// This file is auto-generated by `rails rhino:model_types_export`.
// Do not edit by hand.
//
// One definition per resource: `meta` and `querySurface` are the values the
// client reads at runtime, `attributes`, `read`, `create` and `update` are
// the payload shapes the API exchanges.

export type RhinoIdentifier = string | number;

// Stamped onto every rendered record, and onto records alone — a reference
// nested inside one does not carry it.
//
// A type alias rather than an interface: TypeScript gives an implicit index
// signature to the first and not the second, and a payload that lacks one
// cannot be passed where a RhinoRecord is expected.
export type RhinoRecordBase = {
  readonly _permissions: { readonly update: boolean; readonly destroy: boolean };
};

export const models = {
  account: {
    meta: {
      model: 'account',
      modelPlural: 'accounts',
      name: 'account',
      pluralName: 'accounts',
      readableName: 'Account',
      pluralReadableName: 'Accounts',
      ownedBy: 'global',
      singular: true,
      path: '/api/account',
      searchable: false,
      kind: 'core'
    },
    properties: {
      id: {
        readOnly: true,
        nullable: false,
        type: 'integer',
        format: 'identifier',
        name: 'id',
        readableName: 'Id',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      name: {
        nullable: true,
        type: 'string',
        name: 'name',
        readableName: 'Name',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      nickname: {
        nullable: true,
        type: 'string',
        name: 'nickname',
        readableName: 'Nickname',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      email: {
        nullable: false,
        type: 'string',
        pattern: '^[^@\\s]+@[^@\\s]+$',
        name: 'email',
        readableName: 'Email',
        readable: true,
        creatable: true,
        updatable: false,
        required: true
      },
      image: {
        readOnly: true,
        nullable: true,
        type: 'string',
        name: 'image',
        readableName: 'Image',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      users_roles: {
        readOnly: true,
        nullable: true,
        type: 'array',
        items: {
          type: 'reference',
          anyOf: [{
            $ref: '#/components/schemas/users_role'
          }],
          'x-rhino-attribute-array': {}
        },
        name: 'users_roles',
        readableName: 'Users Roles',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      display_name: {
        readOnly: true,
        nullable: true,
        type: 'string',
        name: 'display_name',
        readableName: 'Account',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      }
    },
    querySurface: {
      filterable: {
        id: {
          type: 'integer',
          format: 'identifier',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        name: {
          type: 'string',
          operators: ['eq', 'diff', 'is_null']
        },
        nickname: {
          type: 'string',
          operators: ['eq', 'diff', 'is_null']
        },
        email: {
          type: 'string',
          operators: ['eq', 'diff', 'is_null']
        },
        image: {
          type: 'string',
          operators: ['eq', 'diff', 'is_null']
        },
        users_roles: {
          type: 'reference',
          model: 'users_role',
          many: true,
          identifier: 'id',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        }
      },
      orderable: ['id', 'name', 'nickname', 'email', 'image'],
      traversable: false,
      searchable: false,
      pagination: {
        defaultLimit: 20,
        maxLimit: 100
      }
    }
  },
  active_storage_attachment: {
    meta: {
      model: 'active_storage_attachment',
      modelPlural: 'active_storage_attachments',
      name: 'activeStorageAttachment',
      pluralName: 'activeStorageAttachments',
      readableName: 'Attachment',
      pluralReadableName: 'Attachments',
      ownedBy: null,
      singular: false,
      path: '/api/attachments',
      searchable: false,
      kind: 'app'
    },
    properties: {
      id: {
        readOnly: true,
        nullable: false,
        type: 'integer',
        format: 'identifier',
        name: 'id',
        readableName: 'Id',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      name: {
        nullable: false,
        type: 'string',
        name: 'name',
        readableName: 'Name',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      previews: {
        nullable: true,
        default: {},
        type: 'json',
        name: 'previews',
        readableName: 'Previews',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      record_type: {
        nullable: false,
        type: 'string',
        name: 'record_type',
        readableName: 'Record Type',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      representations: {
        nullable: true,
        default: {},
        type: 'json',
        name: 'representations',
        readableName: 'Representations',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      url: {
        nullable: true,
        name: 'url',
        readableName: 'Url',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      url_attachment: {
        nullable: true,
        name: 'url_attachment',
        readableName: 'Url Attachment',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      variants: {
        nullable: true,
        default: {},
        type: 'json',
        name: 'variants',
        readableName: 'Variants',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      created_at: {
        readOnly: true,
        nullable: false,
        type: 'string',
        format: 'datetime',
        name: 'created_at',
        readableName: 'Created At',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      signed_id: {
        readOnly: true,
        nullable: true,
        type: 'unknown',
        name: 'signed_id',
        readableName: 'Signed',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      display_name: {
        readOnly: true,
        nullable: true,
        type: 'string',
        name: 'display_name',
        readableName: 'Attachment',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      }
    },
    querySurface: {
      filterable: {
        id: {
          type: 'integer',
          format: 'identifier',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        name: {
          type: 'string',
          operators: ['eq', 'diff']
        },
        record_type: {
          type: 'string',
          operators: ['eq', 'diff']
        },
        created_at: {
          type: 'string',
          format: 'datetime',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        }
      },
      orderable: ['id', 'name', 'record_type', 'created_at'],
      traversable: false,
      searchable: false,
      pagination: {
        defaultLimit: 20,
        maxLimit: 100
      }
    }
  },
  contact: {
    meta: {
      model: 'contact',
      modelPlural: 'contacts',
      name: 'contact',
      pluralName: 'contacts',
      readableName: 'Contact',
      pluralReadableName: 'Contacts',
      ownedBy: 'player',
      singular: false,
      path: '/api/contacts',
      searchable: false,
      kind: 'app'
    },
    properties: {
      id: {
        readOnly: true,
        nullable: false,
        type: 'integer',
        format: 'identifier',
        name: 'id',
        readableName: 'Id',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      email: {
        nullable: true,
        type: 'string',
        pattern: '^[a-zA-Z0-9.!#$%&\'*+\\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$',
        name: 'email',
        readableName: 'Email',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      name: {
        nullable: true,
        type: 'string',
        name: 'name',
        readableName: 'Name',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      note: {
        nullable: true,
        type: 'text',
        name: 'note',
        readableName: 'Note',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      phone: {
        nullable: true,
        type: 'string',
        format: 'phone',
        name: 'phone',
        readableName: 'Phone',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      player_contact: {
        nullable: false,
        default: false,
        type: 'boolean',
        name: 'player_contact',
        readableName: 'Player Contact',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      primary: {
        nullable: false,
        default: true,
        type: 'boolean',
        name: 'primary',
        readableName: 'Primary',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      relationship: {
        nullable: false,
        type: 'string',
        not: {
          enum: ['Player']
        },
        name: 'relationship',
        readableName: 'Relationship',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      player: {
        nullable: false,
        type: 'reference',
        anyOf: [{
          $ref: '#/components/schemas/player'
        }],
        name: 'player',
        readableName: 'Player',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      created_at: {
        readOnly: true,
        nullable: false,
        type: 'string',
        format: 'datetime',
        name: 'created_at',
        readableName: 'Created At',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      updated_at: {
        readOnly: true,
        nullable: false,
        type: 'string',
        format: 'datetime',
        name: 'updated_at',
        readableName: 'Updated At',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      display_name: {
        readOnly: true,
        nullable: true,
        type: 'string',
        name: 'display_name',
        readableName: 'Contact',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      }
    },
    querySurface: {
      filterable: {
        id: {
          type: 'integer',
          format: 'identifier',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        email: {
          type: 'string',
          operators: ['eq', 'diff', 'is_null']
        },
        name: {
          type: 'string',
          operators: ['eq', 'diff', 'is_null']
        },
        note: {
          type: 'text',
          operators: ['eq', 'diff', 'is_null']
        },
        phone: {
          type: 'string',
          operators: ['eq', 'diff', 'is_null']
        },
        player_contact: {
          type: 'boolean',
          operators: ['eq', 'diff']
        },
        primary: {
          type: 'boolean',
          operators: ['eq', 'diff']
        },
        relationship: {
          type: 'string',
          operators: ['eq', 'diff']
        },
        created_at: {
          type: 'string',
          format: 'datetime',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        updated_at: {
          type: 'string',
          format: 'datetime',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        player: {
          type: 'reference',
          model: 'player',
          many: false,
          identifier: 'id',
          foreignKey: 'player_id',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        }
      },
      orderable: ['id', 'email', 'name', 'note', 'phone', 'player_contact', 'primary', 'relationship', 'created_at', 'updated_at', 'player.id', 'player.country', 'player.dob_year', 'player.first_name', 'player.grad_year', 'player.hand', 'player.height_feet', 'player.height_inches', 'player.hometown', 'player.last_name', 'player.number', 'player.quick_rating', 'player.weight_lbs', 'player.created_at', 'player.updated_at', 'player.organization.id', 'player.organization.name', 'player.organization.created_at', 'player.organization.updated_at', 'player.player_positions.id', 'player.player_positions.created_at', 'player.player_positions.updated_at', 'player.positions.id', 'player.positions.abbreviation', 'player.positions.ancestry', 'player.positions.name', 'player.positions.created_at', 'player.positions.updated_at', 'player.rosters.id', 'player.rosters.number', 'player.rosters.quick_rating', 'player.rosters.rank', 'player.rosters.created_at', 'player.rosters.updated_at', 'player.current_roster.id', 'player.current_roster.number', 'player.current_roster.quick_rating', 'player.current_roster.rank', 'player.current_roster.created_at', 'player.current_roster.updated_at', 'player.external_linked_teams.id', 'player.external_linked_teams.team_name', 'player.external_linked_teams.created_at', 'player.external_linked_teams.updated_at'],
      traversable: true,
      searchable: false,
      pagination: {
        defaultLimit: 20,
        maxLimit: 100
      }
    }
  },
  event: {
    meta: {
      model: 'event',
      modelPlural: 'events',
      name: 'event',
      pluralName: 'events',
      readableName: 'Event',
      pluralReadableName: 'Events',
      ownedBy: 'player',
      singular: false,
      path: '/api/events',
      searchable: true,
      kind: 'app'
    },
    properties: {
      id: {
        readOnly: true,
        nullable: false,
        type: 'integer',
        format: 'identifier',
        name: 'id',
        readableName: 'Id',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      action_link: {
        nullable: true,
        type: 'string',
        name: 'action_link',
        readableName: 'Action Link',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      action_name: {
        nullable: true,
        type: 'string',
        name: 'action_name',
        readableName: 'Action Name',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      description: {
        nullable: true,
        type: 'text',
        name: 'description',
        readableName: 'Description',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      key: {
        nullable: false,
        type: 'string',
        name: 'key',
        readableName: 'Key',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      metadata: {
        nullable: true,
        type: 'jsonb',
        name: 'metadata',
        readableName: 'Metadata',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      name: {
        nullable: false,
        type: 'string',
        name: 'name',
        readableName: 'Name',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      summary: {
        nullable: false,
        type: 'string',
        name: 'summary',
        readableName: 'Summary',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      initiator: {
        nullable: false,
        type: 'reference',
        anyOf: [{
          $ref: '#/components/schemas/user'
        }],
        name: 'initiator',
        readableName: 'Initiator',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      player: {
        nullable: false,
        type: 'reference',
        anyOf: [{
          $ref: '#/components/schemas/player'
        }],
        name: 'player',
        readableName: 'Player',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      created_at: {
        readOnly: true,
        nullable: false,
        type: 'string',
        format: 'datetime',
        name: 'created_at',
        readableName: 'Created At',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      updated_at: {
        readOnly: true,
        nullable: false,
        type: 'string',
        format: 'datetime',
        name: 'updated_at',
        readableName: 'Updated At',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      display_name: {
        readOnly: true,
        nullable: true,
        type: 'string',
        name: 'display_name',
        readableName: 'Event',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      }
    },
    querySurface: {
      filterable: {
        id: {
          type: 'integer',
          format: 'identifier',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        action_link: {
          type: 'string',
          operators: ['eq', 'diff', 'is_null']
        },
        action_name: {
          type: 'string',
          operators: ['eq', 'diff', 'is_null']
        },
        description: {
          type: 'text',
          operators: ['eq', 'diff', 'is_null']
        },
        key: {
          type: 'string',
          operators: ['eq', 'diff']
        },
        metadata: {
          type: 'jsonb',
          operators: ['eq', 'diff', 'is_null']
        },
        name: {
          type: 'string',
          operators: ['eq', 'diff']
        },
        summary: {
          type: 'string',
          operators: ['eq', 'diff']
        },
        created_at: {
          type: 'string',
          format: 'datetime',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        updated_at: {
          type: 'string',
          format: 'datetime',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        initiator: {
          type: 'reference',
          model: 'user',
          many: false,
          identifier: 'id',
          foreignKey: 'initiator_id',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        player: {
          type: 'reference',
          model: 'player',
          many: false,
          identifier: 'id',
          foreignKey: 'player_id',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        }
      },
      orderable: ['id', 'action_link', 'action_name', 'description', 'key', 'metadata', 'name', 'summary', 'created_at', 'updated_at', 'initiator.id', 'initiator.name', 'initiator.nickname', 'initiator.email', 'initiator.image', 'player.id', 'player.country', 'player.dob_year', 'player.first_name', 'player.grad_year', 'player.hand', 'player.height_feet', 'player.height_inches', 'player.hometown', 'player.last_name', 'player.number', 'player.quick_rating', 'player.weight_lbs', 'player.created_at', 'player.updated_at', 'player.organization.id', 'player.organization.name', 'player.organization.created_at', 'player.organization.updated_at', 'player.player_positions.id', 'player.player_positions.created_at', 'player.player_positions.updated_at', 'player.positions.id', 'player.positions.abbreviation', 'player.positions.ancestry', 'player.positions.name', 'player.positions.created_at', 'player.positions.updated_at', 'player.rosters.id', 'player.rosters.number', 'player.rosters.quick_rating', 'player.rosters.rank', 'player.rosters.created_at', 'player.rosters.updated_at', 'player.current_roster.id', 'player.current_roster.number', 'player.current_roster.quick_rating', 'player.current_roster.rank', 'player.current_roster.created_at', 'player.current_roster.updated_at', 'player.external_linked_teams.id', 'player.external_linked_teams.team_name', 'player.external_linked_teams.created_at', 'player.external_linked_teams.updated_at'],
      traversable: true,
      searchable: true,
      pagination: {
        defaultLimit: 20,
        maxLimit: 100
      }
    }
  },
  external_game: {
    meta: {
      model: 'external_game',
      modelPlural: 'external_games',
      name: 'externalGame',
      pluralName: 'externalGames',
      readableName: 'External game',
      pluralReadableName: 'External games',
      ownedBy: 'external_team_season',
      singular: false,
      path: '/api/external_games',
      searchable: false,
      kind: 'app'
    },
    properties: {
      id: {
        readOnly: true,
        nullable: false,
        type: 'integer',
        format: 'identifier',
        name: 'id',
        readableName: 'Id',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      date_time: {
        nullable: true,
        type: 'string',
        format: 'datetime',
        name: 'date_time',
        readableName: 'Date Time',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      location_type: {
        nullable: false,
        type: 'string',
        enum: ['unknown', 'home', 'away', 'neutral'],
        name: 'location_type',
        readableName: 'Location Type',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      external_team_season: {
        nullable: false,
        type: 'reference',
        anyOf: [{
          $ref: '#/components/schemas/external_team_season'
        }],
        name: 'external_team_season',
        readableName: 'External Team Season',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      created_at: {
        readOnly: true,
        nullable: false,
        type: 'string',
        format: 'datetime',
        name: 'created_at',
        readableName: 'Created At',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      updated_at: {
        readOnly: true,
        nullable: false,
        type: 'string',
        format: 'datetime',
        name: 'updated_at',
        readableName: 'Updated At',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      display_name: {
        readOnly: true,
        nullable: true,
        type: 'string',
        name: 'display_name',
        readableName: 'External game',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      }
    },
    querySurface: {
      filterable: {
        id: {
          type: 'integer',
          format: 'identifier',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        date_time: {
          type: 'string',
          format: 'datetime',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff', 'eq_coalesce', 'gteq_coalesce', 'lteq_coalesce', 'is_null']
        },
        location_type: {
          type: 'string',
          operators: ['eq', 'diff']
        },
        created_at: {
          type: 'string',
          format: 'datetime',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        updated_at: {
          type: 'string',
          format: 'datetime',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        external_team_season: {
          type: 'reference',
          model: 'external_team_season',
          many: false,
          identifier: 'id',
          foreignKey: 'external_team_season_id',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        }
      },
      orderable: ['id', 'date_time', 'location_type', 'created_at', 'updated_at', 'external_team_season.id', 'external_team_season.created_at', 'external_team_season.updated_at', 'external_team_season.external_league.id', 'external_team_season.external_league.ancestry', 'external_team_season.external_league.description', 'external_team_season.external_league.import_key', 'external_team_season.external_league.name', 'external_team_season.external_league.created_at', 'external_team_season.external_league.updated_at', 'external_team_season.external_team.id', 'external_team_season.external_team.import_key', 'external_team_season.external_team.name', 'external_team_season.external_team.created_at', 'external_team_season.external_team.updated_at', 'external_team_season.season.id', 'external_team_season.season.name', 'external_team_season.season.starts_on', 'external_team_season.season.created_at', 'external_team_season.season.updated_at'],
      traversable: false,
      searchable: false,
      pagination: {
        defaultLimit: 20,
        maxLimit: 100
      }
    }
  },
  external_league: {
    meta: {
      model: 'external_league',
      modelPlural: 'external_leagues',
      name: 'externalLeague',
      pluralName: 'externalLeagues',
      readableName: 'External league',
      pluralReadableName: 'External leagues',
      ownedBy: 'sport',
      singular: false,
      path: '/api/external_leagues',
      searchable: false,
      kind: 'app'
    },
    properties: {
      id: {
        readOnly: true,
        nullable: false,
        type: 'integer',
        format: 'identifier',
        name: 'id',
        readableName: 'Id',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      ancestry: {
        nullable: true,
        type: 'string',
        pattern: '^[0-9]+(\\/[0-9]+)*(?=\\n?$)',
        name: 'ancestry',
        readableName: 'Ancestry',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      description: {
        nullable: true,
        type: 'text',
        name: 'description',
        readableName: 'Description',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      import_key: {
        nullable: true,
        type: 'string',
        name: 'import_key',
        readableName: 'Import Key',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      name: {
        nullable: true,
        type: 'string',
        name: 'name',
        readableName: 'Name',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      sport: {
        nullable: false,
        type: 'reference',
        anyOf: [{
          $ref: '#/components/schemas/sport'
        }],
        name: 'sport',
        readableName: 'Sport',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      created_at: {
        readOnly: true,
        nullable: false,
        type: 'string',
        format: 'datetime',
        name: 'created_at',
        readableName: 'Created At',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      updated_at: {
        readOnly: true,
        nullable: false,
        type: 'string',
        format: 'datetime',
        name: 'updated_at',
        readableName: 'Updated At',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      display_name: {
        readOnly: true,
        nullable: true,
        type: 'string',
        name: 'display_name',
        readableName: 'External league',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      }
    },
    querySurface: {
      filterable: {
        id: {
          type: 'integer',
          format: 'identifier',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff', 'tree_subtree']
        },
        ancestry: {
          type: 'string',
          operators: ['eq', 'diff', 'is_null']
        },
        description: {
          type: 'text',
          operators: ['eq', 'diff', 'is_null']
        },
        import_key: {
          type: 'string',
          operators: ['eq', 'diff', 'is_null']
        },
        name: {
          type: 'string',
          operators: ['eq', 'diff', 'is_null']
        },
        created_at: {
          type: 'string',
          format: 'datetime',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        updated_at: {
          type: 'string',
          format: 'datetime',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        sport: {
          type: 'reference',
          model: 'sport',
          many: false,
          identifier: 'id',
          foreignKey: 'sport_id',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        }
      },
      orderable: ['id', 'ancestry', 'description', 'import_key', 'name', 'created_at', 'updated_at', 'sport.id', 'sport.name', 'sport.created_at', 'sport.updated_at'],
      traversable: false,
      searchable: false,
      pagination: {
        defaultLimit: 20,
        maxLimit: 100
      }
    }
  },
  external_linked_team: {
    meta: {
      model: 'external_linked_team',
      modelPlural: 'external_linked_teams',
      name: 'externalLinkedTeam',
      pluralName: 'externalLinkedTeams',
      readableName: 'External linked team',
      pluralReadableName: 'External linked teams',
      ownedBy: 'player',
      singular: false,
      path: '/api/external_linked_teams',
      searchable: false,
      kind: 'app'
    },
    properties: {
      id: {
        readOnly: true,
        nullable: false,
        type: 'integer',
        format: 'identifier',
        name: 'id',
        readableName: 'Id',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      team_name: {
        nullable: true,
        type: 'string',
        name: 'team_name',
        readableName: 'Team Name',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      external_team_season: {
        nullable: true,
        type: 'reference',
        anyOf: [{
          $ref: '#/components/schemas/external_team_season'
        }],
        name: 'external_team_season',
        readableName: 'External Team Season',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      external_team: {
        nullable: true,
        type: 'reference',
        anyOf: [{
          $ref: '#/components/schemas/external_team'
        }],
        name: 'external_team',
        readableName: 'External Team',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      season: {
        nullable: true,
        type: 'reference',
        anyOf: [{
          $ref: '#/components/schemas/season'
        }],
        name: 'season',
        readableName: 'Season',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      player: {
        nullable: false,
        type: 'reference',
        anyOf: [{
          $ref: '#/components/schemas/player'
        }],
        name: 'player',
        readableName: 'Player',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      created_at: {
        readOnly: true,
        nullable: false,
        type: 'string',
        format: 'datetime',
        name: 'created_at',
        readableName: 'Created At',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      updated_at: {
        readOnly: true,
        nullable: false,
        type: 'string',
        format: 'datetime',
        name: 'updated_at',
        readableName: 'Updated At',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      display_name: {
        readOnly: true,
        nullable: true,
        type: 'string',
        name: 'display_name',
        readableName: 'External linked team',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      }
    },
    querySurface: {
      filterable: {
        id: {
          type: 'integer',
          format: 'identifier',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        team_name: {
          type: 'string',
          operators: ['eq', 'diff', 'is_null']
        },
        created_at: {
          type: 'string',
          format: 'datetime',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        updated_at: {
          type: 'string',
          format: 'datetime',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        external_team_season: {
          type: 'reference',
          model: 'external_team_season',
          many: false,
          identifier: 'id',
          foreignKey: 'external_team_season_id',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        external_team: {
          type: 'reference',
          model: 'external_team',
          many: false,
          identifier: 'id',
          foreignKey: 'external_team_id',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        season: {
          type: 'reference',
          model: 'season',
          many: false,
          identifier: 'id',
          foreignKey: 'season_id',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        player: {
          type: 'reference',
          model: 'player',
          many: false,
          identifier: 'id',
          foreignKey: 'player_id',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        }
      },
      orderable: ['id', 'team_name', 'created_at', 'updated_at', 'external_team_season.id', 'external_team_season.created_at', 'external_team_season.updated_at', 'external_team_season.external_league.id', 'external_team_season.external_league.ancestry', 'external_team_season.external_league.description', 'external_team_season.external_league.import_key', 'external_team_season.external_league.name', 'external_team_season.external_league.created_at', 'external_team_season.external_league.updated_at', 'external_team_season.external_team.id', 'external_team_season.external_team.import_key', 'external_team_season.external_team.name', 'external_team_season.external_team.created_at', 'external_team_season.external_team.updated_at', 'external_team_season.season.id', 'external_team_season.season.name', 'external_team_season.season.starts_on', 'external_team_season.season.created_at', 'external_team_season.season.updated_at', 'external_team.id', 'external_team.import_key', 'external_team.name', 'external_team.created_at', 'external_team.updated_at', 'external_team.external_team_seasons.id', 'external_team.external_team_seasons.created_at', 'external_team.external_team_seasons.updated_at', 'season.id', 'season.name', 'season.starts_on', 'season.created_at', 'season.updated_at', 'season.sport.id', 'season.sport.name', 'season.sport.created_at', 'season.sport.updated_at', 'player.id', 'player.country', 'player.dob_year', 'player.first_name', 'player.grad_year', 'player.hand', 'player.height_feet', 'player.height_inches', 'player.hometown', 'player.last_name', 'player.number', 'player.quick_rating', 'player.weight_lbs', 'player.created_at', 'player.updated_at', 'player.organization.id', 'player.organization.name', 'player.organization.created_at', 'player.organization.updated_at', 'player.player_positions.id', 'player.player_positions.created_at', 'player.player_positions.updated_at', 'player.positions.id', 'player.positions.abbreviation', 'player.positions.ancestry', 'player.positions.name', 'player.positions.created_at', 'player.positions.updated_at', 'player.rosters.id', 'player.rosters.number', 'player.rosters.quick_rating', 'player.rosters.rank', 'player.rosters.created_at', 'player.rosters.updated_at', 'player.current_roster.id', 'player.current_roster.number', 'player.current_roster.quick_rating', 'player.current_roster.rank', 'player.current_roster.created_at', 'player.current_roster.updated_at', 'player.external_linked_teams.id', 'player.external_linked_teams.team_name', 'player.external_linked_teams.created_at', 'player.external_linked_teams.updated_at'],
      traversable: true,
      searchable: false,
      pagination: {
        defaultLimit: 20,
        maxLimit: 100
      }
    }
  },
  external_player: {
    meta: {
      model: 'external_player',
      modelPlural: 'external_players',
      name: 'externalPlayer',
      pluralName: 'externalPlayers',
      readableName: 'External player',
      pluralReadableName: 'External players',
      ownedBy: 'global',
      singular: false,
      path: '/api/external_players',
      searchable: true,
      kind: 'app'
    },
    properties: {
      id: {
        readOnly: true,
        nullable: false,
        type: 'integer',
        format: 'identifier',
        name: 'id',
        readableName: 'Id',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      commitment: {
        nullable: true,
        type: 'string',
        name: 'commitment',
        readableName: 'Commitment',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      country: {
        nullable: true,
        type: 'string',
        format: 'country',
        name: 'country',
        readableName: 'Country',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      dob_year: {
        nullable: true,
        type: 'integer',
        minimum: 1986,
        maximum: 2021,
        format: 'year',
        name: 'dob_year',
        readableName: 'Dob Year',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      first_name: {
        nullable: false,
        type: 'string',
        name: 'first_name',
        readableName: 'First Name',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      grad_year: {
        nullable: true,
        type: 'integer',
        minimum: 1986,
        maximum: 2036,
        format: 'year',
        name: 'grad_year',
        readableName: 'Grad Year',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      hand: {
        nullable: true,
        type: 'string',
        minLength: 1,
        maxLength: 1,
        enum: ['L', 'R'],
        name: 'hand',
        readableName: 'Hand',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      height_feet: {
        nullable: true,
        type: 'integer',
        name: 'height_feet',
        readableName: 'Height Feet',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      height_inches: {
        nullable: true,
        type: 'string',
        name: 'height_inches',
        readableName: 'Height Inches',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      hometown: {
        nullable: true,
        type: 'string',
        name: 'hometown',
        readableName: 'Hometown',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      import_key: {
        nullable: true,
        type: 'string',
        name: 'import_key',
        readableName: 'Import Key',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      last_name: {
        nullable: false,
        type: 'string',
        name: 'last_name',
        readableName: 'Last Name',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      number: {
        nullable: true,
        type: 'string',
        pattern: '^\\d*$',
        maxLength: 3,
        name: 'number',
        readableName: 'Number',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      weight_lbs: {
        nullable: true,
        type: 'integer',
        name: 'weight_lbs',
        readableName: 'Weight Lbs',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      external_rosters: {
        readOnly: true,
        nullable: true,
        type: 'array',
        items: {
          type: 'reference',
          anyOf: [{
            $ref: '#/components/schemas/external_roster'
          }],
          'x-rhino-attribute-array': {}
        },
        name: 'external_rosters',
        readableName: 'External Rosters',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      position: {
        nullable: true,
        type: 'reference',
        anyOf: [{
          $ref: '#/components/schemas/position'
        }],
        name: 'position',
        readableName: 'Position',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      created_at: {
        readOnly: true,
        nullable: false,
        type: 'string',
        format: 'datetime',
        name: 'created_at',
        readableName: 'Created At',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      updated_at: {
        readOnly: true,
        nullable: false,
        type: 'string',
        format: 'datetime',
        name: 'updated_at',
        readableName: 'Updated At',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      display_name: {
        readOnly: true,
        nullable: true,
        type: 'string',
        name: 'display_name',
        readableName: 'External player',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      }
    },
    querySurface: {
      filterable: {
        id: {
          type: 'integer',
          format: 'identifier',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        commitment: {
          type: 'string',
          operators: ['eq', 'diff', 'is_null']
        },
        country: {
          type: 'string',
          operators: ['eq', 'diff', 'is_null']
        },
        dob_year: {
          type: 'integer',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff', 'eq_coalesce', 'gteq_coalesce', 'lteq_coalesce', 'is_null']
        },
        first_name: {
          type: 'string',
          operators: ['eq', 'diff']
        },
        grad_year: {
          type: 'integer',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff', 'eq_coalesce', 'gteq_coalesce', 'lteq_coalesce', 'is_null']
        },
        hand: {
          type: 'string',
          operators: ['eq', 'diff', 'is_null']
        },
        height_feet: {
          type: 'integer',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff', 'eq_coalesce', 'gteq_coalesce', 'lteq_coalesce', 'is_null']
        },
        height_inches: {
          type: 'string',
          operators: ['eq', 'diff', 'is_null']
        },
        hometown: {
          type: 'string',
          operators: ['eq', 'diff', 'is_null']
        },
        import_key: {
          type: 'string',
          operators: ['eq', 'diff', 'is_null']
        },
        last_name: {
          type: 'string',
          operators: ['eq', 'diff']
        },
        number: {
          type: 'string',
          operators: ['eq', 'diff', 'is_null']
        },
        weight_lbs: {
          type: 'integer',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff', 'eq_coalesce', 'gteq_coalesce', 'lteq_coalesce', 'is_null']
        },
        created_at: {
          type: 'string',
          format: 'datetime',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        updated_at: {
          type: 'string',
          format: 'datetime',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        external_rosters: {
          type: 'reference',
          model: 'external_roster',
          many: true,
          identifier: 'id',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        position: {
          type: 'reference',
          model: 'position',
          many: false,
          identifier: 'id',
          foreignKey: 'position_id',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff', 'tree_subtree']
        }
      },
      orderable: ['id', 'commitment', 'country', 'dob_year', 'first_name', 'grad_year', 'hand', 'height_feet', 'height_inches', 'hometown', 'import_key', 'last_name', 'number', 'weight_lbs', 'created_at', 'updated_at', 'external_rosters.id', 'external_rosters.created_at', 'external_rosters.updated_at', 'external_rosters.external_team_season.id', 'external_rosters.external_team_season.created_at', 'external_rosters.external_team_season.updated_at', 'external_rosters.external_player.id', 'external_rosters.external_player.commitment', 'external_rosters.external_player.country', 'external_rosters.external_player.dob_year', 'external_rosters.external_player.first_name', 'external_rosters.external_player.grad_year', 'external_rosters.external_player.hand', 'external_rosters.external_player.height_feet', 'external_rosters.external_player.height_inches', 'external_rosters.external_player.hometown', 'external_rosters.external_player.import_key', 'external_rosters.external_player.last_name', 'external_rosters.external_player.number', 'external_rosters.external_player.weight_lbs', 'external_rosters.external_player.created_at', 'external_rosters.external_player.updated_at', 'position.id', 'position.abbreviation', 'position.ancestry', 'position.name', 'position.created_at', 'position.updated_at', 'position.sport.id', 'position.sport.name', 'position.sport.created_at', 'position.sport.updated_at'],
      traversable: false,
      searchable: true,
      pagination: {
        defaultLimit: 20,
        maxLimit: 100
      }
    }
  },
  external_roster: {
    meta: {
      model: 'external_roster',
      modelPlural: 'external_rosters',
      name: 'externalRoster',
      pluralName: 'externalRosters',
      readableName: 'External roster',
      pluralReadableName: 'External rosters',
      ownedBy: 'external_team_season',
      singular: false,
      path: '/api/external_rosters',
      searchable: false,
      kind: 'app'
    },
    properties: {
      id: {
        readOnly: true,
        nullable: false,
        type: 'integer',
        format: 'identifier',
        name: 'id',
        readableName: 'Id',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      external_team_season: {
        nullable: false,
        type: 'reference',
        anyOf: [{
          $ref: '#/components/schemas/external_team_season'
        }],
        name: 'external_team_season',
        readableName: 'External Team Season',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      external_player: {
        nullable: false,
        type: 'reference',
        anyOf: [{
          $ref: '#/components/schemas/external_player'
        }],
        name: 'external_player',
        readableName: 'External Player',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      created_at: {
        readOnly: true,
        nullable: false,
        type: 'string',
        format: 'datetime',
        name: 'created_at',
        readableName: 'Created At',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      updated_at: {
        readOnly: true,
        nullable: false,
        type: 'string',
        format: 'datetime',
        name: 'updated_at',
        readableName: 'Updated At',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      display_name: {
        readOnly: true,
        nullable: true,
        type: 'string',
        name: 'display_name',
        readableName: 'External roster',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      }
    },
    querySurface: {
      filterable: {
        id: {
          type: 'integer',
          format: 'identifier',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        created_at: {
          type: 'string',
          format: 'datetime',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        updated_at: {
          type: 'string',
          format: 'datetime',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        external_team_season: {
          type: 'reference',
          model: 'external_team_season',
          many: false,
          identifier: 'id',
          foreignKey: 'external_team_season_id',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        external_player: {
          type: 'reference',
          model: 'external_player',
          many: false,
          identifier: 'id',
          foreignKey: 'external_player_id',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        }
      },
      orderable: ['id', 'created_at', 'updated_at', 'external_team_season.id', 'external_team_season.created_at', 'external_team_season.updated_at', 'external_team_season.external_league.id', 'external_team_season.external_league.ancestry', 'external_team_season.external_league.description', 'external_team_season.external_league.import_key', 'external_team_season.external_league.name', 'external_team_season.external_league.created_at', 'external_team_season.external_league.updated_at', 'external_team_season.external_team.id', 'external_team_season.external_team.import_key', 'external_team_season.external_team.name', 'external_team_season.external_team.created_at', 'external_team_season.external_team.updated_at', 'external_team_season.season.id', 'external_team_season.season.name', 'external_team_season.season.starts_on', 'external_team_season.season.created_at', 'external_team_season.season.updated_at', 'external_player.id', 'external_player.commitment', 'external_player.country', 'external_player.dob_year', 'external_player.first_name', 'external_player.grad_year', 'external_player.hand', 'external_player.height_feet', 'external_player.height_inches', 'external_player.hometown', 'external_player.import_key', 'external_player.last_name', 'external_player.number', 'external_player.weight_lbs', 'external_player.created_at', 'external_player.updated_at', 'external_player.external_rosters.id', 'external_player.external_rosters.created_at', 'external_player.external_rosters.updated_at', 'external_player.position.id', 'external_player.position.abbreviation', 'external_player.position.ancestry', 'external_player.position.name', 'external_player.position.created_at', 'external_player.position.updated_at'],
      traversable: false,
      searchable: false,
      pagination: {
        defaultLimit: 20,
        maxLimit: 100
      }
    }
  },
  external_team: {
    meta: {
      model: 'external_team',
      modelPlural: 'external_teams',
      name: 'externalTeam',
      pluralName: 'externalTeams',
      readableName: 'External team',
      pluralReadableName: 'External teams',
      ownedBy: 'global',
      singular: false,
      path: '/api/external_teams',
      searchable: true,
      kind: 'app'
    },
    properties: {
      id: {
        readOnly: true,
        nullable: false,
        type: 'integer',
        format: 'identifier',
        name: 'id',
        readableName: 'Id',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      import_key: {
        nullable: true,
        type: 'string',
        name: 'import_key',
        readableName: 'Import Key',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      name: {
        nullable: true,
        type: 'string',
        name: 'name',
        readableName: 'Name',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      external_team_seasons: {
        readOnly: true,
        nullable: true,
        type: 'array',
        items: {
          type: 'reference',
          anyOf: [{
            $ref: '#/components/schemas/external_team_season'
          }],
          'x-rhino-attribute-array': {}
        },
        name: 'external_team_seasons',
        readableName: 'External Team Seasons',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      created_at: {
        readOnly: true,
        nullable: false,
        type: 'string',
        format: 'datetime',
        name: 'created_at',
        readableName: 'Created At',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      updated_at: {
        readOnly: true,
        nullable: false,
        type: 'string',
        format: 'datetime',
        name: 'updated_at',
        readableName: 'Updated At',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      display_name: {
        readOnly: true,
        nullable: true,
        type: 'string',
        name: 'display_name',
        readableName: 'External team',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      }
    },
    querySurface: {
      filterable: {
        id: {
          type: 'integer',
          format: 'identifier',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        import_key: {
          type: 'string',
          operators: ['eq', 'diff', 'is_null']
        },
        name: {
          type: 'string',
          operators: ['eq', 'diff', 'is_null']
        },
        created_at: {
          type: 'string',
          format: 'datetime',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        updated_at: {
          type: 'string',
          format: 'datetime',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        external_team_seasons: {
          type: 'reference',
          model: 'external_team_season',
          many: true,
          identifier: 'id',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        }
      },
      orderable: ['id', 'import_key', 'name', 'created_at', 'updated_at', 'external_team_seasons.id', 'external_team_seasons.created_at', 'external_team_seasons.updated_at', 'external_team_seasons.external_league.id', 'external_team_seasons.external_league.ancestry', 'external_team_seasons.external_league.description', 'external_team_seasons.external_league.import_key', 'external_team_seasons.external_league.name', 'external_team_seasons.external_league.created_at', 'external_team_seasons.external_league.updated_at', 'external_team_seasons.external_team.id', 'external_team_seasons.external_team.import_key', 'external_team_seasons.external_team.name', 'external_team_seasons.external_team.created_at', 'external_team_seasons.external_team.updated_at', 'external_team_seasons.season.id', 'external_team_seasons.season.name', 'external_team_seasons.season.starts_on', 'external_team_seasons.season.created_at', 'external_team_seasons.season.updated_at'],
      traversable: false,
      searchable: true,
      pagination: {
        defaultLimit: 20,
        maxLimit: 100
      }
    }
  },
  external_team_season: {
    meta: {
      model: 'external_team_season',
      modelPlural: 'external_team_seasons',
      name: 'externalTeamSeason',
      pluralName: 'externalTeamSeasons',
      readableName: 'External team season',
      pluralReadableName: 'External team seasons',
      ownedBy: 'external_team',
      singular: false,
      path: '/api/external_team_seasons',
      searchable: false,
      kind: 'app'
    },
    properties: {
      id: {
        readOnly: true,
        nullable: false,
        type: 'integer',
        format: 'identifier',
        name: 'id',
        readableName: 'Id',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      external_league: {
        nullable: true,
        type: 'reference',
        anyOf: [{
          $ref: '#/components/schemas/external_league'
        }],
        name: 'external_league',
        readableName: 'External League',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      external_team: {
        nullable: false,
        type: 'reference',
        anyOf: [{
          $ref: '#/components/schemas/external_team'
        }],
        name: 'external_team',
        readableName: 'External Team',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      season: {
        nullable: false,
        type: 'reference',
        anyOf: [{
          $ref: '#/components/schemas/season'
        }],
        name: 'season',
        readableName: 'Season',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      created_at: {
        readOnly: true,
        nullable: false,
        type: 'string',
        format: 'datetime',
        name: 'created_at',
        readableName: 'Created At',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      updated_at: {
        readOnly: true,
        nullable: false,
        type: 'string',
        format: 'datetime',
        name: 'updated_at',
        readableName: 'Updated At',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      display_name: {
        readOnly: true,
        nullable: true,
        type: 'string',
        name: 'display_name',
        readableName: 'External team season',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      }
    },
    querySurface: {
      filterable: {
        id: {
          type: 'integer',
          format: 'identifier',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        created_at: {
          type: 'string',
          format: 'datetime',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        updated_at: {
          type: 'string',
          format: 'datetime',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        external_league: {
          type: 'reference',
          model: 'external_league',
          many: false,
          identifier: 'id',
          foreignKey: 'external_league_id',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff', 'tree_subtree']
        },
        external_team: {
          type: 'reference',
          model: 'external_team',
          many: false,
          identifier: 'id',
          foreignKey: 'external_team_id',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        season: {
          type: 'reference',
          model: 'season',
          many: false,
          identifier: 'id',
          foreignKey: 'season_id',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        }
      },
      orderable: ['id', 'created_at', 'updated_at', 'external_league.id', 'external_league.ancestry', 'external_league.description', 'external_league.import_key', 'external_league.name', 'external_league.created_at', 'external_league.updated_at', 'external_league.sport.id', 'external_league.sport.name', 'external_league.sport.created_at', 'external_league.sport.updated_at', 'external_team.id', 'external_team.import_key', 'external_team.name', 'external_team.created_at', 'external_team.updated_at', 'external_team.external_team_seasons.id', 'external_team.external_team_seasons.created_at', 'external_team.external_team_seasons.updated_at', 'season.id', 'season.name', 'season.starts_on', 'season.created_at', 'season.updated_at', 'season.sport.id', 'season.sport.name', 'season.sport.created_at', 'season.sport.updated_at'],
      traversable: false,
      searchable: false,
      pagination: {
        defaultLimit: 20,
        maxLimit: 100
      }
    }
  },
  lineup: {
    meta: {
      model: 'lineup',
      modelPlural: 'lineups',
      name: 'lineup',
      pluralName: 'lineups',
      readableName: 'Lineup',
      pluralReadableName: 'Lineups',
      ownedBy: 'team_season',
      singular: false,
      path: '/api/lineups',
      searchable: true,
      kind: 'app'
    },
    properties: {
      id: {
        readOnly: true,
        nullable: false,
        type: 'integer',
        format: 'identifier',
        name: 'id',
        readableName: 'Id',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      event_at: {
        nullable: true,
        type: 'string',
        format: 'datetime',
        name: 'event_at',
        readableName: 'Event At',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      kind: {
        nullable: false,
        default: 'event',
        type: 'string',
        enum: ['event', 'depth_chart'],
        name: 'kind',
        readableName: 'Kind',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      name: {
        nullable: false,
        type: 'string',
        name: 'name',
        readableName: 'Name',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      team_season: {
        nullable: false,
        type: 'reference',
        anyOf: [{
          $ref: '#/components/schemas/team_season'
        }],
        name: 'team_season',
        readableName: 'Team Season',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      lineup_spots: {
        readOnly: true,
        nullable: true,
        type: 'array',
        items: {
          type: 'reference',
          anyOf: [{
            $ref: '#/components/schemas/lineup_spot'
          }],
          'x-rhino-attribute-array': {}
        },
        name: 'lineup_spots',
        readableName: 'Lineup Spots',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      lineup_type: {
        nullable: false,
        type: 'reference',
        anyOf: [{
          $ref: '#/components/schemas/lineup_type'
        }],
        name: 'lineup_type',
        readableName: 'Lineup Type',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      created_at: {
        readOnly: true,
        nullable: false,
        type: 'string',
        format: 'datetime',
        name: 'created_at',
        readableName: 'Created At',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      updated_at: {
        readOnly: true,
        nullable: false,
        type: 'string',
        format: 'datetime',
        name: 'updated_at',
        readableName: 'Updated At',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      display_name: {
        readOnly: true,
        nullable: true,
        type: 'string',
        name: 'display_name',
        readableName: 'Lineup',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      }
    },
    querySurface: {
      filterable: {
        id: {
          type: 'integer',
          format: 'identifier',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        event_at: {
          type: 'string',
          format: 'datetime',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff', 'eq_coalesce', 'gteq_coalesce', 'lteq_coalesce', 'is_null']
        },
        kind: {
          type: 'string',
          operators: ['eq', 'diff']
        },
        name: {
          type: 'string',
          operators: ['eq', 'diff']
        },
        created_at: {
          type: 'string',
          format: 'datetime',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        updated_at: {
          type: 'string',
          format: 'datetime',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        team_season: {
          type: 'reference',
          model: 'team_season',
          many: false,
          identifier: 'id',
          foreignKey: 'team_season_id',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        lineup_spots: {
          type: 'reference',
          model: 'lineup_spot',
          many: true,
          identifier: 'id',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        lineup_type: {
          type: 'reference',
          model: 'lineup_type',
          many: false,
          identifier: 'id',
          foreignKey: 'lineup_type_id',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        }
      },
      orderable: ['id', 'event_at', 'kind', 'name', 'created_at', 'updated_at', 'team_season.id', 'team_season.calendar_embed_url', 'team_season.calendar_ics_url', 'team_season.stats', 'team_season.status', 'team_season.created_at', 'team_season.updated_at', 'team_season.season.id', 'team_season.season.name', 'team_season.season.starts_on', 'team_season.season.created_at', 'team_season.season.updated_at', 'team_season.team.id', 'team_season.team.name', 'team_season.team.created_at', 'team_season.team.updated_at', 'lineup_spots.id', 'lineup_spots.group_index', 'lineup_spots.created_at', 'lineup_spots.updated_at', 'lineup_spots.lineup.id', 'lineup_spots.lineup.event_at', 'lineup_spots.lineup.kind', 'lineup_spots.lineup.name', 'lineup_spots.lineup.created_at', 'lineup_spots.lineup.updated_at', 'lineup_spots.lineup_type_group.id', 'lineup_spots.lineup_type_group.ancestry', 'lineup_spots.lineup_type_group.default_count', 'lineup_spots.lineup_type_group.name', 'lineup_spots.lineup_type_group.order', 'lineup_spots.lineup_type_group.created_at', 'lineup_spots.lineup_type_group.updated_at', 'lineup_spots.roster.id', 'lineup_spots.roster.number', 'lineup_spots.roster.quick_rating', 'lineup_spots.roster.rank', 'lineup_spots.roster.created_at', 'lineup_spots.roster.updated_at', 'lineup_type.id', 'lineup_type.name', 'lineup_type.created_at', 'lineup_type.updated_at', 'lineup_type.lineup_type_groups.id', 'lineup_type.lineup_type_groups.ancestry', 'lineup_type.lineup_type_groups.default_count', 'lineup_type.lineup_type_groups.name', 'lineup_type.lineup_type_groups.order', 'lineup_type.lineup_type_groups.created_at', 'lineup_type.lineup_type_groups.updated_at', 'lineup_type.sport.id', 'lineup_type.sport.name', 'lineup_type.sport.created_at', 'lineup_type.sport.updated_at'],
      traversable: true,
      searchable: true,
      pagination: {
        defaultLimit: 20,
        maxLimit: 100
      }
    }
  },
  lineup_spot: {
    meta: {
      model: 'lineup_spot',
      modelPlural: 'lineup_spots',
      name: 'lineupSpot',
      pluralName: 'lineupSpots',
      readableName: 'Lineup spot',
      pluralReadableName: 'Lineup spots',
      ownedBy: 'lineup',
      singular: false,
      path: '/api/lineup_spots',
      searchable: false,
      kind: 'app'
    },
    properties: {
      id: {
        readOnly: true,
        nullable: false,
        type: 'integer',
        format: 'identifier',
        name: 'id',
        readableName: 'Id',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      group_index: {
        nullable: false,
        type: 'string',
        name: 'group_index',
        readableName: 'Group Index',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      lineup: {
        nullable: false,
        type: 'reference',
        anyOf: [{
          $ref: '#/components/schemas/lineup'
        }],
        name: 'lineup',
        readableName: 'Lineup',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      lineup_type_group: {
        nullable: false,
        type: 'reference',
        anyOf: [{
          $ref: '#/components/schemas/lineup_type_group'
        }],
        name: 'lineup_type_group',
        readableName: 'Lineup Type Group',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      roster: {
        nullable: false,
        type: 'reference',
        anyOf: [{
          $ref: '#/components/schemas/roster'
        }],
        name: 'roster',
        readableName: 'Roster',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      created_at: {
        readOnly: true,
        nullable: false,
        type: 'string',
        format: 'datetime',
        name: 'created_at',
        readableName: 'Created At',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      updated_at: {
        readOnly: true,
        nullable: false,
        type: 'string',
        format: 'datetime',
        name: 'updated_at',
        readableName: 'Updated At',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      display_name: {
        readOnly: true,
        nullable: true,
        type: 'string',
        name: 'display_name',
        readableName: 'Lineup spot',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      }
    },
    querySurface: {
      filterable: {
        id: {
          type: 'integer',
          format: 'identifier',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        group_index: {
          type: 'string',
          operators: ['eq', 'diff', 'is_null']
        },
        created_at: {
          type: 'string',
          format: 'datetime',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        updated_at: {
          type: 'string',
          format: 'datetime',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        lineup: {
          type: 'reference',
          model: 'lineup',
          many: false,
          identifier: 'id',
          foreignKey: 'lineup_id',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        lineup_type_group: {
          type: 'reference',
          model: 'lineup_type_group',
          many: false,
          identifier: 'id',
          foreignKey: 'lineup_type_group_id',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff', 'tree_subtree']
        },
        roster: {
          type: 'reference',
          model: 'roster',
          many: false,
          identifier: 'id',
          foreignKey: 'roster_id',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        }
      },
      orderable: ['id', 'group_index', 'created_at', 'updated_at', 'lineup.id', 'lineup.event_at', 'lineup.kind', 'lineup.name', 'lineup.created_at', 'lineup.updated_at', 'lineup.team_season.id', 'lineup.team_season.calendar_embed_url', 'lineup.team_season.calendar_ics_url', 'lineup.team_season.stats', 'lineup.team_season.status', 'lineup.team_season.created_at', 'lineup.team_season.updated_at', 'lineup.lineup_spots.id', 'lineup.lineup_spots.group_index', 'lineup.lineup_spots.created_at', 'lineup.lineup_spots.updated_at', 'lineup.lineup_type.id', 'lineup.lineup_type.name', 'lineup.lineup_type.created_at', 'lineup.lineup_type.updated_at', 'lineup_type_group.id', 'lineup_type_group.ancestry', 'lineup_type_group.default_count', 'lineup_type_group.name', 'lineup_type_group.order', 'lineup_type_group.created_at', 'lineup_type_group.updated_at', 'lineup_type_group.lineup_type.id', 'lineup_type_group.lineup_type.name', 'lineup_type_group.lineup_type.created_at', 'lineup_type_group.lineup_type.updated_at', 'lineup_type_group.position.id', 'lineup_type_group.position.abbreviation', 'lineup_type_group.position.ancestry', 'lineup_type_group.position.name', 'lineup_type_group.position.created_at', 'lineup_type_group.position.updated_at', 'roster.id', 'roster.number', 'roster.quick_rating', 'roster.rank', 'roster.created_at', 'roster.updated_at', 'roster.player.id', 'roster.player.country', 'roster.player.dob_year', 'roster.player.first_name', 'roster.player.grad_year', 'roster.player.hand', 'roster.player.height_feet', 'roster.player.height_inches', 'roster.player.hometown', 'roster.player.last_name', 'roster.player.number', 'roster.player.quick_rating', 'roster.player.weight_lbs', 'roster.player.created_at', 'roster.player.updated_at', 'roster.team_season.id', 'roster.team_season.calendar_embed_url', 'roster.team_season.calendar_ics_url', 'roster.team_season.stats', 'roster.team_season.status', 'roster.team_season.created_at', 'roster.team_season.updated_at', 'roster.roster_status.id', 'roster.roster_status.name', 'roster.roster_status.order', 'roster.roster_status.status_type', 'roster.roster_status.created_at', 'roster.roster_status.updated_at'],
      traversable: true,
      searchable: false,
      pagination: {
        defaultLimit: 20,
        maxLimit: 100
      }
    }
  },
  lineup_type: {
    meta: {
      model: 'lineup_type',
      modelPlural: 'lineup_types',
      name: 'lineupType',
      pluralName: 'lineupTypes',
      readableName: 'Lineup type',
      pluralReadableName: 'Lineup types',
      ownedBy: 'sport',
      singular: false,
      path: '/api/lineup_types',
      searchable: false,
      kind: 'app'
    },
    properties: {
      id: {
        readOnly: true,
        nullable: false,
        type: 'integer',
        format: 'identifier',
        name: 'id',
        readableName: 'Id',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      name: {
        nullable: false,
        type: 'string',
        name: 'name',
        readableName: 'Name',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      lineup_type_groups: {
        readOnly: true,
        nullable: true,
        type: 'array',
        items: {
          type: 'reference',
          anyOf: [{
            $ref: '#/components/schemas/lineup_type_group'
          }],
          'x-rhino-attribute-array': {}
        },
        name: 'lineup_type_groups',
        readableName: 'Lineup Type Groups',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      sport: {
        nullable: false,
        type: 'reference',
        anyOf: [{
          $ref: '#/components/schemas/sport'
        }],
        name: 'sport',
        readableName: 'Sport',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      created_at: {
        readOnly: true,
        nullable: false,
        type: 'string',
        format: 'datetime',
        name: 'created_at',
        readableName: 'Created At',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      updated_at: {
        readOnly: true,
        nullable: false,
        type: 'string',
        format: 'datetime',
        name: 'updated_at',
        readableName: 'Updated At',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      display_name: {
        readOnly: true,
        nullable: true,
        type: 'string',
        name: 'display_name',
        readableName: 'Lineup type',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      }
    },
    querySurface: {
      filterable: {
        id: {
          type: 'integer',
          format: 'identifier',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        name: {
          type: 'string',
          operators: ['eq', 'diff']
        },
        created_at: {
          type: 'string',
          format: 'datetime',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        updated_at: {
          type: 'string',
          format: 'datetime',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        lineup_type_groups: {
          type: 'reference',
          model: 'lineup_type_group',
          many: true,
          identifier: 'id',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff', 'tree_subtree']
        },
        sport: {
          type: 'reference',
          model: 'sport',
          many: false,
          identifier: 'id',
          foreignKey: 'sport_id',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        }
      },
      orderable: ['id', 'name', 'created_at', 'updated_at', 'lineup_type_groups.id', 'lineup_type_groups.ancestry', 'lineup_type_groups.default_count', 'lineup_type_groups.name', 'lineup_type_groups.order', 'lineup_type_groups.created_at', 'lineup_type_groups.updated_at', 'lineup_type_groups.lineup_type.id', 'lineup_type_groups.lineup_type.name', 'lineup_type_groups.lineup_type.created_at', 'lineup_type_groups.lineup_type.updated_at', 'lineup_type_groups.position.id', 'lineup_type_groups.position.abbreviation', 'lineup_type_groups.position.ancestry', 'lineup_type_groups.position.name', 'lineup_type_groups.position.created_at', 'lineup_type_groups.position.updated_at', 'sport.id', 'sport.name', 'sport.created_at', 'sport.updated_at'],
      traversable: false,
      searchable: false,
      pagination: {
        defaultLimit: 20,
        maxLimit: 100
      }
    }
  },
  lineup_type_group: {
    meta: {
      model: 'lineup_type_group',
      modelPlural: 'lineup_type_groups',
      name: 'lineupTypeGroup',
      pluralName: 'lineupTypeGroups',
      readableName: 'Lineup type group',
      pluralReadableName: 'Lineup type groups',
      ownedBy: 'lineup_type',
      singular: false,
      path: '/api/lineup_type_groups',
      searchable: false,
      kind: 'app'
    },
    properties: {
      id: {
        readOnly: true,
        nullable: false,
        type: 'integer',
        format: 'identifier',
        name: 'id',
        readableName: 'Id',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      ancestry: {
        nullable: true,
        type: 'string',
        pattern: '^[0-9]+(\\/[0-9]+)*(?=\\n?$)',
        name: 'ancestry',
        readableName: 'Ancestry',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      default_count: {
        nullable: false,
        default: 1,
        type: 'integer',
        name: 'default_count',
        readableName: 'Default Count',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      name: {
        nullable: true,
        type: 'string',
        name: 'name',
        readableName: 'Name',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      order: {
        nullable: false,
        type: 'integer',
        name: 'order',
        readableName: 'Order',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      lineup_type: {
        nullable: false,
        type: 'reference',
        anyOf: [{
          $ref: '#/components/schemas/lineup_type'
        }],
        name: 'lineup_type',
        readableName: 'Lineup Type',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      position: {
        nullable: false,
        type: 'reference',
        anyOf: [{
          $ref: '#/components/schemas/position'
        }],
        name: 'position',
        readableName: 'Position',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      created_at: {
        readOnly: true,
        nullable: false,
        type: 'string',
        format: 'datetime',
        name: 'created_at',
        readableName: 'Created At',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      updated_at: {
        readOnly: true,
        nullable: false,
        type: 'string',
        format: 'datetime',
        name: 'updated_at',
        readableName: 'Updated At',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      children: {
        readOnly: true,
        nullable: true,
        type: 'array',
        items: {
          type: 'reference',
          anyOf: [{
            $ref: '#/components/schemas/lineup_type_group'
          }]
        },
        name: 'children',
        readableName: 'Children',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      display_name: {
        readOnly: true,
        nullable: true,
        type: 'string',
        name: 'display_name',
        readableName: 'Lineup type group',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      }
    },
    querySurface: {
      filterable: {
        id: {
          type: 'integer',
          format: 'identifier',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff', 'tree_subtree']
        },
        ancestry: {
          type: 'string',
          operators: ['eq', 'diff', 'is_null']
        },
        default_count: {
          type: 'integer',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        name: {
          type: 'string',
          operators: ['eq', 'diff', 'is_null']
        },
        order: {
          type: 'integer',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        created_at: {
          type: 'string',
          format: 'datetime',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        updated_at: {
          type: 'string',
          format: 'datetime',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        lineup_type: {
          type: 'reference',
          model: 'lineup_type',
          many: false,
          identifier: 'id',
          foreignKey: 'lineup_type_id',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        position: {
          type: 'reference',
          model: 'position',
          many: false,
          identifier: 'id',
          foreignKey: 'position_id',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff', 'tree_subtree']
        }
      },
      orderable: ['id', 'ancestry', 'default_count', 'name', 'order', 'created_at', 'updated_at', 'lineup_type.id', 'lineup_type.name', 'lineup_type.created_at', 'lineup_type.updated_at', 'lineup_type.lineup_type_groups.id', 'lineup_type.lineup_type_groups.ancestry', 'lineup_type.lineup_type_groups.default_count', 'lineup_type.lineup_type_groups.name', 'lineup_type.lineup_type_groups.order', 'lineup_type.lineup_type_groups.created_at', 'lineup_type.lineup_type_groups.updated_at', 'lineup_type.sport.id', 'lineup_type.sport.name', 'lineup_type.sport.created_at', 'lineup_type.sport.updated_at', 'position.id', 'position.abbreviation', 'position.ancestry', 'position.name', 'position.created_at', 'position.updated_at', 'position.sport.id', 'position.sport.name', 'position.sport.created_at', 'position.sport.updated_at'],
      traversable: false,
      searchable: false,
      pagination: {
        defaultLimit: 20,
        maxLimit: 100
      }
    }
  },
  message: {
    meta: {
      model: 'message',
      modelPlural: 'messages',
      name: 'message',
      pluralName: 'messages',
      readableName: 'Message',
      pluralReadableName: 'Messages',
      ownedBy: 'player',
      singular: false,
      path: '/api/messages',
      searchable: true,
      kind: 'app'
    },
    properties: {
      id: {
        readOnly: true,
        nullable: false,
        type: 'integer',
        format: 'identifier',
        name: 'id',
        readableName: 'Id',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      body: {
        nullable: false,
        type: 'text',
        name: 'body',
        readableName: 'Body',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      delivery_id: {
        nullable: true,
        type: 'string',
        name: 'delivery_id',
        readableName: 'Delivery',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      delivery_status: {
        nullable: false,
        default: 'not_sent',
        type: 'string',
        enum: ['not_sent', 'queued', 'delivered', 'error'],
        name: 'delivery_status',
        readableName: 'Delivery Status',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      group_id: {
        nullable: true,
        type: 'string',
        name: 'group_id',
        readableName: 'Group',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      message_direction: {
        nullable: false,
        default: 'outbound',
        type: 'string',
        enum: ['inbound', 'outbound'],
        name: 'message_direction',
        readableName: 'Message Direction',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      message_type: {
        nullable: false,
        type: 'string',
        enum: ['sms', 'email'],
        name: 'message_type',
        readableName: 'Message Type',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      summary: {
        nullable: true,
        type: 'string',
        name: 'summary',
        readableName: 'Summary',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      player: {
        nullable: false,
        type: 'reference',
        anyOf: [{
          $ref: '#/components/schemas/player'
        }],
        name: 'player',
        readableName: 'Player',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      from: {
        nullable: false,
        type: 'reference',
        anyOf: [{
          $ref: '#/components/schemas/user'
        }],
        name: 'from',
        readableName: 'From',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      recipients: {
        nullable: true,
        type: 'array',
        items: {
          type: 'reference',
          anyOf: [{
            $ref: '#/components/schemas/recipient'
          }],
          'x-rhino-attribute-array': {
            creatable: true,
            updatable: true,
            destroyable: false
          }
        },
        minLength: 1,
        name: 'recipients',
        readableName: 'Recipients',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      contacts: {
        readOnly: true,
        nullable: true,
        type: 'array',
        items: {
          type: 'reference',
          anyOf: [{
            $ref: '#/components/schemas/contact'
          }],
          'x-rhino-attribute-array': {}
        },
        name: 'contacts',
        readableName: 'Contacts',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      created_at: {
        readOnly: true,
        nullable: false,
        type: 'string',
        format: 'datetime',
        name: 'created_at',
        readableName: 'Created At',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      updated_at: {
        readOnly: true,
        nullable: false,
        type: 'string',
        format: 'datetime',
        name: 'updated_at',
        readableName: 'Updated At',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      display_name: {
        readOnly: true,
        nullable: true,
        type: 'string',
        name: 'display_name',
        readableName: 'Message',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      }
    },
    querySurface: {
      filterable: {
        id: {
          type: 'integer',
          format: 'identifier',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        body: {
          type: 'text',
          operators: ['eq', 'diff']
        },
        delivery_id: {
          type: 'string',
          operators: ['eq', 'diff', 'is_null']
        },
        delivery_status: {
          type: 'string',
          operators: ['eq', 'diff']
        },
        group_id: {
          type: 'string',
          operators: ['eq', 'diff', 'is_null']
        },
        message_direction: {
          type: 'string',
          operators: ['eq', 'diff']
        },
        message_type: {
          type: 'string',
          operators: ['eq', 'diff']
        },
        summary: {
          type: 'string',
          operators: ['eq', 'diff', 'is_null']
        },
        created_at: {
          type: 'string',
          format: 'datetime',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        updated_at: {
          type: 'string',
          format: 'datetime',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        player: {
          type: 'reference',
          model: 'player',
          many: false,
          identifier: 'id',
          foreignKey: 'player_id',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        from: {
          type: 'reference',
          model: 'user',
          many: false,
          identifier: 'id',
          foreignKey: 'from_id',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        recipients: {
          type: 'reference',
          model: 'recipient',
          many: true,
          identifier: 'id',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        contacts: {
          type: 'reference',
          model: 'contact',
          many: true,
          identifier: 'id',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        }
      },
      orderable: ['id', 'body', 'delivery_id', 'delivery_status', 'group_id', 'message_direction', 'message_type', 'summary', 'created_at', 'updated_at', 'player.id', 'player.country', 'player.dob_year', 'player.first_name', 'player.grad_year', 'player.hand', 'player.height_feet', 'player.height_inches', 'player.hometown', 'player.last_name', 'player.number', 'player.quick_rating', 'player.weight_lbs', 'player.created_at', 'player.updated_at', 'player.organization.id', 'player.organization.name', 'player.organization.created_at', 'player.organization.updated_at', 'player.player_positions.id', 'player.player_positions.created_at', 'player.player_positions.updated_at', 'player.positions.id', 'player.positions.abbreviation', 'player.positions.ancestry', 'player.positions.name', 'player.positions.created_at', 'player.positions.updated_at', 'player.rosters.id', 'player.rosters.number', 'player.rosters.quick_rating', 'player.rosters.rank', 'player.rosters.created_at', 'player.rosters.updated_at', 'player.current_roster.id', 'player.current_roster.number', 'player.current_roster.quick_rating', 'player.current_roster.rank', 'player.current_roster.created_at', 'player.current_roster.updated_at', 'player.external_linked_teams.id', 'player.external_linked_teams.team_name', 'player.external_linked_teams.created_at', 'player.external_linked_teams.updated_at', 'from.id', 'from.name', 'from.nickname', 'from.email', 'from.image', 'recipients.id', 'recipients.created_at', 'recipients.updated_at', 'recipients.contact.id', 'recipients.contact.email', 'recipients.contact.name', 'recipients.contact.note', 'recipients.contact.phone', 'recipients.contact.player_contact', 'recipients.contact.primary', 'recipients.contact.relationship', 'recipients.contact.created_at', 'recipients.contact.updated_at', 'recipients.message.id', 'recipients.message.body', 'recipients.message.delivery_id', 'recipients.message.delivery_status', 'recipients.message.group_id', 'recipients.message.message_direction', 'recipients.message.message_type', 'recipients.message.summary', 'recipients.message.created_at', 'recipients.message.updated_at', 'contacts.id', 'contacts.email', 'contacts.name', 'contacts.note', 'contacts.phone', 'contacts.player_contact', 'contacts.primary', 'contacts.relationship', 'contacts.created_at', 'contacts.updated_at', 'contacts.player.id', 'contacts.player.country', 'contacts.player.dob_year', 'contacts.player.first_name', 'contacts.player.grad_year', 'contacts.player.hand', 'contacts.player.height_feet', 'contacts.player.height_inches', 'contacts.player.hometown', 'contacts.player.last_name', 'contacts.player.number', 'contacts.player.quick_rating', 'contacts.player.weight_lbs', 'contacts.player.created_at', 'contacts.player.updated_at'],
      traversable: true,
      searchable: true,
      pagination: {
        defaultLimit: 20,
        maxLimit: 100
      }
    }
  },
  note: {
    meta: {
      model: 'note',
      modelPlural: 'notes',
      name: 'note',
      pluralName: 'notes',
      readableName: 'Note',
      pluralReadableName: 'Notes',
      ownedBy: 'player',
      singular: false,
      path: '/api/notes',
      searchable: false,
      kind: 'app'
    },
    properties: {
      id: {
        readOnly: true,
        nullable: false,
        type: 'integer',
        format: 'identifier',
        name: 'id',
        readableName: 'Id',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      discarded_at: {
        nullable: true,
        type: 'string',
        format: 'datetime',
        name: 'discarded_at',
        readableName: 'Discarded At',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      note: {
        nullable: true,
        type: 'text',
        name: 'note',
        readableName: 'Note',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      player: {
        nullable: false,
        type: 'reference',
        anyOf: [{
          $ref: '#/components/schemas/player'
        }],
        name: 'player',
        readableName: 'Player',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      reporter: {
        readOnly: true,
        nullable: false,
        type: 'reference',
        anyOf: [{
          $ref: '#/components/schemas/user'
        }],
        name: 'reporter',
        readableName: 'Reporter',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      created_at: {
        readOnly: true,
        nullable: false,
        type: 'string',
        format: 'datetime',
        name: 'created_at',
        readableName: 'Created At',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      updated_at: {
        readOnly: true,
        nullable: false,
        type: 'string',
        format: 'datetime',
        name: 'updated_at',
        readableName: 'Updated At',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      display_name: {
        readOnly: true,
        nullable: true,
        type: 'string',
        name: 'display_name',
        readableName: 'Note',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      }
    },
    querySurface: {
      filterable: {
        id: {
          type: 'integer',
          format: 'identifier',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        discarded_at: {
          type: 'string',
          format: 'datetime',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff', 'eq_coalesce', 'gteq_coalesce', 'lteq_coalesce', 'is_null']
        },
        note: {
          type: 'text',
          operators: ['eq', 'diff', 'is_null']
        },
        created_at: {
          type: 'string',
          format: 'datetime',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        updated_at: {
          type: 'string',
          format: 'datetime',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        player: {
          type: 'reference',
          model: 'player',
          many: false,
          identifier: 'id',
          foreignKey: 'player_id',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        reporter: {
          type: 'reference',
          model: 'user',
          many: false,
          identifier: 'id',
          foreignKey: 'reporter_id',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        }
      },
      orderable: ['id', 'discarded_at', 'note', 'created_at', 'updated_at', 'player.id', 'player.country', 'player.dob_year', 'player.first_name', 'player.grad_year', 'player.hand', 'player.height_feet', 'player.height_inches', 'player.hometown', 'player.last_name', 'player.number', 'player.quick_rating', 'player.weight_lbs', 'player.created_at', 'player.updated_at', 'player.organization.id', 'player.organization.name', 'player.organization.created_at', 'player.organization.updated_at', 'player.player_positions.id', 'player.player_positions.created_at', 'player.player_positions.updated_at', 'player.positions.id', 'player.positions.abbreviation', 'player.positions.ancestry', 'player.positions.name', 'player.positions.created_at', 'player.positions.updated_at', 'player.rosters.id', 'player.rosters.number', 'player.rosters.quick_rating', 'player.rosters.rank', 'player.rosters.created_at', 'player.rosters.updated_at', 'player.current_roster.id', 'player.current_roster.number', 'player.current_roster.quick_rating', 'player.current_roster.rank', 'player.current_roster.created_at', 'player.current_roster.updated_at', 'player.external_linked_teams.id', 'player.external_linked_teams.team_name', 'player.external_linked_teams.created_at', 'player.external_linked_teams.updated_at', 'reporter.id', 'reporter.name', 'reporter.nickname', 'reporter.email', 'reporter.image'],
      traversable: true,
      searchable: false,
      pagination: {
        defaultLimit: 20,
        maxLimit: 100
      }
    }
  },
  observation: {
    meta: {
      model: 'observation',
      modelPlural: 'observations',
      name: 'observation',
      pluralName: 'observations',
      readableName: 'Observation',
      pluralReadableName: 'Observations',
      ownedBy: 'organization',
      singular: false,
      path: '/api/observations',
      searchable: false,
      kind: 'app'
    },
    properties: {
      id: {
        readOnly: true,
        nullable: false,
        type: 'integer',
        format: 'identifier',
        name: 'id',
        readableName: 'Id',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      complete: {
        readOnly: true,
        nullable: false,
        default: false,
        type: 'boolean',
        name: 'complete',
        readableName: 'Complete',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      game_note: {
        nullable: true,
        type: 'text',
        name: 'game_note',
        readableName: 'Game Note',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      observed_at: {
        nullable: true,
        type: 'string',
        format: 'date',
        name: 'observed_at',
        readableName: 'Observed At',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      observing: {
        nullable: true,
        type: 'string',
        enum: ['exhibition', 'regular_season', 'playoff', 'tournament', 'practice', 'tryout', 'video', 'other'],
        name: 'observing',
        readableName: 'Observing',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      report: {
        nullable: true,
        type: 'jsonb',
        name: 'report',
        readableName: 'Report',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      venue: {
        nullable: true,
        type: 'string',
        name: 'venue',
        readableName: 'Venue',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      organization: {
        nullable: false,
        type: 'reference',
        anyOf: [{
          $ref: '#/components/schemas/organization'
        }],
        name: 'organization',
        readableName: 'Organization',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      observer: {
        nullable: false,
        type: 'reference',
        anyOf: [{
          $ref: '#/components/schemas/user'
        }],
        name: 'observer',
        readableName: 'Observer',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      created_at: {
        readOnly: true,
        nullable: false,
        type: 'string',
        format: 'datetime',
        name: 'created_at',
        readableName: 'Created At',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      updated_at: {
        readOnly: true,
        nullable: false,
        type: 'string',
        format: 'datetime',
        name: 'updated_at',
        readableName: 'Updated At',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      display_name: {
        readOnly: true,
        nullable: true,
        type: 'string',
        name: 'display_name',
        readableName: 'Observation',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      }
    },
    querySurface: {
      filterable: {
        id: {
          type: 'integer',
          format: 'identifier',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        complete: {
          type: 'boolean',
          operators: ['eq', 'diff']
        },
        game_note: {
          type: 'text',
          operators: ['eq', 'diff', 'is_null']
        },
        observed_at: {
          type: 'string',
          format: 'date',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff', 'eq_coalesce', 'gteq_coalesce', 'lteq_coalesce', 'is_null']
        },
        observing: {
          type: 'string',
          operators: ['eq', 'diff', 'is_null']
        },
        report: {
          type: 'jsonb',
          operators: ['eq', 'diff', 'is_null']
        },
        venue: {
          type: 'string',
          operators: ['eq', 'diff', 'is_null']
        },
        created_at: {
          type: 'string',
          format: 'datetime',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        updated_at: {
          type: 'string',
          format: 'datetime',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        organization: {
          type: 'reference',
          model: 'organization',
          many: false,
          identifier: 'id',
          foreignKey: 'organization_id',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        observer: {
          type: 'reference',
          model: 'user',
          many: false,
          identifier: 'id',
          foreignKey: 'observer_id',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        }
      },
      orderable: ['id', 'complete', 'game_note', 'observed_at', 'observing', 'report', 'venue', 'created_at', 'updated_at', 'organization.id', 'organization.name', 'organization.created_at', 'organization.updated_at', 'organization.logo_attachment.id', 'organization.logo_attachment.name', 'organization.logo_attachment.record_type', 'organization.logo_attachment.created_at', 'organization.sport.id', 'organization.sport.name', 'organization.sport.created_at', 'organization.sport.updated_at', 'organization.teams.id', 'organization.teams.name', 'organization.teams.created_at', 'organization.teams.updated_at', 'organization.users_roles.id', 'organization.users_roles.created_at', 'organization.users_roles.updated_at', 'observer.id', 'observer.name', 'observer.nickname', 'observer.email', 'observer.image'],
      traversable: true,
      searchable: false,
      pagination: {
        defaultLimit: 20,
        maxLimit: 100
      }
    }
  },
  organization: {
    meta: {
      model: 'organization',
      modelPlural: 'organizations',
      name: 'organization',
      pluralName: 'organizations',
      readableName: 'Organization',
      pluralReadableName: 'Organizations',
      ownedBy: null,
      singular: false,
      path: '/api/organizations',
      searchable: false,
      kind: 'core'
    },
    properties: {
      id: {
        readOnly: true,
        nullable: false,
        type: 'integer',
        format: 'identifier',
        name: 'id',
        readableName: 'Id',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      features: {
        readOnly: true,
        nullable: true,
        default: [],
        type: 'array',
        items: {
          type: 'string'
        },
        name: 'features',
        readableName: 'Features',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      name: {
        nullable: false,
        type: 'string',
        name: 'name',
        readableName: 'Name',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      logo_attachment: {
        nullable: true,
        type: 'reference',
        anyOf: [{
          $ref: '#/components/schemas/active_storage_attachment'
        }],
        name: 'logo_attachment',
        readableName: 'Logo Attachment',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      sport: {
        readOnly: true,
        nullable: false,
        type: 'reference',
        anyOf: [{
          $ref: '#/components/schemas/sport'
        }],
        name: 'sport',
        readableName: 'Sport',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      teams: {
        readOnly: true,
        nullable: true,
        type: 'array',
        items: {
          type: 'reference',
          anyOf: [{
            $ref: '#/components/schemas/team'
          }],
          'x-rhino-attribute-array': {
            creatable: true,
            updatable: true,
            destroyable: false
          }
        },
        name: 'teams',
        readableName: 'Teams',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      users_roles: {
        readOnly: true,
        nullable: true,
        type: 'array',
        items: {
          type: 'reference',
          anyOf: [{
            $ref: '#/components/schemas/users_role'
          }],
          'x-rhino-attribute-array': {}
        },
        name: 'users_roles',
        readableName: 'Users Roles',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      created_at: {
        readOnly: true,
        nullable: false,
        type: 'string',
        format: 'datetime',
        name: 'created_at',
        readableName: 'Created At',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      updated_at: {
        readOnly: true,
        nullable: false,
        type: 'string',
        format: 'datetime',
        name: 'updated_at',
        readableName: 'Updated At',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      display_name: {
        readOnly: true,
        nullable: true,
        type: 'string',
        name: 'display_name',
        readableName: 'Organization',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      }
    },
    querySurface: {
      filterable: {
        id: {
          type: 'integer',
          format: 'identifier',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        name: {
          type: 'string',
          operators: ['eq', 'diff']
        },
        created_at: {
          type: 'string',
          format: 'datetime',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        updated_at: {
          type: 'string',
          format: 'datetime',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        logo_attachment: {
          type: 'reference',
          model: 'active_storage_attachment',
          many: false,
          identifier: 'id',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        sport: {
          type: 'reference',
          model: 'sport',
          many: false,
          identifier: 'id',
          foreignKey: 'sport_id',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        teams: {
          type: 'reference',
          model: 'team',
          many: true,
          identifier: 'id',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        users_roles: {
          type: 'reference',
          model: 'users_role',
          many: true,
          identifier: 'id',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        }
      },
      orderable: ['id', 'name', 'created_at', 'updated_at', 'logo_attachment.id', 'logo_attachment.name', 'logo_attachment.record_type', 'logo_attachment.created_at', 'sport.id', 'sport.name', 'sport.created_at', 'sport.updated_at', 'teams.id', 'teams.name', 'teams.created_at', 'teams.updated_at', 'teams.organization.id', 'teams.organization.name', 'teams.organization.created_at', 'teams.organization.updated_at', 'teams.team_seasons.id', 'teams.team_seasons.calendar_embed_url', 'teams.team_seasons.calendar_ics_url', 'teams.team_seasons.stats', 'teams.team_seasons.status', 'teams.team_seasons.created_at', 'teams.team_seasons.updated_at', 'users_roles.id', 'users_roles.created_at', 'users_roles.updated_at', 'users_roles.user.id', 'users_roles.user.name', 'users_roles.user.nickname', 'users_roles.user.email', 'users_roles.user.image', 'users_roles.role.id', 'users_roles.role.name', 'users_roles.role.created_at', 'users_roles.role.updated_at', 'users_roles.organization.id', 'users_roles.organization.name', 'users_roles.organization.created_at', 'users_roles.organization.updated_at'],
      traversable: true,
      searchable: false,
      pagination: {
        defaultLimit: 20,
        maxLimit: 100
      }
    }
  },
  player: {
    meta: {
      model: 'player',
      modelPlural: 'players',
      name: 'player',
      pluralName: 'players',
      readableName: 'Player',
      pluralReadableName: 'Players',
      ownedBy: 'organization',
      singular: false,
      path: '/api/players',
      searchable: true,
      kind: 'app'
    },
    properties: {
      id: {
        readOnly: true,
        nullable: false,
        type: 'integer',
        format: 'identifier',
        name: 'id',
        readableName: 'Id',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      country: {
        nullable: true,
        type: 'string',
        format: 'country',
        name: 'country',
        readableName: 'Country',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      dob_year: {
        nullable: true,
        type: 'integer',
        minimum: 1986,
        maximum: 2021,
        format: 'year',
        name: 'dob_year',
        readableName: 'Dob Year',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      first_name: {
        nullable: true,
        type: 'string',
        name: 'first_name',
        readableName: 'First Name',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      grad_year: {
        nullable: true,
        type: 'integer',
        minimum: 1986,
        maximum: 2036,
        format: 'year',
        name: 'grad_year',
        readableName: 'Grad Year',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      hand: {
        nullable: true,
        type: 'string',
        minLength: 1,
        maxLength: 1,
        enum: ['L', 'R'],
        name: 'hand',
        readableName: 'Hand',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      height_feet: {
        nullable: true,
        type: 'integer',
        name: 'height_feet',
        readableName: 'Height Feet',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      height_inches: {
        nullable: true,
        type: 'string',
        name: 'height_inches',
        readableName: 'Height Inches',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      hometown: {
        nullable: true,
        type: 'string',
        name: 'hometown',
        readableName: 'Hometown',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      last_name: {
        nullable: false,
        type: 'string',
        name: 'last_name',
        readableName: 'Last Name',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      number: {
        nullable: true,
        type: 'string',
        pattern: '^\\d*$',
        maxLength: 3,
        name: 'number',
        readableName: 'Number',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      quick_rating: {
        readOnly: true,
        nullable: true,
        type: 'number',
        format: 'double',
        name: 'quick_rating',
        readableName: 'Quick Rating',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      weight_lbs: {
        nullable: true,
        type: 'integer',
        name: 'weight_lbs',
        readableName: 'Weight Lbs',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      organization: {
        nullable: false,
        type: 'reference',
        anyOf: [{
          $ref: '#/components/schemas/organization'
        }],
        name: 'organization',
        readableName: 'Organization',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      player_positions: {
        nullable: true,
        type: 'array',
        items: {
          type: 'reference',
          anyOf: [{
            $ref: '#/components/schemas/player_position'
          }],
          'x-rhino-attribute-array': {
            creatable: true,
            updatable: true,
            destroyable: true
          }
        },
        format: 'join_table_simple',
        name: 'player_positions',
        readableName: 'Player Positions',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      positions: {
        readOnly: true,
        nullable: true,
        type: 'array',
        items: {
          type: 'reference',
          anyOf: [{
            $ref: '#/components/schemas/position'
          }],
          'x-rhino-attribute-array': {}
        },
        name: 'positions',
        readableName: 'Positions',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      rosters: {
        nullable: true,
        type: 'array',
        items: {
          type: 'reference',
          anyOf: [{
            $ref: '#/components/schemas/roster'
          }],
          'x-rhino-attribute-array': {
            creatable: true,
            updatable: true,
            destroyable: true
          }
        },
        name: 'rosters',
        readableName: 'Rosters',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      current_roster: {
        nullable: true,
        type: 'reference',
        anyOf: [{
          $ref: '#/components/schemas/roster'
        }],
        name: 'current_roster',
        readableName: 'Current Roster',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      external_linked_teams: {
        nullable: true,
        type: 'array',
        items: {
          type: 'reference',
          anyOf: [{
            $ref: '#/components/schemas/external_linked_team'
          }],
          'x-rhino-attribute-array': {
            creatable: true,
            updatable: true,
            destroyable: false
          }
        },
        name: 'external_linked_teams',
        readableName: 'External Linked Teams',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      created_at: {
        readOnly: true,
        nullable: false,
        type: 'string',
        format: 'datetime',
        name: 'created_at',
        readableName: 'Created At',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      updated_at: {
        readOnly: true,
        nullable: false,
        type: 'string',
        format: 'datetime',
        name: 'updated_at',
        readableName: 'Updated At',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      display_name: {
        readOnly: true,
        nullable: true,
        type: 'string',
        name: 'display_name',
        readableName: 'Player',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      }
    },
    querySurface: {
      filterable: {
        id: {
          type: 'integer',
          format: 'identifier',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        country: {
          type: 'string',
          operators: ['eq', 'diff', 'is_null']
        },
        dob_year: {
          type: 'integer',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff', 'eq_coalesce', 'gteq_coalesce', 'lteq_coalesce', 'is_null']
        },
        first_name: {
          type: 'string',
          operators: ['eq', 'diff', 'is_null']
        },
        grad_year: {
          type: 'integer',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff', 'eq_coalesce', 'gteq_coalesce', 'lteq_coalesce', 'is_null']
        },
        hand: {
          type: 'string',
          operators: ['eq', 'diff', 'is_null']
        },
        height_feet: {
          type: 'integer',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff', 'eq_coalesce', 'gteq_coalesce', 'lteq_coalesce', 'is_null']
        },
        height_inches: {
          type: 'string',
          operators: ['eq', 'diff', 'is_null']
        },
        hometown: {
          type: 'string',
          operators: ['eq', 'diff', 'is_null']
        },
        last_name: {
          type: 'string',
          operators: ['eq', 'diff']
        },
        number: {
          type: 'string',
          operators: ['eq', 'diff', 'is_null']
        },
        quick_rating: {
          type: 'number',
          format: 'double',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff', 'eq_coalesce', 'gteq_coalesce', 'lteq_coalesce', 'is_null']
        },
        weight_lbs: {
          type: 'integer',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff', 'eq_coalesce', 'gteq_coalesce', 'lteq_coalesce', 'is_null']
        },
        created_at: {
          type: 'string',
          format: 'datetime',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        updated_at: {
          type: 'string',
          format: 'datetime',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        organization: {
          type: 'reference',
          model: 'organization',
          many: false,
          identifier: 'id',
          foreignKey: 'organization_id',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        player_positions: {
          type: 'reference',
          model: 'player_position',
          many: true,
          identifier: 'id',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        positions: {
          type: 'reference',
          model: 'position',
          many: true,
          identifier: 'id',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff', 'tree_subtree']
        },
        rosters: {
          type: 'reference',
          model: 'roster',
          many: true,
          identifier: 'id',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        current_roster: {
          type: 'reference',
          model: 'roster',
          many: false,
          identifier: 'id',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        external_linked_teams: {
          type: 'reference',
          model: 'external_linked_team',
          many: true,
          identifier: 'id',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        }
      },
      orderable: ['id', 'country', 'dob_year', 'first_name', 'grad_year', 'hand', 'height_feet', 'height_inches', 'hometown', 'last_name', 'number', 'quick_rating', 'weight_lbs', 'created_at', 'updated_at', 'organization.id', 'organization.name', 'organization.created_at', 'organization.updated_at', 'organization.logo_attachment.id', 'organization.logo_attachment.name', 'organization.logo_attachment.record_type', 'organization.logo_attachment.created_at', 'organization.sport.id', 'organization.sport.name', 'organization.sport.created_at', 'organization.sport.updated_at', 'organization.teams.id', 'organization.teams.name', 'organization.teams.created_at', 'organization.teams.updated_at', 'organization.users_roles.id', 'organization.users_roles.created_at', 'organization.users_roles.updated_at', 'player_positions.id', 'player_positions.created_at', 'player_positions.updated_at', 'player_positions.player.id', 'player_positions.player.country', 'player_positions.player.dob_year', 'player_positions.player.first_name', 'player_positions.player.grad_year', 'player_positions.player.hand', 'player_positions.player.height_feet', 'player_positions.player.height_inches', 'player_positions.player.hometown', 'player_positions.player.last_name', 'player_positions.player.number', 'player_positions.player.quick_rating', 'player_positions.player.weight_lbs', 'player_positions.player.created_at', 'player_positions.player.updated_at', 'player_positions.position.id', 'player_positions.position.abbreviation', 'player_positions.position.ancestry', 'player_positions.position.name', 'player_positions.position.created_at', 'player_positions.position.updated_at', 'positions.id', 'positions.abbreviation', 'positions.ancestry', 'positions.name', 'positions.created_at', 'positions.updated_at', 'positions.sport.id', 'positions.sport.name', 'positions.sport.created_at', 'positions.sport.updated_at', 'rosters.id', 'rosters.number', 'rosters.quick_rating', 'rosters.rank', 'rosters.created_at', 'rosters.updated_at', 'rosters.player.id', 'rosters.player.country', 'rosters.player.dob_year', 'rosters.player.first_name', 'rosters.player.grad_year', 'rosters.player.hand', 'rosters.player.height_feet', 'rosters.player.height_inches', 'rosters.player.hometown', 'rosters.player.last_name', 'rosters.player.number', 'rosters.player.quick_rating', 'rosters.player.weight_lbs', 'rosters.player.created_at', 'rosters.player.updated_at', 'rosters.team_season.id', 'rosters.team_season.calendar_embed_url', 'rosters.team_season.calendar_ics_url', 'rosters.team_season.stats', 'rosters.team_season.status', 'rosters.team_season.created_at', 'rosters.team_season.updated_at', 'rosters.roster_status.id', 'rosters.roster_status.name', 'rosters.roster_status.order', 'rosters.roster_status.status_type', 'rosters.roster_status.created_at', 'rosters.roster_status.updated_at', 'current_roster.id', 'current_roster.number', 'current_roster.quick_rating', 'current_roster.rank', 'current_roster.created_at', 'current_roster.updated_at', 'current_roster.player.id', 'current_roster.player.country', 'current_roster.player.dob_year', 'current_roster.player.first_name', 'current_roster.player.grad_year', 'current_roster.player.hand', 'current_roster.player.height_feet', 'current_roster.player.height_inches', 'current_roster.player.hometown', 'current_roster.player.last_name', 'current_roster.player.number', 'current_roster.player.quick_rating', 'current_roster.player.weight_lbs', 'current_roster.player.created_at', 'current_roster.player.updated_at', 'current_roster.team_season.id', 'current_roster.team_season.calendar_embed_url', 'current_roster.team_season.calendar_ics_url', 'current_roster.team_season.stats', 'current_roster.team_season.status', 'current_roster.team_season.created_at', 'current_roster.team_season.updated_at', 'current_roster.roster_status.id', 'current_roster.roster_status.name', 'current_roster.roster_status.order', 'current_roster.roster_status.status_type', 'current_roster.roster_status.created_at', 'current_roster.roster_status.updated_at', 'external_linked_teams.id', 'external_linked_teams.team_name', 'external_linked_teams.created_at', 'external_linked_teams.updated_at', 'external_linked_teams.external_team_season.id', 'external_linked_teams.external_team_season.created_at', 'external_linked_teams.external_team_season.updated_at', 'external_linked_teams.external_team.id', 'external_linked_teams.external_team.import_key', 'external_linked_teams.external_team.name', 'external_linked_teams.external_team.created_at', 'external_linked_teams.external_team.updated_at', 'external_linked_teams.season.id', 'external_linked_teams.season.name', 'external_linked_teams.season.starts_on', 'external_linked_teams.season.created_at', 'external_linked_teams.season.updated_at', 'external_linked_teams.player.id', 'external_linked_teams.player.country', 'external_linked_teams.player.dob_year', 'external_linked_teams.player.first_name', 'external_linked_teams.player.grad_year', 'external_linked_teams.player.hand', 'external_linked_teams.player.height_feet', 'external_linked_teams.player.height_inches', 'external_linked_teams.player.hometown', 'external_linked_teams.player.last_name', 'external_linked_teams.player.number', 'external_linked_teams.player.quick_rating', 'external_linked_teams.player.weight_lbs', 'external_linked_teams.player.created_at', 'external_linked_teams.player.updated_at'],
      traversable: true,
      searchable: true,
      pagination: {
        defaultLimit: 20,
        maxLimit: 100
      }
    }
  },
  player_position: {
    meta: {
      model: 'player_position',
      modelPlural: 'player_positions',
      name: 'playerPosition',
      pluralName: 'playerPositions',
      readableName: 'Player position',
      pluralReadableName: 'Player positions',
      ownedBy: 'player',
      singular: false,
      path: '/api/player_positions',
      searchable: false,
      kind: 'app'
    },
    properties: {
      id: {
        readOnly: true,
        nullable: false,
        type: 'integer',
        format: 'identifier',
        name: 'id',
        readableName: 'Id',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      player: {
        nullable: false,
        type: 'reference',
        anyOf: [{
          $ref: '#/components/schemas/player'
        }],
        name: 'player',
        readableName: 'Player',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      position: {
        nullable: false,
        type: 'reference',
        anyOf: [{
          $ref: '#/components/schemas/position'
        }],
        name: 'position',
        readableName: 'Position',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      created_at: {
        readOnly: true,
        nullable: false,
        type: 'string',
        format: 'datetime',
        name: 'created_at',
        readableName: 'Created At',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      updated_at: {
        readOnly: true,
        nullable: false,
        type: 'string',
        format: 'datetime',
        name: 'updated_at',
        readableName: 'Updated At',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      display_name: {
        readOnly: true,
        nullable: true,
        type: 'string',
        name: 'display_name',
        readableName: 'Player position',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      }
    },
    querySurface: {
      filterable: {
        id: {
          type: 'integer',
          format: 'identifier',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        created_at: {
          type: 'string',
          format: 'datetime',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        updated_at: {
          type: 'string',
          format: 'datetime',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        player: {
          type: 'reference',
          model: 'player',
          many: false,
          identifier: 'id',
          foreignKey: 'player_id',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        position: {
          type: 'reference',
          model: 'position',
          many: false,
          identifier: 'id',
          foreignKey: 'position_id',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff', 'tree_subtree']
        }
      },
      orderable: ['id', 'created_at', 'updated_at', 'player.id', 'player.country', 'player.dob_year', 'player.first_name', 'player.grad_year', 'player.hand', 'player.height_feet', 'player.height_inches', 'player.hometown', 'player.last_name', 'player.number', 'player.quick_rating', 'player.weight_lbs', 'player.created_at', 'player.updated_at', 'player.organization.id', 'player.organization.name', 'player.organization.created_at', 'player.organization.updated_at', 'player.player_positions.id', 'player.player_positions.created_at', 'player.player_positions.updated_at', 'player.positions.id', 'player.positions.abbreviation', 'player.positions.ancestry', 'player.positions.name', 'player.positions.created_at', 'player.positions.updated_at', 'player.rosters.id', 'player.rosters.number', 'player.rosters.quick_rating', 'player.rosters.rank', 'player.rosters.created_at', 'player.rosters.updated_at', 'player.current_roster.id', 'player.current_roster.number', 'player.current_roster.quick_rating', 'player.current_roster.rank', 'player.current_roster.created_at', 'player.current_roster.updated_at', 'player.external_linked_teams.id', 'player.external_linked_teams.team_name', 'player.external_linked_teams.created_at', 'player.external_linked_teams.updated_at', 'position.id', 'position.abbreviation', 'position.ancestry', 'position.name', 'position.created_at', 'position.updated_at', 'position.sport.id', 'position.sport.name', 'position.sport.created_at', 'position.sport.updated_at'],
      traversable: true,
      searchable: false,
      pagination: {
        defaultLimit: 20,
        maxLimit: 100
      }
    }
  },
  position: {
    meta: {
      model: 'position',
      modelPlural: 'positions',
      name: 'position',
      pluralName: 'positions',
      readableName: 'Position',
      pluralReadableName: 'Positions',
      ownedBy: 'sport',
      singular: false,
      path: '/api/positions',
      searchable: false,
      kind: 'app'
    },
    properties: {
      id: {
        readOnly: true,
        nullable: false,
        type: 'integer',
        format: 'identifier',
        name: 'id',
        readableName: 'Id',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      abbreviation: {
        nullable: true,
        type: 'string',
        name: 'abbreviation',
        readableName: 'Abbreviation',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      ancestry: {
        nullable: true,
        type: 'string',
        pattern: '^[0-9]+(\\/[0-9]+)*(?=\\n?$)',
        name: 'ancestry',
        readableName: 'Ancestry',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      name: {
        nullable: true,
        type: 'string',
        name: 'name',
        readableName: 'Name',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      sport: {
        nullable: false,
        type: 'reference',
        anyOf: [{
          $ref: '#/components/schemas/sport'
        }],
        name: 'sport',
        readableName: 'Sport',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      created_at: {
        readOnly: true,
        nullable: false,
        type: 'string',
        format: 'datetime',
        name: 'created_at',
        readableName: 'Created At',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      updated_at: {
        readOnly: true,
        nullable: false,
        type: 'string',
        format: 'datetime',
        name: 'updated_at',
        readableName: 'Updated At',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      display_name: {
        readOnly: true,
        nullable: true,
        type: 'string',
        name: 'display_name',
        readableName: 'Position',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      }
    },
    querySurface: {
      filterable: {
        id: {
          type: 'integer',
          format: 'identifier',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff', 'tree_subtree']
        },
        abbreviation: {
          type: 'string',
          operators: ['eq', 'diff', 'is_null']
        },
        ancestry: {
          type: 'string',
          operators: ['eq', 'diff', 'is_null']
        },
        name: {
          type: 'string',
          operators: ['eq', 'diff', 'is_null']
        },
        created_at: {
          type: 'string',
          format: 'datetime',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        updated_at: {
          type: 'string',
          format: 'datetime',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        sport: {
          type: 'reference',
          model: 'sport',
          many: false,
          identifier: 'id',
          foreignKey: 'sport_id',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        }
      },
      orderable: ['id', 'abbreviation', 'ancestry', 'name', 'created_at', 'updated_at', 'sport.id', 'sport.name', 'sport.created_at', 'sport.updated_at'],
      traversable: false,
      searchable: false,
      pagination: {
        defaultLimit: 1000,
        maxLimit: 1000
      }
    }
  },
  practice_plan: {
    meta: {
      model: 'practice_plan',
      modelPlural: 'practice_plans',
      name: 'practicePlan',
      pluralName: 'practicePlans',
      readableName: 'Practice plan',
      pluralReadableName: 'Practice plans',
      ownedBy: 'team_season',
      singular: false,
      path: '/api/practice_plans',
      searchable: true,
      kind: 'app'
    },
    properties: {
      id: {
        readOnly: true,
        nullable: false,
        type: 'integer',
        format: 'identifier',
        name: 'id',
        readableName: 'Id',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      description: {
        nullable: true,
        type: 'text',
        name: 'description',
        readableName: 'Description',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      plan_date: {
        nullable: false,
        type: 'string',
        format: 'date',
        name: 'plan_date',
        readableName: 'Plan Date',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      title: {
        nullable: false,
        type: 'string',
        name: 'title',
        readableName: 'Title',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      pdf_attachment: {
        nullable: true,
        type: 'reference',
        anyOf: [{
          $ref: '#/components/schemas/active_storage_attachment'
        }],
        name: 'pdf_attachment',
        readableName: 'Pdf Attachment',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      team_season: {
        nullable: false,
        type: 'reference',
        anyOf: [{
          $ref: '#/components/schemas/team_season'
        }],
        name: 'team_season',
        readableName: 'Team Season',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      created_at: {
        readOnly: true,
        nullable: false,
        type: 'string',
        format: 'datetime',
        name: 'created_at',
        readableName: 'Created At',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      updated_at: {
        readOnly: true,
        nullable: false,
        type: 'string',
        format: 'datetime',
        name: 'updated_at',
        readableName: 'Updated At',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      display_name: {
        readOnly: true,
        nullable: true,
        type: 'string',
        name: 'display_name',
        readableName: 'Practice plan',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      }
    },
    querySurface: {
      filterable: {
        id: {
          type: 'integer',
          format: 'identifier',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        description: {
          type: 'text',
          operators: ['eq', 'diff', 'is_null']
        },
        plan_date: {
          type: 'string',
          format: 'date',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff', 'eq_coalesce', 'gteq_coalesce', 'lteq_coalesce', 'is_null']
        },
        title: {
          type: 'string',
          operators: ['eq', 'diff']
        },
        created_at: {
          type: 'string',
          format: 'datetime',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        updated_at: {
          type: 'string',
          format: 'datetime',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        pdf_attachment: {
          type: 'reference',
          model: 'active_storage_attachment',
          many: false,
          identifier: 'id',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        team_season: {
          type: 'reference',
          model: 'team_season',
          many: false,
          identifier: 'id',
          foreignKey: 'team_season_id',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        }
      },
      orderable: ['id', 'description', 'plan_date', 'title', 'created_at', 'updated_at', 'pdf_attachment.id', 'pdf_attachment.name', 'pdf_attachment.record_type', 'pdf_attachment.created_at', 'team_season.id', 'team_season.calendar_embed_url', 'team_season.calendar_ics_url', 'team_season.stats', 'team_season.status', 'team_season.created_at', 'team_season.updated_at', 'team_season.season.id', 'team_season.season.name', 'team_season.season.starts_on', 'team_season.season.created_at', 'team_season.season.updated_at', 'team_season.team.id', 'team_season.team.name', 'team_season.team.created_at', 'team_season.team.updated_at'],
      traversable: true,
      searchable: true,
      pagination: {
        defaultLimit: 20,
        maxLimit: 100
      }
    }
  },
  recipient: {
    meta: {
      model: 'recipient',
      modelPlural: 'recipients',
      name: 'recipient',
      pluralName: 'recipients',
      readableName: 'Recipient',
      pluralReadableName: 'Recipients',
      ownedBy: 'contact',
      singular: false,
      path: '/api/recipients',
      searchable: false,
      kind: 'app'
    },
    properties: {
      id: {
        readOnly: true,
        nullable: false,
        type: 'integer',
        format: 'identifier',
        name: 'id',
        readableName: 'Id',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      contact: {
        nullable: false,
        type: 'reference',
        anyOf: [{
          $ref: '#/components/schemas/contact'
        }],
        name: 'contact',
        readableName: 'Contact',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      message: {
        nullable: false,
        type: 'reference',
        anyOf: [{
          $ref: '#/components/schemas/message'
        }],
        name: 'message',
        readableName: 'Message',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      created_at: {
        readOnly: true,
        nullable: false,
        type: 'string',
        format: 'datetime',
        name: 'created_at',
        readableName: 'Created At',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      updated_at: {
        readOnly: true,
        nullable: false,
        type: 'string',
        format: 'datetime',
        name: 'updated_at',
        readableName: 'Updated At',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      display_name: {
        readOnly: true,
        nullable: true,
        type: 'string',
        name: 'display_name',
        readableName: 'Recipient',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      }
    },
    querySurface: {
      filterable: {
        id: {
          type: 'integer',
          format: 'identifier',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        created_at: {
          type: 'string',
          format: 'datetime',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        updated_at: {
          type: 'string',
          format: 'datetime',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        contact: {
          type: 'reference',
          model: 'contact',
          many: false,
          identifier: 'id',
          foreignKey: 'contact_id',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        message: {
          type: 'reference',
          model: 'message',
          many: false,
          identifier: 'id',
          foreignKey: 'message_id',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        }
      },
      orderable: ['id', 'created_at', 'updated_at', 'contact.id', 'contact.email', 'contact.name', 'contact.note', 'contact.phone', 'contact.player_contact', 'contact.primary', 'contact.relationship', 'contact.created_at', 'contact.updated_at', 'contact.player.id', 'contact.player.country', 'contact.player.dob_year', 'contact.player.first_name', 'contact.player.grad_year', 'contact.player.hand', 'contact.player.height_feet', 'contact.player.height_inches', 'contact.player.hometown', 'contact.player.last_name', 'contact.player.number', 'contact.player.quick_rating', 'contact.player.weight_lbs', 'contact.player.created_at', 'contact.player.updated_at', 'message.id', 'message.body', 'message.delivery_id', 'message.delivery_status', 'message.group_id', 'message.message_direction', 'message.message_type', 'message.summary', 'message.created_at', 'message.updated_at', 'message.player.id', 'message.player.country', 'message.player.dob_year', 'message.player.first_name', 'message.player.grad_year', 'message.player.hand', 'message.player.height_feet', 'message.player.height_inches', 'message.player.hometown', 'message.player.last_name', 'message.player.number', 'message.player.quick_rating', 'message.player.weight_lbs', 'message.player.created_at', 'message.player.updated_at', 'message.from.id', 'message.from.name', 'message.from.nickname', 'message.from.email', 'message.from.image', 'message.recipients.id', 'message.recipients.created_at', 'message.recipients.updated_at', 'message.contacts.id', 'message.contacts.email', 'message.contacts.name', 'message.contacts.note', 'message.contacts.phone', 'message.contacts.player_contact', 'message.contacts.primary', 'message.contacts.relationship', 'message.contacts.created_at', 'message.contacts.updated_at'],
      traversable: true,
      searchable: false,
      pagination: {
        defaultLimit: 20,
        maxLimit: 100
      }
    }
  },
  report: {
    meta: {
      model: 'report',
      modelPlural: 'reports',
      name: 'report',
      pluralName: 'reports',
      readableName: 'Report',
      pluralReadableName: 'Reports',
      ownedBy: 'player',
      singular: false,
      path: '/api/reports',
      searchable: true,
      kind: 'app'
    },
    properties: {
      id: {
        readOnly: true,
        nullable: false,
        type: 'integer',
        format: 'identifier',
        name: 'id',
        readableName: 'Id',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      observing: {
        nullable: false,
        type: 'string',
        enum: ['exhibition', 'regular_season', 'playoff', 'tournament', 'practice', 'tryout', 'video', 'other'],
        name: 'observing',
        readableName: 'Observing',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      report_status: {
        nullable: true,
        type: 'integer',
        name: 'report_status',
        readableName: 'Report Status',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      reported_at: {
        nullable: false,
        type: 'string',
        format: 'datetime',
        name: 'reported_at',
        readableName: 'Reported At',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      venue: {
        nullable: true,
        type: 'string',
        name: 'venue',
        readableName: 'Venue',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      report_type: {
        nullable: false,
        type: 'reference',
        anyOf: [{
          $ref: '#/components/schemas/report_type'
        }],
        name: 'report_type',
        readableName: 'Report Type',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      player: {
        nullable: false,
        type: 'reference',
        anyOf: [{
          $ref: '#/components/schemas/player'
        }],
        name: 'player',
        readableName: 'Player',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      reporter: {
        nullable: false,
        type: 'reference',
        anyOf: [{
          $ref: '#/components/schemas/user'
        }],
        name: 'reporter',
        readableName: 'Reporter',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      report_values: {
        nullable: true,
        type: 'array',
        items: {
          type: 'reference',
          anyOf: [{
            $ref: '#/components/schemas/report_value'
          }],
          'x-rhino-attribute-array': {
            creatable: true,
            updatable: true,
            destroyable: false
          }
        },
        name: 'report_values',
        readableName: 'Report Values',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      report_fields: {
        readOnly: true,
        nullable: true,
        type: 'array',
        items: {
          type: 'reference',
          anyOf: [{
            $ref: '#/components/schemas/report_field'
          }],
          'x-rhino-attribute-array': {}
        },
        name: 'report_fields',
        readableName: 'Report Fields',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      created_at: {
        readOnly: true,
        nullable: false,
        type: 'string',
        format: 'datetime',
        name: 'created_at',
        readableName: 'Created At',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      updated_at: {
        readOnly: true,
        nullable: false,
        type: 'string',
        format: 'datetime',
        name: 'updated_at',
        readableName: 'Updated At',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      display_name: {
        readOnly: true,
        nullable: true,
        type: 'string',
        name: 'display_name',
        readableName: 'Report',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      }
    },
    querySurface: {
      filterable: {
        id: {
          type: 'integer',
          format: 'identifier',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        observing: {
          type: 'string',
          operators: ['eq', 'diff']
        },
        report_status: {
          type: 'integer',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff', 'eq_coalesce', 'gteq_coalesce', 'lteq_coalesce', 'is_null']
        },
        reported_at: {
          type: 'string',
          format: 'datetime',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        venue: {
          type: 'string',
          operators: ['eq', 'diff', 'is_null']
        },
        created_at: {
          type: 'string',
          format: 'datetime',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        updated_at: {
          type: 'string',
          format: 'datetime',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        report_type: {
          type: 'reference',
          model: 'report_type',
          many: false,
          identifier: 'id',
          foreignKey: 'report_type_id',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        player: {
          type: 'reference',
          model: 'player',
          many: false,
          identifier: 'id',
          foreignKey: 'player_id',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        reporter: {
          type: 'reference',
          model: 'user',
          many: false,
          identifier: 'id',
          foreignKey: 'reporter_id',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        report_values: {
          type: 'reference',
          model: 'report_value',
          many: true,
          identifier: 'id',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        report_fields: {
          type: 'reference',
          model: 'report_field',
          many: true,
          identifier: 'id',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        }
      },
      orderable: ['id', 'observing', 'report_status', 'reported_at', 'venue', 'created_at', 'updated_at', 'report_type.id', 'report_type.name', 'report_type.created_at', 'report_type.updated_at', 'report_type.report_fields.id', 'report_type.report_fields.field_type', 'report_type.report_fields.name', 'report_type.report_fields.order', 'report_type.report_fields.required', 'report_type.report_fields.created_at', 'report_type.report_fields.updated_at', 'report_type.sport.id', 'report_type.sport.name', 'report_type.sport.created_at', 'report_type.sport.updated_at', 'player.id', 'player.country', 'player.dob_year', 'player.first_name', 'player.grad_year', 'player.hand', 'player.height_feet', 'player.height_inches', 'player.hometown', 'player.last_name', 'player.number', 'player.quick_rating', 'player.weight_lbs', 'player.created_at', 'player.updated_at', 'player.organization.id', 'player.organization.name', 'player.organization.created_at', 'player.organization.updated_at', 'player.player_positions.id', 'player.player_positions.created_at', 'player.player_positions.updated_at', 'player.positions.id', 'player.positions.abbreviation', 'player.positions.ancestry', 'player.positions.name', 'player.positions.created_at', 'player.positions.updated_at', 'player.rosters.id', 'player.rosters.number', 'player.rosters.quick_rating', 'player.rosters.rank', 'player.rosters.created_at', 'player.rosters.updated_at', 'player.current_roster.id', 'player.current_roster.number', 'player.current_roster.quick_rating', 'player.current_roster.rank', 'player.current_roster.created_at', 'player.current_roster.updated_at', 'player.external_linked_teams.id', 'player.external_linked_teams.team_name', 'player.external_linked_teams.created_at', 'player.external_linked_teams.updated_at', 'reporter.id', 'reporter.name', 'reporter.nickname', 'reporter.email', 'reporter.image', 'report_values.id', 'report_values.value', 'report_values.created_at', 'report_values.updated_at', 'report_values.report.id', 'report_values.report.observing', 'report_values.report.report_status', 'report_values.report.reported_at', 'report_values.report.venue', 'report_values.report.created_at', 'report_values.report.updated_at', 'report_values.report_field.id', 'report_values.report_field.field_type', 'report_values.report_field.name', 'report_values.report_field.order', 'report_values.report_field.required', 'report_values.report_field.created_at', 'report_values.report_field.updated_at', 'report_fields.id', 'report_fields.field_type', 'report_fields.name', 'report_fields.order', 'report_fields.required', 'report_fields.created_at', 'report_fields.updated_at', 'report_fields.report_type.id', 'report_fields.report_type.name', 'report_fields.report_type.created_at', 'report_fields.report_type.updated_at'],
      traversable: true,
      searchable: true,
      pagination: {
        defaultLimit: 20,
        maxLimit: 100
      }
    }
  },
  report_field: {
    meta: {
      model: 'report_field',
      modelPlural: 'report_fields',
      name: 'reportField',
      pluralName: 'reportFields',
      readableName: 'Report field',
      pluralReadableName: 'Report fields',
      ownedBy: 'report_type',
      singular: false,
      path: '/api/report_fields',
      searchable: false,
      kind: 'app'
    },
    properties: {
      id: {
        readOnly: true,
        nullable: false,
        type: 'integer',
        format: 'identifier',
        name: 'id',
        readableName: 'Id',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      field_type: {
        nullable: false,
        type: 'string',
        enum: ['text', 'rating'],
        name: 'field_type',
        readableName: 'Field Type',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      name: {
        nullable: true,
        type: 'string',
        name: 'name',
        readableName: 'Name',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      order: {
        nullable: false,
        type: 'integer',
        name: 'order',
        readableName: 'Order',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      required: {
        nullable: false,
        default: true,
        type: 'boolean',
        name: 'required',
        readableName: 'Required',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      report_type: {
        nullable: false,
        type: 'reference',
        anyOf: [{
          $ref: '#/components/schemas/report_type'
        }],
        name: 'report_type',
        readableName: 'Report Type',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      created_at: {
        readOnly: true,
        nullable: false,
        type: 'string',
        format: 'datetime',
        name: 'created_at',
        readableName: 'Created At',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      updated_at: {
        readOnly: true,
        nullable: false,
        type: 'string',
        format: 'datetime',
        name: 'updated_at',
        readableName: 'Updated At',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      display_name: {
        readOnly: true,
        nullable: true,
        type: 'string',
        name: 'display_name',
        readableName: 'Report field',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      }
    },
    querySurface: {
      filterable: {
        id: {
          type: 'integer',
          format: 'identifier',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        field_type: {
          type: 'string',
          operators: ['eq', 'diff']
        },
        name: {
          type: 'string',
          operators: ['eq', 'diff', 'is_null']
        },
        order: {
          type: 'integer',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        required: {
          type: 'boolean',
          operators: ['eq', 'diff']
        },
        created_at: {
          type: 'string',
          format: 'datetime',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        updated_at: {
          type: 'string',
          format: 'datetime',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        report_type: {
          type: 'reference',
          model: 'report_type',
          many: false,
          identifier: 'id',
          foreignKey: 'report_type_id',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        }
      },
      orderable: ['id', 'field_type', 'name', 'order', 'required', 'created_at', 'updated_at', 'report_type.id', 'report_type.name', 'report_type.created_at', 'report_type.updated_at', 'report_type.report_fields.id', 'report_type.report_fields.field_type', 'report_type.report_fields.name', 'report_type.report_fields.order', 'report_type.report_fields.required', 'report_type.report_fields.created_at', 'report_type.report_fields.updated_at', 'report_type.sport.id', 'report_type.sport.name', 'report_type.sport.created_at', 'report_type.sport.updated_at'],
      traversable: false,
      searchable: false,
      pagination: {
        defaultLimit: 20,
        maxLimit: 100
      }
    }
  },
  report_type: {
    meta: {
      model: 'report_type',
      modelPlural: 'report_types',
      name: 'reportType',
      pluralName: 'reportTypes',
      readableName: 'Report type',
      pluralReadableName: 'Report types',
      ownedBy: 'sport',
      singular: false,
      path: '/api/report_types',
      searchable: false,
      kind: 'app'
    },
    properties: {
      id: {
        readOnly: true,
        nullable: false,
        type: 'integer',
        format: 'identifier',
        name: 'id',
        readableName: 'Id',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      name: {
        nullable: true,
        type: 'string',
        name: 'name',
        readableName: 'Name',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      report_fields: {
        readOnly: true,
        nullable: true,
        type: 'array',
        items: {
          type: 'reference',
          anyOf: [{
            $ref: '#/components/schemas/report_field'
          }],
          'x-rhino-attribute-array': {}
        },
        name: 'report_fields',
        readableName: 'Report Fields',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      sport: {
        nullable: false,
        type: 'reference',
        anyOf: [{
          $ref: '#/components/schemas/sport'
        }],
        name: 'sport',
        readableName: 'Sport',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      created_at: {
        readOnly: true,
        nullable: false,
        type: 'string',
        format: 'datetime',
        name: 'created_at',
        readableName: 'Created At',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      updated_at: {
        readOnly: true,
        nullable: false,
        type: 'string',
        format: 'datetime',
        name: 'updated_at',
        readableName: 'Updated At',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      display_name: {
        readOnly: true,
        nullable: true,
        type: 'string',
        name: 'display_name',
        readableName: 'Report type',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      }
    },
    querySurface: {
      filterable: {
        id: {
          type: 'integer',
          format: 'identifier',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        name: {
          type: 'string',
          operators: ['eq', 'diff', 'is_null']
        },
        created_at: {
          type: 'string',
          format: 'datetime',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        updated_at: {
          type: 'string',
          format: 'datetime',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        report_fields: {
          type: 'reference',
          model: 'report_field',
          many: true,
          identifier: 'id',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        sport: {
          type: 'reference',
          model: 'sport',
          many: false,
          identifier: 'id',
          foreignKey: 'sport_id',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        }
      },
      orderable: ['id', 'name', 'created_at', 'updated_at', 'report_fields.id', 'report_fields.field_type', 'report_fields.name', 'report_fields.order', 'report_fields.required', 'report_fields.created_at', 'report_fields.updated_at', 'report_fields.report_type.id', 'report_fields.report_type.name', 'report_fields.report_type.created_at', 'report_fields.report_type.updated_at', 'sport.id', 'sport.name', 'sport.created_at', 'sport.updated_at'],
      traversable: false,
      searchable: false,
      pagination: {
        defaultLimit: 20,
        maxLimit: 100
      }
    }
  },
  report_value: {
    meta: {
      model: 'report_value',
      modelPlural: 'report_values',
      name: 'reportValue',
      pluralName: 'reportValues',
      readableName: 'Report value',
      pluralReadableName: 'Report values',
      ownedBy: 'report',
      singular: false,
      path: '/api/report_values',
      searchable: false,
      kind: 'app'
    },
    properties: {
      id: {
        readOnly: true,
        nullable: false,
        type: 'integer',
        format: 'identifier',
        name: 'id',
        readableName: 'Id',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      value: {
        nullable: true,
        type: 'string',
        name: 'value',
        readableName: 'Value',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      report: {
        nullable: false,
        type: 'reference',
        anyOf: [{
          $ref: '#/components/schemas/report'
        }],
        name: 'report',
        readableName: 'Report',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      report_field: {
        nullable: false,
        type: 'reference',
        anyOf: [{
          $ref: '#/components/schemas/report_field'
        }],
        name: 'report_field',
        readableName: 'Report Field',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      created_at: {
        readOnly: true,
        nullable: false,
        type: 'string',
        format: 'datetime',
        name: 'created_at',
        readableName: 'Created At',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      updated_at: {
        readOnly: true,
        nullable: false,
        type: 'string',
        format: 'datetime',
        name: 'updated_at',
        readableName: 'Updated At',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      display_name: {
        readOnly: true,
        nullable: true,
        type: 'string',
        name: 'display_name',
        readableName: 'Report value',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      }
    },
    querySurface: {
      filterable: {
        id: {
          type: 'integer',
          format: 'identifier',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        value: {
          type: 'string',
          operators: ['eq', 'diff', 'is_null']
        },
        created_at: {
          type: 'string',
          format: 'datetime',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        updated_at: {
          type: 'string',
          format: 'datetime',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        report: {
          type: 'reference',
          model: 'report',
          many: false,
          identifier: 'id',
          foreignKey: 'report_id',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        report_field: {
          type: 'reference',
          model: 'report_field',
          many: false,
          identifier: 'id',
          foreignKey: 'report_field_id',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        }
      },
      orderable: ['id', 'value', 'created_at', 'updated_at', 'report.id', 'report.observing', 'report.report_status', 'report.reported_at', 'report.venue', 'report.created_at', 'report.updated_at', 'report.report_type.id', 'report.report_type.name', 'report.report_type.created_at', 'report.report_type.updated_at', 'report.player.id', 'report.player.country', 'report.player.dob_year', 'report.player.first_name', 'report.player.grad_year', 'report.player.hand', 'report.player.height_feet', 'report.player.height_inches', 'report.player.hometown', 'report.player.last_name', 'report.player.number', 'report.player.quick_rating', 'report.player.weight_lbs', 'report.player.created_at', 'report.player.updated_at', 'report.reporter.id', 'report.reporter.name', 'report.reporter.nickname', 'report.reporter.email', 'report.reporter.image', 'report.report_values.id', 'report.report_values.value', 'report.report_values.created_at', 'report.report_values.updated_at', 'report.report_fields.id', 'report.report_fields.field_type', 'report.report_fields.name', 'report.report_fields.order', 'report.report_fields.required', 'report.report_fields.created_at', 'report.report_fields.updated_at', 'report_field.id', 'report_field.field_type', 'report_field.name', 'report_field.order', 'report_field.required', 'report_field.created_at', 'report_field.updated_at', 'report_field.report_type.id', 'report_field.report_type.name', 'report_field.report_type.created_at', 'report_field.report_type.updated_at'],
      traversable: true,
      searchable: false,
      pagination: {
        defaultLimit: 20,
        maxLimit: 100
      }
    }
  },
  rhino_notification: {
    meta: {
      model: 'rhino_notification',
      modelPlural: 'rhino_notifications',
      name: 'rhinoNotification',
      pluralName: 'rhinoNotifications',
      readableName: 'Notification',
      pluralReadableName: 'Notifications',
      ownedBy: 'user',
      singular: false,
      path: '/api/_rhino/notifications',
      searchable: false,
      kind: 'system'
    },
    properties: {
      id: {
        readOnly: true,
        nullable: false,
        type: 'integer',
        format: 'identifier',
        name: 'id',
        readableName: 'Id',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      key: {
        readOnly: true,
        nullable: false,
        type: 'string',
        name: 'key',
        readableName: 'Key',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      message: {
        readOnly: true,
        nullable: false,
        type: 'string',
        name: 'message',
        readableName: 'Message',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      url: {
        readOnly: true,
        nullable: true,
        type: 'string',
        name: 'url',
        readableName: 'Url',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      opened_at: {
        nullable: true,
        type: 'string',
        format: 'datetime',
        name: 'opened_at',
        readableName: 'Opened At',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      created_at: {
        readOnly: true,
        nullable: false,
        type: 'string',
        format: 'datetime',
        name: 'created_at',
        readableName: 'Created At',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      display_name: {
        readOnly: true,
        nullable: true,
        type: 'string',
        name: 'display_name',
        readableName: 'Notification',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      }
    },
    querySurface: {
      filterable: {
        id: {
          type: 'integer',
          format: 'identifier',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        key: {
          type: 'string',
          operators: ['eq', 'diff']
        },
        message: {
          type: 'string',
          operators: ['eq', 'diff']
        },
        url: {
          type: 'string',
          operators: ['eq', 'diff', 'is_null']
        },
        opened_at: {
          type: 'string',
          format: 'datetime',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff', 'eq_coalesce', 'gteq_coalesce', 'lteq_coalesce', 'is_null']
        },
        created_at: {
          type: 'string',
          format: 'datetime',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        }
      },
      orderable: ['id', 'key', 'message', 'url', 'opened_at', 'created_at'],
      traversable: false,
      searchable: false,
      pagination: {
        defaultLimit: 20,
        maxLimit: 100
      }
    }
  },
  rhino_package: {
    meta: {
      model: 'rhino_package',
      modelPlural: 'rhino_packages',
      name: 'rhinoPackage',
      pluralName: 'rhinoPackages',
      readableName: 'Package',
      pluralReadableName: 'Packages',
      ownedBy: 'global',
      singular: false,
      path: '/api/_rhino/packages',
      searchable: false,
      kind: 'system'
    },
    properties: {
      id: {
        readOnly: true,
        nullable: false,
        type: 'integer',
        format: 'identifier',
        name: 'id',
        readableName: 'Id',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      slug: {
        readOnly: true,
        nullable: false,
        type: 'string',
        name: 'slug',
        readableName: 'Slug',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      name: {
        readOnly: true,
        nullable: false,
        type: 'string',
        name: 'name',
        readableName: 'Name',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      kind: {
        readOnly: true,
        nullable: false,
        default: 'base',
        type: 'string',
        enum: ['standard', 'base', 'addon'],
        name: 'kind',
        readableName: 'Kind',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      features: {
        readOnly: true,
        nullable: true,
        default: [],
        type: 'array',
        items: {
          type: 'string'
        },
        name: 'features',
        readableName: 'Features',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      display_name: {
        readOnly: true,
        nullable: true,
        type: 'string',
        name: 'display_name',
        readableName: 'Package',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      }
    },
    querySurface: {
      filterable: {
        id: {
          type: 'integer',
          format: 'identifier',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        slug: {
          type: 'string',
          operators: ['eq', 'diff']
        },
        name: {
          type: 'string',
          operators: ['eq', 'diff']
        },
        kind: {
          type: 'string',
          operators: ['eq', 'diff']
        }
      },
      orderable: ['id', 'slug', 'name', 'kind'],
      traversable: false,
      searchable: false,
      pagination: {
        defaultLimit: 20,
        maxLimit: 100
      }
    }
  },
  rhino_subscription: {
    meta: {
      model: 'rhino_subscription',
      modelPlural: 'rhino_subscriptions',
      name: 'rhinoSubscription',
      pluralName: 'rhinoSubscriptions',
      readableName: 'Subscription',
      pluralReadableName: 'Subscriptions',
      ownedBy: 'base_owner',
      singular: false,
      path: '/api/_rhino/subscriptions',
      searchable: false,
      kind: 'system'
    },
    properties: {
      id: {
        readOnly: true,
        nullable: false,
        type: 'integer',
        format: 'identifier',
        name: 'id',
        readableName: 'Id',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      base_owner: {
        readOnly: true,
        nullable: false,
        type: 'reference',
        anyOf: [{
          $ref: '#/components/schemas/organization'
        }],
        name: 'base_owner',
        readableName: 'Base Owner',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      status: {
        readOnly: true,
        nullable: true,
        type: 'string',
        name: 'status',
        readableName: 'Status',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      current_period_end: {
        readOnly: true,
        nullable: true,
        type: 'string',
        format: 'datetime',
        name: 'current_period_end',
        readableName: 'Current Period End',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      subscription_items: {
        readOnly: true,
        nullable: true,
        type: 'array',
        items: {
          type: 'reference',
          anyOf: [{
            $ref: '#/components/schemas/rhino_subscription_item'
          }],
          'x-rhino-attribute-array': {}
        },
        name: 'subscription_items',
        readableName: 'Subscription Items',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      display_name: {
        readOnly: true,
        nullable: true,
        type: 'string',
        name: 'display_name',
        readableName: 'Subscription',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      }
    },
    querySurface: {
      filterable: {
        id: {
          type: 'integer',
          format: 'identifier',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        status: {
          type: 'string',
          operators: ['eq', 'diff', 'is_null']
        },
        current_period_end: {
          type: 'string',
          format: 'datetime',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff', 'eq_coalesce', 'gteq_coalesce', 'lteq_coalesce', 'is_null']
        },
        base_owner: {
          type: 'reference',
          model: 'organization',
          many: false,
          identifier: 'id',
          foreignKey: 'base_owner_id',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        subscription_items: {
          type: 'reference',
          model: 'rhino_subscription_item',
          many: true,
          identifier: 'id',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        }
      },
      orderable: ['id', 'status', 'current_period_end', 'base_owner.id', 'base_owner.name', 'base_owner.created_at', 'base_owner.updated_at', 'base_owner.logo_attachment.id', 'base_owner.logo_attachment.name', 'base_owner.logo_attachment.record_type', 'base_owner.logo_attachment.created_at', 'base_owner.sport.id', 'base_owner.sport.name', 'base_owner.sport.created_at', 'base_owner.sport.updated_at', 'base_owner.teams.id', 'base_owner.teams.name', 'base_owner.teams.created_at', 'base_owner.teams.updated_at', 'base_owner.users_roles.id', 'base_owner.users_roles.created_at', 'base_owner.users_roles.updated_at', 'subscription_items.id', 'subscription_items.expires_at', 'subscription_items.subscription.id', 'subscription_items.subscription.status', 'subscription_items.subscription.current_period_end', 'subscription_items.package.id', 'subscription_items.package.slug', 'subscription_items.package.name', 'subscription_items.package.kind'],
      traversable: true,
      searchable: false,
      pagination: {
        defaultLimit: 20,
        maxLimit: 100
      }
    }
  },
  rhino_subscription_item: {
    meta: {
      model: 'rhino_subscription_item',
      modelPlural: 'rhino_subscription_items',
      name: 'rhinoSubscriptionItem',
      pluralName: 'rhinoSubscriptionItems',
      readableName: 'Subscription item',
      pluralReadableName: 'Subscription items',
      ownedBy: 'subscription',
      singular: false,
      path: '/api/_rhino/subscription_items',
      searchable: false,
      kind: 'system'
    },
    properties: {
      id: {
        readOnly: true,
        nullable: false,
        type: 'integer',
        format: 'identifier',
        name: 'id',
        readableName: 'Id',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      subscription: {
        readOnly: true,
        nullable: false,
        type: 'reference',
        anyOf: [{
          $ref: '#/components/schemas/rhino_subscription'
        }],
        name: 'subscription',
        readableName: 'Subscription',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      package: {
        readOnly: true,
        nullable: false,
        type: 'reference',
        anyOf: [{
          $ref: '#/components/schemas/rhino_package'
        }],
        name: 'package',
        readableName: 'Package',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      expires_at: {
        readOnly: true,
        nullable: true,
        type: 'string',
        format: 'datetime',
        name: 'expires_at',
        readableName: 'Expires At',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      display_name: {
        readOnly: true,
        nullable: true,
        type: 'string',
        name: 'display_name',
        readableName: 'Subscription item',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      }
    },
    querySurface: {
      filterable: {
        id: {
          type: 'integer',
          format: 'identifier',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        expires_at: {
          type: 'string',
          format: 'datetime',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff', 'eq_coalesce', 'gteq_coalesce', 'lteq_coalesce', 'is_null']
        },
        subscription: {
          type: 'reference',
          model: 'rhino_subscription',
          many: false,
          identifier: 'id',
          foreignKey: 'subscription_id',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        package: {
          type: 'reference',
          model: 'rhino_package',
          many: false,
          identifier: 'id',
          foreignKey: 'package_id',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        }
      },
      orderable: ['id', 'expires_at', 'subscription.id', 'subscription.status', 'subscription.current_period_end', 'subscription.base_owner.id', 'subscription.base_owner.name', 'subscription.base_owner.created_at', 'subscription.base_owner.updated_at', 'subscription.subscription_items.id', 'subscription.subscription_items.expires_at', 'package.id', 'package.slug', 'package.name', 'package.kind'],
      traversable: true,
      searchable: false,
      pagination: {
        defaultLimit: 20,
        maxLimit: 100
      }
    }
  },
  role: {
    meta: {
      model: 'role',
      modelPlural: 'roles',
      name: 'role',
      pluralName: 'roles',
      readableName: 'Role',
      pluralReadableName: 'Roles',
      ownedBy: 'global',
      singular: false,
      path: '/api/roles',
      searchable: false,
      kind: 'core'
    },
    properties: {
      id: {
        readOnly: true,
        nullable: false,
        type: 'integer',
        format: 'identifier',
        name: 'id',
        readableName: 'Id',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      name: {
        nullable: false,
        type: 'string',
        pattern: '^[a-zA-Z_]+$',
        name: 'name',
        readableName: 'Name',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      created_at: {
        readOnly: true,
        nullable: false,
        type: 'string',
        format: 'datetime',
        name: 'created_at',
        readableName: 'Created At',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      updated_at: {
        readOnly: true,
        nullable: false,
        type: 'string',
        format: 'datetime',
        name: 'updated_at',
        readableName: 'Updated At',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      display_name: {
        readOnly: true,
        nullable: true,
        type: 'string',
        name: 'display_name',
        readableName: 'Role',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      }
    },
    querySurface: {
      filterable: {
        id: {
          type: 'integer',
          format: 'identifier',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        name: {
          type: 'string',
          operators: ['eq', 'diff']
        },
        created_at: {
          type: 'string',
          format: 'datetime',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        updated_at: {
          type: 'string',
          format: 'datetime',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        }
      },
      orderable: ['id', 'name', 'created_at', 'updated_at'],
      traversable: false,
      searchable: false,
      pagination: {
        defaultLimit: 20,
        maxLimit: 100
      }
    }
  },
  roster: {
    meta: {
      model: 'roster',
      modelPlural: 'rosters',
      name: 'roster',
      pluralName: 'rosters',
      readableName: 'Roster',
      pluralReadableName: 'Rosters',
      ownedBy: 'player',
      singular: false,
      path: '/api/rosters',
      searchable: true,
      kind: 'app'
    },
    properties: {
      id: {
        readOnly: true,
        nullable: false,
        type: 'integer',
        format: 'identifier',
        name: 'id',
        readableName: 'Id',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      number: {
        nullable: true,
        type: 'string',
        pattern: '^\\d*$',
        maxLength: 3,
        name: 'number',
        readableName: 'Number',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      quick_rating: {
        readOnly: true,
        nullable: true,
        type: 'number',
        format: 'double',
        name: 'quick_rating',
        readableName: 'Quick Rating',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      rank: {
        nullable: true,
        type: 'integer',
        name: 'rank',
        readableName: 'Rank',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      player: {
        nullable: false,
        type: 'reference',
        anyOf: [{
          $ref: '#/components/schemas/player'
        }],
        name: 'player',
        readableName: 'Player',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      team_season: {
        nullable: false,
        type: 'reference',
        anyOf: [{
          $ref: '#/components/schemas/team_season'
        }],
        name: 'team_season',
        readableName: 'Team Season',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      roster_status: {
        nullable: false,
        type: 'reference',
        anyOf: [{
          $ref: '#/components/schemas/roster_status'
        }],
        name: 'roster_status',
        readableName: 'Roster Status',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      created_at: {
        readOnly: true,
        nullable: false,
        type: 'string',
        format: 'datetime',
        name: 'created_at',
        readableName: 'Created At',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      updated_at: {
        readOnly: true,
        nullable: false,
        type: 'string',
        format: 'datetime',
        name: 'updated_at',
        readableName: 'Updated At',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      display_name: {
        readOnly: true,
        nullable: true,
        type: 'string',
        name: 'display_name',
        readableName: 'Roster',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      }
    },
    querySurface: {
      filterable: {
        id: {
          type: 'integer',
          format: 'identifier',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        number: {
          type: 'string',
          operators: ['eq', 'diff', 'is_null']
        },
        quick_rating: {
          type: 'number',
          format: 'double',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff', 'eq_coalesce', 'gteq_coalesce', 'lteq_coalesce', 'is_null']
        },
        rank: {
          type: 'integer',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff', 'eq_coalesce', 'gteq_coalesce', 'lteq_coalesce', 'is_null']
        },
        created_at: {
          type: 'string',
          format: 'datetime',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        updated_at: {
          type: 'string',
          format: 'datetime',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        player: {
          type: 'reference',
          model: 'player',
          many: false,
          identifier: 'id',
          foreignKey: 'player_id',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        team_season: {
          type: 'reference',
          model: 'team_season',
          many: false,
          identifier: 'id',
          foreignKey: 'team_season_id',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        roster_status: {
          type: 'reference',
          model: 'roster_status',
          many: false,
          identifier: 'id',
          foreignKey: 'roster_status_id',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        }
      },
      orderable: ['id', 'number', 'quick_rating', 'rank', 'created_at', 'updated_at', 'player.id', 'player.country', 'player.dob_year', 'player.first_name', 'player.grad_year', 'player.hand', 'player.height_feet', 'player.height_inches', 'player.hometown', 'player.last_name', 'player.number', 'player.quick_rating', 'player.weight_lbs', 'player.created_at', 'player.updated_at', 'player.organization.id', 'player.organization.name', 'player.organization.created_at', 'player.organization.updated_at', 'player.player_positions.id', 'player.player_positions.created_at', 'player.player_positions.updated_at', 'player.positions.id', 'player.positions.abbreviation', 'player.positions.ancestry', 'player.positions.name', 'player.positions.created_at', 'player.positions.updated_at', 'player.rosters.id', 'player.rosters.number', 'player.rosters.quick_rating', 'player.rosters.rank', 'player.rosters.created_at', 'player.rosters.updated_at', 'player.current_roster.id', 'player.current_roster.number', 'player.current_roster.quick_rating', 'player.current_roster.rank', 'player.current_roster.created_at', 'player.current_roster.updated_at', 'player.external_linked_teams.id', 'player.external_linked_teams.team_name', 'player.external_linked_teams.created_at', 'player.external_linked_teams.updated_at', 'team_season.id', 'team_season.calendar_embed_url', 'team_season.calendar_ics_url', 'team_season.stats', 'team_season.status', 'team_season.created_at', 'team_season.updated_at', 'team_season.season.id', 'team_season.season.name', 'team_season.season.starts_on', 'team_season.season.created_at', 'team_season.season.updated_at', 'team_season.team.id', 'team_season.team.name', 'team_season.team.created_at', 'team_season.team.updated_at', 'roster_status.id', 'roster_status.name', 'roster_status.order', 'roster_status.status_type', 'roster_status.created_at', 'roster_status.updated_at', 'roster_status.organization.id', 'roster_status.organization.name', 'roster_status.organization.created_at', 'roster_status.organization.updated_at'],
      traversable: true,
      searchable: true,
      pagination: {
        defaultLimit: 1000,
        maxLimit: 1000
      }
    }
  },
  roster_status: {
    meta: {
      model: 'roster_status',
      modelPlural: 'roster_statuses',
      name: 'rosterStatus',
      pluralName: 'rosterStatuses',
      readableName: 'Roster status',
      pluralReadableName: 'Roster statuses',
      ownedBy: 'organization',
      singular: false,
      path: '/api/roster_statuses',
      searchable: false,
      kind: 'app'
    },
    properties: {
      id: {
        readOnly: true,
        nullable: false,
        type: 'integer',
        format: 'identifier',
        name: 'id',
        readableName: 'Id',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      name: {
        nullable: false,
        type: 'string',
        name: 'name',
        readableName: 'Name',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      order: {
        nullable: false,
        type: 'integer',
        name: 'order',
        readableName: 'Order',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      status_type: {
        nullable: false,
        type: 'string',
        enum: ['planning', 'active', 'archived'],
        name: 'status_type',
        readableName: 'Status Type',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      organization: {
        nullable: false,
        type: 'reference',
        anyOf: [{
          $ref: '#/components/schemas/organization'
        }],
        name: 'organization',
        readableName: 'Organization',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      created_at: {
        readOnly: true,
        nullable: false,
        type: 'string',
        format: 'datetime',
        name: 'created_at',
        readableName: 'Created At',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      updated_at: {
        readOnly: true,
        nullable: false,
        type: 'string',
        format: 'datetime',
        name: 'updated_at',
        readableName: 'Updated At',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      display_name: {
        readOnly: true,
        nullable: true,
        type: 'string',
        name: 'display_name',
        readableName: 'Roster status',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      }
    },
    querySurface: {
      filterable: {
        id: {
          type: 'integer',
          format: 'identifier',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        name: {
          type: 'string',
          operators: ['eq', 'diff']
        },
        order: {
          type: 'integer',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        status_type: {
          type: 'string',
          operators: ['eq', 'diff']
        },
        created_at: {
          type: 'string',
          format: 'datetime',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        updated_at: {
          type: 'string',
          format: 'datetime',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        organization: {
          type: 'reference',
          model: 'organization',
          many: false,
          identifier: 'id',
          foreignKey: 'organization_id',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        }
      },
      orderable: ['id', 'name', 'order', 'status_type', 'created_at', 'updated_at', 'organization.id', 'organization.name', 'organization.created_at', 'organization.updated_at', 'organization.logo_attachment.id', 'organization.logo_attachment.name', 'organization.logo_attachment.record_type', 'organization.logo_attachment.created_at', 'organization.sport.id', 'organization.sport.name', 'organization.sport.created_at', 'organization.sport.updated_at', 'organization.teams.id', 'organization.teams.name', 'organization.teams.created_at', 'organization.teams.updated_at', 'organization.users_roles.id', 'organization.users_roles.created_at', 'organization.users_roles.updated_at'],
      traversable: true,
      searchable: false,
      pagination: {
        defaultLimit: 1000,
        maxLimit: 1000
      }
    }
  },
  season: {
    meta: {
      model: 'season',
      modelPlural: 'seasons',
      name: 'season',
      pluralName: 'seasons',
      readableName: 'Season',
      pluralReadableName: 'Seasons',
      ownedBy: 'sport',
      singular: false,
      path: '/api/seasons',
      searchable: false,
      kind: 'app'
    },
    properties: {
      id: {
        readOnly: true,
        nullable: false,
        type: 'integer',
        format: 'identifier',
        name: 'id',
        readableName: 'Id',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      name: {
        nullable: true,
        type: 'string',
        name: 'name',
        readableName: 'Name',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      starts_on: {
        nullable: false,
        type: 'string',
        format: 'date',
        name: 'starts_on',
        readableName: 'Starts On',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      sport: {
        nullable: false,
        type: 'reference',
        anyOf: [{
          $ref: '#/components/schemas/sport'
        }],
        name: 'sport',
        readableName: 'Sport',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      created_at: {
        readOnly: true,
        nullable: false,
        type: 'string',
        format: 'datetime',
        name: 'created_at',
        readableName: 'Created At',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      updated_at: {
        readOnly: true,
        nullable: false,
        type: 'string',
        format: 'datetime',
        name: 'updated_at',
        readableName: 'Updated At',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      display_name: {
        readOnly: true,
        nullable: true,
        type: 'string',
        name: 'display_name',
        readableName: 'Season',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      }
    },
    querySurface: {
      filterable: {
        id: {
          type: 'integer',
          format: 'identifier',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        name: {
          type: 'string',
          operators: ['eq', 'diff', 'is_null']
        },
        starts_on: {
          type: 'string',
          format: 'date',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        created_at: {
          type: 'string',
          format: 'datetime',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        updated_at: {
          type: 'string',
          format: 'datetime',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        sport: {
          type: 'reference',
          model: 'sport',
          many: false,
          identifier: 'id',
          foreignKey: 'sport_id',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        }
      },
      orderable: ['id', 'name', 'starts_on', 'created_at', 'updated_at', 'sport.id', 'sport.name', 'sport.created_at', 'sport.updated_at'],
      traversable: false,
      searchable: false,
      pagination: {
        defaultLimit: 20,
        maxLimit: 100
      }
    }
  },
  sport: {
    meta: {
      model: 'sport',
      modelPlural: 'sports',
      name: 'sport',
      pluralName: 'sports',
      readableName: 'Sport',
      pluralReadableName: 'Sports',
      ownedBy: 'global',
      singular: false,
      path: '/api/sports',
      searchable: false,
      kind: 'app'
    },
    properties: {
      id: {
        readOnly: true,
        nullable: false,
        type: 'integer',
        format: 'identifier',
        name: 'id',
        readableName: 'Id',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      name: {
        nullable: true,
        type: 'string',
        name: 'name',
        readableName: 'Name',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      created_at: {
        readOnly: true,
        nullable: false,
        type: 'string',
        format: 'datetime',
        name: 'created_at',
        readableName: 'Created At',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      updated_at: {
        readOnly: true,
        nullable: false,
        type: 'string',
        format: 'datetime',
        name: 'updated_at',
        readableName: 'Updated At',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      display_name: {
        readOnly: true,
        nullable: true,
        type: 'string',
        name: 'display_name',
        readableName: 'Sport',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      }
    },
    querySurface: {
      filterable: {
        id: {
          type: 'integer',
          format: 'identifier',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        name: {
          type: 'string',
          operators: ['eq', 'diff', 'is_null']
        },
        created_at: {
          type: 'string',
          format: 'datetime',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        updated_at: {
          type: 'string',
          format: 'datetime',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        }
      },
      orderable: ['id', 'name', 'created_at', 'updated_at'],
      traversable: false,
      searchable: false,
      pagination: {
        defaultLimit: 20,
        maxLimit: 100
      }
    }
  },
  team: {
    meta: {
      model: 'team',
      modelPlural: 'teams',
      name: 'team',
      pluralName: 'teams',
      readableName: 'Team',
      pluralReadableName: 'Teams',
      ownedBy: 'organization',
      singular: false,
      path: '/api/teams',
      searchable: false,
      kind: 'app'
    },
    properties: {
      id: {
        readOnly: true,
        nullable: false,
        type: 'integer',
        format: 'identifier',
        name: 'id',
        readableName: 'Id',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      name: {
        nullable: false,
        type: 'string',
        name: 'name',
        readableName: 'Name',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      organization: {
        nullable: false,
        type: 'reference',
        anyOf: [{
          $ref: '#/components/schemas/organization'
        }],
        name: 'organization',
        readableName: 'Organization',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      team_seasons: {
        nullable: true,
        type: 'array',
        items: {
          type: 'reference',
          anyOf: [{
            $ref: '#/components/schemas/team_season'
          }],
          'x-rhino-attribute-array': {
            creatable: true,
            updatable: true,
            destroyable: false
          }
        },
        name: 'team_seasons',
        readableName: 'Team Seasons',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      created_at: {
        readOnly: true,
        nullable: false,
        type: 'string',
        format: 'datetime',
        name: 'created_at',
        readableName: 'Created At',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      updated_at: {
        readOnly: true,
        nullable: false,
        type: 'string',
        format: 'datetime',
        name: 'updated_at',
        readableName: 'Updated At',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      display_name: {
        readOnly: true,
        nullable: true,
        type: 'string',
        name: 'display_name',
        readableName: 'Team',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      }
    },
    querySurface: {
      filterable: {
        id: {
          type: 'integer',
          format: 'identifier',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        name: {
          type: 'string',
          operators: ['eq', 'diff']
        },
        created_at: {
          type: 'string',
          format: 'datetime',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        updated_at: {
          type: 'string',
          format: 'datetime',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        organization: {
          type: 'reference',
          model: 'organization',
          many: false,
          identifier: 'id',
          foreignKey: 'organization_id',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        team_seasons: {
          type: 'reference',
          model: 'team_season',
          many: true,
          identifier: 'id',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        }
      },
      orderable: ['id', 'name', 'created_at', 'updated_at', 'organization.id', 'organization.name', 'organization.created_at', 'organization.updated_at', 'organization.logo_attachment.id', 'organization.logo_attachment.name', 'organization.logo_attachment.record_type', 'organization.logo_attachment.created_at', 'organization.sport.id', 'organization.sport.name', 'organization.sport.created_at', 'organization.sport.updated_at', 'organization.teams.id', 'organization.teams.name', 'organization.teams.created_at', 'organization.teams.updated_at', 'organization.users_roles.id', 'organization.users_roles.created_at', 'organization.users_roles.updated_at', 'team_seasons.id', 'team_seasons.calendar_embed_url', 'team_seasons.calendar_ics_url', 'team_seasons.stats', 'team_seasons.status', 'team_seasons.created_at', 'team_seasons.updated_at', 'team_seasons.season.id', 'team_seasons.season.name', 'team_seasons.season.starts_on', 'team_seasons.season.created_at', 'team_seasons.season.updated_at', 'team_seasons.team.id', 'team_seasons.team.name', 'team_seasons.team.created_at', 'team_seasons.team.updated_at'],
      traversable: true,
      searchable: false,
      pagination: {
        defaultLimit: 20,
        maxLimit: 100
      }
    }
  },
  team_season: {
    meta: {
      model: 'team_season',
      modelPlural: 'team_seasons',
      name: 'teamSeason',
      pluralName: 'teamSeasons',
      readableName: 'Team season',
      pluralReadableName: 'Team seasons',
      ownedBy: 'team',
      singular: false,
      path: '/api/team_seasons',
      searchable: false,
      kind: 'app'
    },
    properties: {
      id: {
        readOnly: true,
        nullable: false,
        type: 'integer',
        format: 'identifier',
        name: 'id',
        readableName: 'Id',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      calendar_embed_url: {
        nullable: true,
        type: 'string',
        name: 'calendar_embed_url',
        readableName: 'Calendar Embed Url',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      calendar_ics_url: {
        nullable: true,
        type: 'string',
        name: 'calendar_ics_url',
        readableName: 'Calendar Ics Url',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      rating_avg: {
        nullable: true,
        type: 'number',
        format: 'double',
        name: 'rating_avg',
        readableName: 'Rating Avg',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      roster_accepted: {
        nullable: true,
        type: 'integer',
        name: 'roster_accepted',
        readableName: 'Roster Accepted',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      start_with: {
        nullable: true,
        default: 'none',
        type: 'string',
        name: 'start_with',
        readableName: 'Start With',
        readable: true,
        creatable: true,
        updatable: false,
        required: false
      },
      start_with_file: {
        nullable: true,
        type: 'string',
        name: 'start_with_file',
        readableName: 'Start With File',
        readable: true,
        creatable: true,
        updatable: false,
        required: false
      },
      stats: {
        nullable: false,
        default: {},
        type: 'jsonb',
        name: 'stats',
        readableName: 'Stats',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      status: {
        nullable: false,
        default: 'planning',
        type: 'string',
        enum: ['planning', 'active', 'archived'],
        name: 'status',
        readableName: 'Status',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      season: {
        nullable: false,
        type: 'reference',
        anyOf: [{
          $ref: '#/components/schemas/season'
        }],
        name: 'season',
        readableName: 'Season',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      team: {
        nullable: false,
        type: 'reference',
        anyOf: [{
          $ref: '#/components/schemas/team'
        }],
        name: 'team',
        readableName: 'Team',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      created_at: {
        readOnly: true,
        nullable: false,
        type: 'string',
        format: 'datetime',
        name: 'created_at',
        readableName: 'Created At',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      updated_at: {
        readOnly: true,
        nullable: false,
        type: 'string',
        format: 'datetime',
        name: 'updated_at',
        readableName: 'Updated At',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      display_name: {
        readOnly: true,
        nullable: true,
        type: 'string',
        name: 'display_name',
        readableName: 'Team season',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      }
    },
    querySurface: {
      filterable: {
        id: {
          type: 'integer',
          format: 'identifier',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        calendar_embed_url: {
          type: 'string',
          operators: ['eq', 'diff', 'is_null']
        },
        calendar_ics_url: {
          type: 'string',
          operators: ['eq', 'diff', 'is_null']
        },
        stats: {
          type: 'jsonb',
          operators: ['eq', 'diff']
        },
        status: {
          type: 'string',
          operators: ['eq', 'diff']
        },
        created_at: {
          type: 'string',
          format: 'datetime',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        updated_at: {
          type: 'string',
          format: 'datetime',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        season: {
          type: 'reference',
          model: 'season',
          many: false,
          identifier: 'id',
          foreignKey: 'season_id',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        team: {
          type: 'reference',
          model: 'team',
          many: false,
          identifier: 'id',
          foreignKey: 'team_id',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        }
      },
      orderable: ['id', 'calendar_embed_url', 'calendar_ics_url', 'stats', 'status', 'created_at', 'updated_at', 'season.id', 'season.name', 'season.starts_on', 'season.created_at', 'season.updated_at', 'season.sport.id', 'season.sport.name', 'season.sport.created_at', 'season.sport.updated_at', 'team.id', 'team.name', 'team.created_at', 'team.updated_at', 'team.organization.id', 'team.organization.name', 'team.organization.created_at', 'team.organization.updated_at', 'team.team_seasons.id', 'team.team_seasons.calendar_embed_url', 'team.team_seasons.calendar_ics_url', 'team.team_seasons.stats', 'team.team_seasons.status', 'team.team_seasons.created_at', 'team.team_seasons.updated_at'],
      traversable: true,
      searchable: false,
      pagination: {
        defaultLimit: 20,
        maxLimit: 100
      }
    }
  },
  user: {
    meta: {
      model: 'user',
      modelPlural: 'users',
      name: 'user',
      pluralName: 'users',
      readableName: 'User',
      pluralReadableName: 'Users',
      ownedBy: null,
      singular: false,
      path: '/api/users',
      searchable: false,
      kind: 'core'
    },
    properties: {
      id: {
        readOnly: true,
        nullable: false,
        type: 'integer',
        format: 'identifier',
        name: 'id',
        readableName: 'Id',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      name: {
        nullable: true,
        type: 'string',
        name: 'name',
        readableName: 'Name',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      nickname: {
        nullable: true,
        type: 'string',
        name: 'nickname',
        readableName: 'Nickname',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      email: {
        nullable: false,
        type: 'string',
        pattern: '^[^@\\s]+@[^@\\s]+$',
        name: 'email',
        readableName: 'Email',
        readable: true,
        creatable: true,
        updatable: false,
        required: true
      },
      image: {
        readOnly: true,
        nullable: true,
        type: 'string',
        name: 'image',
        readableName: 'Image',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      users_roles: {
        readOnly: true,
        nullable: true,
        type: 'array',
        items: {
          type: 'reference',
          anyOf: [{
            $ref: '#/components/schemas/users_role'
          }],
          'x-rhino-attribute-array': {}
        },
        name: 'users_roles',
        readableName: 'Users Roles',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      display_name: {
        readOnly: true,
        nullable: true,
        type: 'string',
        name: 'display_name',
        readableName: 'User',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      }
    },
    querySurface: {
      filterable: {
        id: {
          type: 'integer',
          format: 'identifier',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        name: {
          type: 'string',
          operators: ['eq', 'diff', 'is_null']
        },
        nickname: {
          type: 'string',
          operators: ['eq', 'diff', 'is_null']
        },
        email: {
          type: 'string',
          operators: ['eq', 'diff', 'is_null']
        },
        image: {
          type: 'string',
          operators: ['eq', 'diff', 'is_null']
        },
        users_roles: {
          type: 'reference',
          model: 'users_role',
          many: true,
          identifier: 'id',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        }
      },
      orderable: ['id', 'name', 'nickname', 'email', 'image'],
      traversable: false,
      searchable: false,
      pagination: {
        defaultLimit: 20,
        maxLimit: 100
      }
    }
  },
  users_role: {
    meta: {
      model: 'users_role',
      modelPlural: 'users_roles',
      name: 'usersRole',
      pluralName: 'usersRoles',
      readableName: 'Access',
      pluralReadableName: 'Access',
      ownedBy: 'organization',
      singular: false,
      path: '/api/users_roles',
      searchable: false,
      kind: 'core'
    },
    properties: {
      id: {
        readOnly: true,
        nullable: false,
        type: 'integer',
        format: 'identifier',
        name: 'id',
        readableName: 'Id',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      user: {
        nullable: false,
        type: 'reference',
        anyOf: [{
          $ref: '#/components/schemas/user'
        }],
        name: 'user',
        readableName: 'User',
        readable: true,
        creatable: true,
        updatable: false,
        required: true
      },
      role: {
        nullable: false,
        type: 'reference',
        anyOf: [{
          $ref: '#/components/schemas/role'
        }],
        name: 'role',
        readableName: 'Role',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      organization: {
        nullable: false,
        type: 'reference',
        anyOf: [{
          $ref: '#/components/schemas/organization'
        }],
        name: 'organization',
        readableName: 'Organization',
        readable: true,
        creatable: true,
        updatable: false,
        required: true
      },
      created_at: {
        readOnly: true,
        nullable: false,
        type: 'string',
        format: 'datetime',
        name: 'created_at',
        readableName: 'Created At',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      updated_at: {
        readOnly: true,
        nullable: false,
        type: 'string',
        format: 'datetime',
        name: 'updated_at',
        readableName: 'Updated At',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      display_name: {
        readOnly: true,
        nullable: true,
        type: 'string',
        name: 'display_name',
        readableName: 'Access',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      }
    },
    querySurface: {
      filterable: {
        id: {
          type: 'integer',
          format: 'identifier',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        created_at: {
          type: 'string',
          format: 'datetime',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        updated_at: {
          type: 'string',
          format: 'datetime',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        user: {
          type: 'reference',
          model: 'user',
          many: false,
          identifier: 'id',
          foreignKey: 'user_id',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        role: {
          type: 'reference',
          model: 'role',
          many: false,
          identifier: 'id',
          foreignKey: 'role_id',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        organization: {
          type: 'reference',
          model: 'organization',
          many: false,
          identifier: 'id',
          foreignKey: 'organization_id',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        }
      },
      orderable: ['id', 'created_at', 'updated_at', 'user.id', 'user.name', 'user.nickname', 'user.email', 'user.image', 'role.id', 'role.name', 'role.created_at', 'role.updated_at', 'organization.id', 'organization.name', 'organization.created_at', 'organization.updated_at', 'organization.logo_attachment.id', 'organization.logo_attachment.name', 'organization.logo_attachment.record_type', 'organization.logo_attachment.created_at', 'organization.sport.id', 'organization.sport.name', 'organization.sport.created_at', 'organization.sport.updated_at', 'organization.teams.id', 'organization.teams.name', 'organization.teams.created_at', 'organization.teams.updated_at', 'organization.users_roles.id', 'organization.users_roles.created_at', 'organization.users_roles.updated_at'],
      traversable: true,
      searchable: false,
      pagination: {
        defaultLimit: 20,
        maxLimit: 100
      }
    }
  },
  users_role_invite: {
    meta: {
      model: 'users_role_invite',
      modelPlural: 'users_role_invites',
      name: 'usersRoleInvite',
      pluralName: 'usersRoleInvites',
      readableName: 'Users role invite',
      pluralReadableName: 'Users role invites',
      ownedBy: 'organization',
      singular: false,
      path: '/api/users_role_invites',
      searchable: false,
      kind: 'core'
    },
    properties: {
      id: {
        readOnly: true,
        nullable: false,
        type: 'integer',
        format: 'identifier',
        name: 'id',
        readableName: 'Id',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      email: {
        nullable: false,
        type: 'string',
        pattern: '^[^@\\s]+@[^@\\s]+$',
        name: 'email',
        readableName: 'Email',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      role: {
        nullable: false,
        type: 'reference',
        anyOf: [{
          $ref: '#/components/schemas/role'
        }],
        name: 'role',
        readableName: 'Role',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      organization: {
        nullable: false,
        type: 'reference',
        anyOf: [{
          $ref: '#/components/schemas/organization'
        }],
        name: 'organization',
        readableName: 'Organization',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      created_at: {
        readOnly: true,
        nullable: false,
        type: 'string',
        format: 'datetime',
        name: 'created_at',
        readableName: 'Created At',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      updated_at: {
        readOnly: true,
        nullable: false,
        type: 'string',
        format: 'datetime',
        name: 'updated_at',
        readableName: 'Updated At',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      display_name: {
        readOnly: true,
        nullable: true,
        type: 'string',
        name: 'display_name',
        readableName: 'Users role invite',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      }
    },
    querySurface: {
      filterable: {
        id: {
          type: 'integer',
          format: 'identifier',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        email: {
          type: 'string',
          operators: ['eq', 'diff']
        },
        created_at: {
          type: 'string',
          format: 'datetime',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        updated_at: {
          type: 'string',
          format: 'datetime',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        role: {
          type: 'reference',
          model: 'role',
          many: false,
          identifier: 'id',
          foreignKey: 'role_id',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        organization: {
          type: 'reference',
          model: 'organization',
          many: false,
          identifier: 'id',
          foreignKey: 'organization_id',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        }
      },
      orderable: ['id', 'email', 'created_at', 'updated_at', 'role.id', 'role.name', 'role.created_at', 'role.updated_at', 'organization.id', 'organization.name', 'organization.created_at', 'organization.updated_at', 'organization.logo_attachment.id', 'organization.logo_attachment.name', 'organization.logo_attachment.record_type', 'organization.logo_attachment.created_at', 'organization.sport.id', 'organization.sport.name', 'organization.sport.created_at', 'organization.sport.updated_at', 'organization.teams.id', 'organization.teams.name', 'organization.teams.created_at', 'organization.teams.updated_at', 'organization.users_roles.id', 'organization.users_roles.created_at', 'organization.users_roles.updated_at'],
      traversable: true,
      searchable: false,
      pagination: {
        defaultLimit: 20,
        maxLimit: 100
      }
    }
  },
  video: {
    meta: {
      model: 'video',
      modelPlural: 'videos',
      name: 'video',
      pluralName: 'videos',
      readableName: 'Video',
      pluralReadableName: 'Videos',
      ownedBy: 'team_season',
      singular: false,
      path: '/api/videos',
      searchable: true,
      kind: 'app'
    },
    properties: {
      id: {
        readOnly: true,
        nullable: false,
        type: 'integer',
        format: 'identifier',
        name: 'id',
        readableName: 'Id',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      category: {
        nullable: false,
        type: 'string',
        enum: ['time_based', 'system'],
        name: 'category',
        readableName: 'Category',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      description: {
        nullable: true,
        type: 'text',
        name: 'description',
        readableName: 'Description',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      scheduled_at: {
        nullable: true,
        type: 'string',
        format: 'date',
        name: 'scheduled_at',
        readableName: 'Scheduled At',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      system: {
        nullable: true,
        type: 'string',
        enum: ['forecheck', 'backcheck', 'breakout', 'neutral_zone_offense', 'neutral_zone_defense', 'offensive_zone', 'defensive_zone', 'power_play', 'penalty_kill', 'faceoff', 'transition', 'goaltending', 'skill'],
        name: 'system',
        readableName: 'System',
        readable: true,
        creatable: true,
        updatable: true,
        required: false
      },
      title: {
        nullable: false,
        type: 'string',
        name: 'title',
        readableName: 'Title',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      url: {
        nullable: false,
        type: 'string',
        name: 'url',
        readableName: 'Url',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      team_season: {
        nullable: false,
        type: 'reference',
        anyOf: [{
          $ref: '#/components/schemas/team_season'
        }],
        name: 'team_season',
        readableName: 'Team Season',
        readable: true,
        creatable: true,
        updatable: true,
        required: true
      },
      created_at: {
        readOnly: true,
        nullable: false,
        type: 'string',
        format: 'datetime',
        name: 'created_at',
        readableName: 'Created At',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      updated_at: {
        readOnly: true,
        nullable: false,
        type: 'string',
        format: 'datetime',
        name: 'updated_at',
        readableName: 'Updated At',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      },
      display_name: {
        readOnly: true,
        nullable: true,
        type: 'string',
        name: 'display_name',
        readableName: 'Video',
        readable: true,
        creatable: false,
        updatable: false,
        required: false
      }
    },
    querySurface: {
      filterable: {
        id: {
          type: 'integer',
          format: 'identifier',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        category: {
          type: 'string',
          operators: ['eq', 'diff']
        },
        description: {
          type: 'text',
          operators: ['eq', 'diff', 'is_null']
        },
        scheduled_at: {
          type: 'string',
          format: 'date',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff', 'eq_coalesce', 'gteq_coalesce', 'lteq_coalesce', 'is_null']
        },
        system: {
          type: 'string',
          operators: ['eq', 'diff', 'is_null']
        },
        title: {
          type: 'string',
          operators: ['eq', 'diff']
        },
        url: {
          type: 'string',
          operators: ['eq', 'diff']
        },
        created_at: {
          type: 'string',
          format: 'datetime',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        updated_at: {
          type: 'string',
          format: 'datetime',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        },
        team_season: {
          type: 'reference',
          model: 'team_season',
          many: false,
          identifier: 'id',
          foreignKey: 'team_season_id',
          operators: ['eq', 'gt', 'lt', 'gteq', 'lteq', 'diff']
        }
      },
      orderable: ['id', 'category', 'description', 'scheduled_at', 'system', 'title', 'url', 'created_at', 'updated_at', 'team_season.id', 'team_season.calendar_embed_url', 'team_season.calendar_ics_url', 'team_season.stats', 'team_season.status', 'team_season.created_at', 'team_season.updated_at', 'team_season.season.id', 'team_season.season.name', 'team_season.season.starts_on', 'team_season.season.created_at', 'team_season.season.updated_at', 'team_season.team.id', 'team_season.team.name', 'team_season.team.created_at', 'team_season.team.updated_at'],
      traversable: true,
      searchable: true,
      pagination: {
        defaultLimit: 20,
        maxLimit: 100
      }
    }
  },
} as const;

// What each installed engine tells the client about itself: the owners it
// is built around, and the features a host has turned on. Configuration
// rather than schema, but the same generated file, because a value the
// client reads at boot should not need a request to answer.
export const modules = {
  rhino: {
    version: '0.30.0.alpha.39',
    authOwner: 'user',
    baseOwner: 'organization',
    oauth: [{
      name: 'google_oauth2',
      path: '/api/auth/omniauth/google_oauth2'
    }],
    allow_signup: true,
    allow_org_creation: false,
    api_keys_enabled: true,
    api_key_max_expiry_days: 365,
    notifications_enabled: false,
    invite_for: 1209600,
    stripe_enabled: false,
    require_active_subscription: false
  }
} as const;

export interface GeneratedModels {
  account: {
    attributes: {
      readonly id: number;
      name: string | null;
      nickname: string | null;
      email: string;
      readonly image: string | null;
      readonly display_name: string | null;
    };
    read: RhinoRecordBase & GeneratedModels['account']['attributes'] & {
      readonly users_roles: (GeneratedModels['users_role']['attributes'] & {
        organization: GeneratedModels['organization']['attributes'];
        role: GeneratedModels['role']['attributes'];
      })[];
    };
    create: {
      name?: string | null;
      nickname?: string | null;
      email: string;
    };
    update: {
      name?: string | null;
      nickname?: string | null;
    };
    meta: (typeof models)['account']['meta'];
    querySurface: (typeof models)['account']['querySurface'];
  };
  active_storage_attachment: {
    attributes: {
      readonly id: number;
      name: string;
      previews: unknown | null;
      record_type: string;
      representations: unknown | null;
      url: unknown | null;
      url_attachment: unknown | null;
      variants: unknown | null;
      readonly created_at: string;
      readonly signed_id: unknown | null;
      readonly display_name: string | null;
    };
    read: RhinoRecordBase & GeneratedModels['active_storage_attachment']['attributes'];
    create: {
      name: string;
      previews?: unknown | null;
      record_type: string;
      representations?: unknown | null;
      url?: unknown | null;
      url_attachment?: (string | { signed_id: string }) | null;
      variants?: unknown | null;
    };
    update: {
      name?: string;
      previews?: unknown | null;
      record_type?: string;
      representations?: unknown | null;
      url?: unknown | null;
      url_attachment?: (string | { signed_id: string }) | null;
      variants?: unknown | null;
    };
    meta: (typeof models)['active_storage_attachment']['meta'];
    querySurface: (typeof models)['active_storage_attachment']['querySurface'];
  };
  contact: {
    attributes: {
      readonly id: number;
      email: string | null;
      name: string | null;
      note: string | null;
      phone: string | null;
      player_contact: boolean;
      primary: boolean;
      relationship: string;
      readonly created_at: string;
      readonly updated_at: string;
      readonly display_name: string | null;
    };
    read: RhinoRecordBase & GeneratedModels['contact']['attributes'] & {
      player: GeneratedModels['player']['attributes'];
    };
    create: {
      email?: string | null;
      name?: string | null;
      note?: string | null;
      phone?: string | null;
      player_contact?: boolean;
      primary?: boolean;
      relationship: string;
      player: RhinoIdentifier | { id: RhinoIdentifier };
    };
    update: {
      email?: string | null;
      name?: string | null;
      note?: string | null;
      phone?: string | null;
      player_contact?: boolean;
      primary?: boolean;
      relationship?: string;
      player?: RhinoIdentifier | { id: RhinoIdentifier };
    };
    meta: (typeof models)['contact']['meta'];
    querySurface: (typeof models)['contact']['querySurface'];
  };
  event: {
    attributes: {
      readonly id: number;
      action_link: string | null;
      action_name: string | null;
      description: string | null;
      key: string;
      metadata: unknown | null;
      name: string;
      summary: string;
      readonly created_at: string;
      readonly updated_at: string;
      readonly display_name: string | null;
    };
    read: RhinoRecordBase & GeneratedModels['event']['attributes'] & {
      initiator: GeneratedModels['user']['attributes'];
      player: GeneratedModels['player']['attributes'];
    };
    create: {
      action_link?: string | null;
      action_name?: string | null;
      description?: string | null;
      key: string;
      metadata?: unknown | null;
      name: string;
      summary: string;
      initiator: RhinoIdentifier | { id: RhinoIdentifier };
      player: RhinoIdentifier | { id: RhinoIdentifier };
    };
    update: {
      action_link?: string | null;
      action_name?: string | null;
      description?: string | null;
      key?: string;
      metadata?: unknown | null;
      name?: string;
      summary?: string;
      initiator?: RhinoIdentifier | { id: RhinoIdentifier };
      player?: RhinoIdentifier | { id: RhinoIdentifier };
    };
    meta: (typeof models)['event']['meta'];
    querySurface: (typeof models)['event']['querySurface'];
  };
  external_game: {
    attributes: {
      readonly id: number;
      date_time: string | null;
      location_type: 'unknown' | 'home' | 'away' | 'neutral';
      readonly created_at: string;
      readonly updated_at: string;
      readonly display_name: string | null;
    };
    read: RhinoRecordBase & GeneratedModels['external_game']['attributes'] & {
      external_team_season: GeneratedModels['external_team_season']['attributes'];
    };
    create: {
      date_time?: string | null;
      location_type: 'unknown' | 'home' | 'away' | 'neutral';
      external_team_season: RhinoIdentifier | { id: RhinoIdentifier };
    };
    update: {
      date_time?: string | null;
      location_type?: 'unknown' | 'home' | 'away' | 'neutral';
      external_team_season?: RhinoIdentifier | { id: RhinoIdentifier };
    };
    meta: (typeof models)['external_game']['meta'];
    querySurface: (typeof models)['external_game']['querySurface'];
  };
  external_league: {
    attributes: {
      readonly id: number;
      ancestry: string | null;
      description: string | null;
      import_key: string | null;
      name: string | null;
      readonly created_at: string;
      readonly updated_at: string;
      readonly display_name: string | null;
    };
    read: RhinoRecordBase & GeneratedModels['external_league']['attributes'] & {
      sport: GeneratedModels['sport']['attributes'];
    };
    create: {
      ancestry?: string | null;
      description?: string | null;
      import_key?: string | null;
      name?: string | null;
      sport: RhinoIdentifier | { id: RhinoIdentifier };
    };
    update: {
      ancestry?: string | null;
      description?: string | null;
      import_key?: string | null;
      name?: string | null;
      sport?: RhinoIdentifier | { id: RhinoIdentifier };
    };
    meta: (typeof models)['external_league']['meta'];
    querySurface: (typeof models)['external_league']['querySurface'];
  };
  external_linked_team: {
    attributes: {
      readonly id: number;
      team_name: string | null;
      readonly created_at: string;
      readonly updated_at: string;
      readonly display_name: string | null;
    };
    read: RhinoRecordBase & GeneratedModels['external_linked_team']['attributes'] & {
      external_team_season: GeneratedModels['external_team_season']['attributes'] & {
        season: GeneratedModels['season']['attributes'];
      } | null;
      external_team: GeneratedModels['external_team']['attributes'] | null;
      season: GeneratedModels['season']['attributes'] | null;
      player: GeneratedModels['player']['attributes'];
    };
    create: {
      team_name?: string | null;
      external_team_season?: (RhinoIdentifier | { id: RhinoIdentifier }) | null;
      external_team?: (RhinoIdentifier | { id: RhinoIdentifier }) | null;
      season?: (RhinoIdentifier | { id: RhinoIdentifier }) | null;
      player: RhinoIdentifier | { id: RhinoIdentifier };
    };
    update: {
      team_name?: string | null;
      external_team_season?: (RhinoIdentifier | { id: RhinoIdentifier }) | null;
      external_team?: (RhinoIdentifier | { id: RhinoIdentifier }) | null;
      season?: (RhinoIdentifier | { id: RhinoIdentifier }) | null;
      player?: RhinoIdentifier | { id: RhinoIdentifier };
    };
    meta: (typeof models)['external_linked_team']['meta'];
    querySurface: (typeof models)['external_linked_team']['querySurface'];
  };
  external_player: {
    attributes: {
      readonly id: number;
      commitment: string | null;
      country: string | null;
      dob_year: number | null;
      first_name: string;
      grad_year: number | null;
      hand: ('L' | 'R') | null;
      height_feet: number | null;
      height_inches: string | null;
      hometown: string | null;
      import_key: string | null;
      last_name: string;
      number: string | null;
      weight_lbs: number | null;
      readonly created_at: string;
      readonly updated_at: string;
      readonly display_name: string | null;
    };
    read: RhinoRecordBase & GeneratedModels['external_player']['attributes'] & {
      readonly external_rosters: (GeneratedModels['external_roster']['attributes'] & {
        external_team_season: GeneratedModels['external_team_season']['attributes'] & {
          external_team: GeneratedModels['external_team']['attributes'];
          season: GeneratedModels['season']['attributes'];
        };
      })[];
      position: GeneratedModels['position']['attributes'] | null;
    };
    create: {
      commitment?: string | null;
      country?: string | null;
      dob_year?: number | null;
      first_name: string;
      grad_year?: number | null;
      hand?: ('L' | 'R') | null;
      height_feet?: number | null;
      height_inches?: string | null;
      hometown?: string | null;
      import_key?: string | null;
      last_name: string;
      number?: string | null;
      weight_lbs?: number | null;
      position?: (RhinoIdentifier | { id: RhinoIdentifier }) | null;
    };
    update: {
      commitment?: string | null;
      country?: string | null;
      dob_year?: number | null;
      first_name?: string;
      grad_year?: number | null;
      hand?: ('L' | 'R') | null;
      height_feet?: number | null;
      height_inches?: string | null;
      hometown?: string | null;
      import_key?: string | null;
      last_name?: string;
      number?: string | null;
      weight_lbs?: number | null;
      position?: (RhinoIdentifier | { id: RhinoIdentifier }) | null;
    };
    meta: (typeof models)['external_player']['meta'];
    querySurface: (typeof models)['external_player']['querySurface'];
  };
  external_roster: {
    attributes: {
      readonly id: number;
      readonly created_at: string;
      readonly updated_at: string;
      readonly display_name: string | null;
    };
    read: RhinoRecordBase & GeneratedModels['external_roster']['attributes'] & {
      external_team_season: GeneratedModels['external_team_season']['attributes'];
      external_player: GeneratedModels['external_player']['attributes'];
    };
    create: {
      external_team_season: RhinoIdentifier | { id: RhinoIdentifier };
      external_player: RhinoIdentifier | { id: RhinoIdentifier };
    };
    update: {
      external_team_season?: RhinoIdentifier | { id: RhinoIdentifier };
      external_player?: RhinoIdentifier | { id: RhinoIdentifier };
    };
    meta: (typeof models)['external_roster']['meta'];
    querySurface: (typeof models)['external_roster']['querySurface'];
  };
  external_team: {
    attributes: {
      readonly id: number;
      import_key: string | null;
      name: string | null;
      readonly created_at: string;
      readonly updated_at: string;
      readonly display_name: string | null;
    };
    read: RhinoRecordBase & GeneratedModels['external_team']['attributes'] & {
      readonly external_team_seasons: (GeneratedModels['external_team_season']['attributes'] & {
        season: GeneratedModels['season']['attributes'];
      })[];
    };
    create: {
      import_key?: string | null;
      name?: string | null;
    };
    update: {
      import_key?: string | null;
      name?: string | null;
    };
    meta: (typeof models)['external_team']['meta'];
    querySurface: (typeof models)['external_team']['querySurface'];
  };
  external_team_season: {
    attributes: {
      readonly id: number;
      readonly created_at: string;
      readonly updated_at: string;
      readonly display_name: string | null;
    };
    read: RhinoRecordBase & GeneratedModels['external_team_season']['attributes'] & {
      external_league: GeneratedModels['external_league']['attributes'] | null;
      external_team: GeneratedModels['external_team']['attributes'];
      season: GeneratedModels['season']['attributes'];
    };
    create: {
      external_league?: (RhinoIdentifier | { id: RhinoIdentifier }) | null;
      external_team: RhinoIdentifier | { id: RhinoIdentifier };
      season: RhinoIdentifier | { id: RhinoIdentifier };
    };
    update: {
      external_league?: (RhinoIdentifier | { id: RhinoIdentifier }) | null;
      external_team?: RhinoIdentifier | { id: RhinoIdentifier };
      season?: RhinoIdentifier | { id: RhinoIdentifier };
    };
    meta: (typeof models)['external_team_season']['meta'];
    querySurface: (typeof models)['external_team_season']['querySurface'];
  };
  lineup: {
    attributes: {
      readonly id: number;
      event_at: string | null;
      kind: 'event' | 'depth_chart';
      name: string;
      readonly created_at: string;
      readonly updated_at: string;
      readonly display_name: string | null;
    };
    read: RhinoRecordBase & GeneratedModels['lineup']['attributes'] & {
      team_season: GeneratedModels['team_season']['attributes'];
      readonly lineup_spots: (GeneratedModels['lineup_spot']['attributes'] & {
        roster: GeneratedModels['roster']['attributes'] & {
          player: GeneratedModels['player']['attributes'];
          roster_status: GeneratedModels['roster_status']['attributes'];
        };
        lineup_type_group: GeneratedModels['lineup_type_group']['attributes'] & {
          position: GeneratedModels['position']['attributes'];
        } & {
          readonly children: (GeneratedModels['lineup_type_group']['attributes'] & {
            lineup_type: GeneratedModels['lineup_type']['attributes'];
            position: GeneratedModels['position']['attributes'];
          })[];
        };
      })[];
      lineup_type: GeneratedModels['lineup_type']['attributes'] & {
        readonly lineup_type_groups: (GeneratedModels['lineup_type_group']['attributes'] & {
          position: GeneratedModels['position']['attributes'];
        } & {
          readonly children: (GeneratedModels['lineup_type_group']['attributes'] & {
            lineup_type: GeneratedModels['lineup_type']['attributes'];
            position: GeneratedModels['position']['attributes'];
          })[];
        })[];
      };
    };
    create: {
      event_at?: string | null;
      kind?: 'event' | 'depth_chart';
      name: string;
      team_season: RhinoIdentifier | { id: RhinoIdentifier };
      lineup_type: RhinoIdentifier | { id: RhinoIdentifier };
    };
    update: {
      event_at?: string | null;
      kind?: 'event' | 'depth_chart';
      name?: string;
      team_season?: RhinoIdentifier | { id: RhinoIdentifier };
      lineup_type?: RhinoIdentifier | { id: RhinoIdentifier };
    };
    meta: (typeof models)['lineup']['meta'];
    querySurface: (typeof models)['lineup']['querySurface'];
  };
  lineup_spot: {
    attributes: {
      readonly id: number;
      group_index: string;
      readonly created_at: string;
      readonly updated_at: string;
      readonly display_name: string | null;
    };
    read: RhinoRecordBase & GeneratedModels['lineup_spot']['attributes'] & {
      lineup: GeneratedModels['lineup']['attributes'];
      lineup_type_group: GeneratedModels['lineup_type_group']['attributes'] & {
        readonly children: (GeneratedModels['lineup_type_group']['attributes'] & {
          lineup_type: GeneratedModels['lineup_type']['attributes'];
          position: GeneratedModels['position']['attributes'];
        })[];
      };
      roster: GeneratedModels['roster']['attributes'];
    };
    create: {
      group_index: string;
      lineup: RhinoIdentifier | { id: RhinoIdentifier };
      lineup_type_group: RhinoIdentifier | { id: RhinoIdentifier };
      roster: RhinoIdentifier | { id: RhinoIdentifier };
    };
    update: {
      group_index?: string;
      lineup?: RhinoIdentifier | { id: RhinoIdentifier };
      lineup_type_group?: RhinoIdentifier | { id: RhinoIdentifier };
      roster?: RhinoIdentifier | { id: RhinoIdentifier };
    };
    meta: (typeof models)['lineup_spot']['meta'];
    querySurface: (typeof models)['lineup_spot']['querySurface'];
  };
  lineup_type: {
    attributes: {
      readonly id: number;
      name: string;
      readonly created_at: string;
      readonly updated_at: string;
      readonly display_name: string | null;
    };
    read: RhinoRecordBase & GeneratedModels['lineup_type']['attributes'] & {
      readonly lineup_type_groups: (GeneratedModels['lineup_type_group']['attributes'] & {
        readonly children: (GeneratedModels['lineup_type_group']['attributes'] & {
          lineup_type: GeneratedModels['lineup_type']['attributes'];
          position: GeneratedModels['position']['attributes'];
        })[];
      })[];
      sport: GeneratedModels['sport']['attributes'];
    };
    create: {
      name: string;
      sport: RhinoIdentifier | { id: RhinoIdentifier };
    };
    update: {
      name?: string;
      sport?: RhinoIdentifier | { id: RhinoIdentifier };
    };
    meta: (typeof models)['lineup_type']['meta'];
    querySurface: (typeof models)['lineup_type']['querySurface'];
  };
  lineup_type_group: {
    attributes: {
      readonly id: number;
      ancestry: string | null;
      default_count: number;
      name: string | null;
      order: number;
      readonly created_at: string;
      readonly updated_at: string;
      readonly display_name: string | null;
    };
    read: RhinoRecordBase & GeneratedModels['lineup_type_group']['attributes'] & {
      lineup_type: GeneratedModels['lineup_type']['attributes'];
      position: GeneratedModels['position']['attributes'];
    } & {
      readonly children: (GeneratedModels['lineup_type_group']['attributes'] & {
        lineup_type: GeneratedModels['lineup_type']['attributes'];
        position: GeneratedModels['position']['attributes'];
      })[];
    };
    create: {
      ancestry?: string | null;
      default_count?: number;
      name?: string | null;
      order: number;
      lineup_type: RhinoIdentifier | { id: RhinoIdentifier };
      position: RhinoIdentifier | { id: RhinoIdentifier };
    };
    update: {
      ancestry?: string | null;
      default_count?: number;
      name?: string | null;
      order?: number;
      lineup_type?: RhinoIdentifier | { id: RhinoIdentifier };
      position?: RhinoIdentifier | { id: RhinoIdentifier };
    };
    meta: (typeof models)['lineup_type_group']['meta'];
    querySurface: (typeof models)['lineup_type_group']['querySurface'];
  };
  message: {
    attributes: {
      readonly id: number;
      body: string;
      delivery_id: string | null;
      delivery_status: 'not_sent' | 'queued' | 'delivered' | 'error';
      group_id: string | null;
      message_direction: 'inbound' | 'outbound';
      message_type: 'sms' | 'email';
      summary: string | null;
      readonly created_at: string;
      readonly updated_at: string;
      readonly display_name: string | null;
    };
    read: RhinoRecordBase & GeneratedModels['message']['attributes'] & {
      player: GeneratedModels['player']['attributes'] & {
        current_roster: GeneratedModels['roster']['attributes'] & {
          roster_status: GeneratedModels['roster_status']['attributes'];
          team_season: GeneratedModels['team_season']['attributes'] & {
            season: GeneratedModels['season']['attributes'];
          };
        } | null;
      };
      from: GeneratedModels['user']['attributes'];
      recipients: GeneratedModels['recipient']['attributes'][];
      readonly contacts: GeneratedModels['contact']['attributes'][];
    };
    create: {
      body: string;
      delivery_id?: string | null;
      delivery_status?: 'not_sent' | 'queued' | 'delivered' | 'error';
      group_id?: string | null;
      message_direction?: 'inbound' | 'outbound';
      message_type: 'sms' | 'email';
      summary?: string | null;
      player: RhinoIdentifier | { id: RhinoIdentifier };
      from: RhinoIdentifier | { id: RhinoIdentifier };
      recipients?: GeneratedModels['recipient']['create'][] | null;
    };
    update: {
      body?: string;
      delivery_id?: string | null;
      delivery_status?: 'not_sent' | 'queued' | 'delivered' | 'error';
      group_id?: string | null;
      message_direction?: 'inbound' | 'outbound';
      message_type?: 'sms' | 'email';
      summary?: string | null;
      player?: RhinoIdentifier | { id: RhinoIdentifier };
      from?: RhinoIdentifier | { id: RhinoIdentifier };
      recipients?: GeneratedModels['recipient']['create'][] | null;
    };
    meta: (typeof models)['message']['meta'];
    querySurface: (typeof models)['message']['querySurface'];
  };
  note: {
    attributes: {
      readonly id: number;
      discarded_at: string | null;
      note: string | null;
      readonly created_at: string;
      readonly updated_at: string;
      readonly display_name: string | null;
    };
    read: RhinoRecordBase & GeneratedModels['note']['attributes'] & {
      player: GeneratedModels['player']['attributes'];
      readonly reporter: GeneratedModels['user']['attributes'];
    };
    create: {
      discarded_at?: string | null;
      note?: string | null;
      player: RhinoIdentifier | { id: RhinoIdentifier };
    };
    update: {
      discarded_at?: string | null;
      note?: string | null;
      player?: RhinoIdentifier | { id: RhinoIdentifier };
    };
    meta: (typeof models)['note']['meta'];
    querySurface: (typeof models)['note']['querySurface'];
  };
  observation: {
    attributes: {
      readonly id: number;
      readonly complete: boolean;
      game_note: string | null;
      observed_at: string | null;
      observing: ('exhibition' | 'regular_season' | 'playoff' | 'tournament' | 'practice' | 'tryout' | 'video' | 'other') | null;
      report: unknown | null;
      venue: string | null;
      readonly created_at: string;
      readonly updated_at: string;
      readonly display_name: string | null;
    };
    read: RhinoRecordBase & GeneratedModels['observation']['attributes'] & {
      organization: GeneratedModels['organization']['attributes'];
      observer: GeneratedModels['user']['attributes'];
    };
    create: {
      game_note?: string | null;
      observed_at?: string | null;
      observing?: ('exhibition' | 'regular_season' | 'playoff' | 'tournament' | 'practice' | 'tryout' | 'video' | 'other') | null;
      report?: unknown | null;
      venue?: string | null;
      organization: RhinoIdentifier | { id: RhinoIdentifier };
      observer: RhinoIdentifier | { id: RhinoIdentifier };
    };
    update: {
      game_note?: string | null;
      observed_at?: string | null;
      observing?: ('exhibition' | 'regular_season' | 'playoff' | 'tournament' | 'practice' | 'tryout' | 'video' | 'other') | null;
      report?: unknown | null;
      venue?: string | null;
      organization?: RhinoIdentifier | { id: RhinoIdentifier };
      observer?: RhinoIdentifier | { id: RhinoIdentifier };
    };
    meta: (typeof models)['observation']['meta'];
    querySurface: (typeof models)['observation']['querySurface'];
  };
  organization: {
    attributes: {
      readonly id: number;
      readonly features: string[] | null;
      name: string;
      readonly created_at: string;
      readonly updated_at: string;
      readonly display_name: string | null;
    };
    read: RhinoRecordBase & GeneratedModels['organization']['attributes'] & {
      logo_attachment: GeneratedModels['active_storage_attachment']['attributes'] | null;
      readonly sport: GeneratedModels['sport']['attributes'];
      readonly teams: (GeneratedModels['team']['attributes'] & {
        team_seasons: (GeneratedModels['team_season']['attributes'] & {
          season: GeneratedModels['season']['attributes'];
        })[];
      })[];
      readonly users_roles: (GeneratedModels['users_role']['attributes'] & {
        role: GeneratedModels['role']['attributes'];
      })[];
    };
    create: {
      name: string;
      logo_attachment?: (string | { signed_id: string }) | null;
    };
    update: {
      name?: string;
      logo_attachment?: (string | { signed_id: string }) | null;
    };
    meta: (typeof models)['organization']['meta'];
    querySurface: (typeof models)['organization']['querySurface'];
  };
  player: {
    attributes: {
      readonly id: number;
      country: string | null;
      dob_year: number | null;
      first_name: string | null;
      grad_year: number | null;
      hand: ('L' | 'R') | null;
      height_feet: number | null;
      height_inches: string | null;
      hometown: string | null;
      last_name: string;
      number: string | null;
      readonly quick_rating: number | null;
      weight_lbs: number | null;
      readonly created_at: string;
      readonly updated_at: string;
      readonly display_name: string | null;
    };
    read: RhinoRecordBase & GeneratedModels['player']['attributes'] & {
      organization: GeneratedModels['organization']['attributes'];
      player_positions: (GeneratedModels['player_position']['attributes'] & {
        position: GeneratedModels['position']['attributes'];
      })[];
      readonly positions: GeneratedModels['position']['attributes'][];
      rosters: (GeneratedModels['roster']['attributes'] & {
        roster_status: GeneratedModels['roster_status']['attributes'];
        team_season: GeneratedModels['team_season']['attributes'];
      })[];
      current_roster: GeneratedModels['roster']['attributes'] & {
        roster_status: GeneratedModels['roster_status']['attributes'];
        team_season: GeneratedModels['team_season']['attributes'] & {
          season: GeneratedModels['season']['attributes'];
        };
      } | null;
      external_linked_teams: GeneratedModels['external_linked_team']['attributes'][];
    };
    create: {
      country?: string | null;
      dob_year?: number | null;
      first_name?: string | null;
      grad_year?: number | null;
      hand?: ('L' | 'R') | null;
      height_feet?: number | null;
      height_inches?: string | null;
      hometown?: string | null;
      last_name: string;
      number?: string | null;
      weight_lbs?: number | null;
      organization: RhinoIdentifier | { id: RhinoIdentifier };
      player_positions?: GeneratedModels['player_position']['create'][] | null;
      rosters?: GeneratedModels['roster']['create'][] | null;
      current_roster?: (RhinoIdentifier | { id: RhinoIdentifier }) | null;
      external_linked_teams?: GeneratedModels['external_linked_team']['create'][] | null;
    };
    update: {
      country?: string | null;
      dob_year?: number | null;
      first_name?: string | null;
      grad_year?: number | null;
      hand?: ('L' | 'R') | null;
      height_feet?: number | null;
      height_inches?: string | null;
      hometown?: string | null;
      last_name?: string;
      number?: string | null;
      weight_lbs?: number | null;
      organization?: RhinoIdentifier | { id: RhinoIdentifier };
      player_positions?: GeneratedModels['player_position']['create'][] | null;
      rosters?: GeneratedModels['roster']['create'][] | null;
      current_roster?: (RhinoIdentifier | { id: RhinoIdentifier }) | null;
      external_linked_teams?: GeneratedModels['external_linked_team']['create'][] | null;
    };
    meta: (typeof models)['player']['meta'];
    querySurface: (typeof models)['player']['querySurface'];
  };
  player_position: {
    attributes: {
      readonly id: number;
      readonly created_at: string;
      readonly updated_at: string;
      readonly display_name: string | null;
    };
    read: RhinoRecordBase & GeneratedModels['player_position']['attributes'] & {
      player: GeneratedModels['player']['attributes'];
      position: GeneratedModels['position']['attributes'];
    };
    create: {
      player: RhinoIdentifier | { id: RhinoIdentifier };
      position: RhinoIdentifier | { id: RhinoIdentifier };
    };
    update: {
      player?: RhinoIdentifier | { id: RhinoIdentifier };
      position?: RhinoIdentifier | { id: RhinoIdentifier };
    };
    meta: (typeof models)['player_position']['meta'];
    querySurface: (typeof models)['player_position']['querySurface'];
  };
  position: {
    attributes: {
      readonly id: number;
      abbreviation: string | null;
      ancestry: string | null;
      name: string | null;
      readonly created_at: string;
      readonly updated_at: string;
      readonly display_name: string | null;
    };
    read: RhinoRecordBase & GeneratedModels['position']['attributes'] & {
      sport: GeneratedModels['sport']['attributes'];
    };
    create: {
      abbreviation?: string | null;
      ancestry?: string | null;
      name?: string | null;
      sport: RhinoIdentifier | { id: RhinoIdentifier };
    };
    update: {
      abbreviation?: string | null;
      ancestry?: string | null;
      name?: string | null;
      sport?: RhinoIdentifier | { id: RhinoIdentifier };
    };
    meta: (typeof models)['position']['meta'];
    querySurface: (typeof models)['position']['querySurface'];
  };
  practice_plan: {
    attributes: {
      readonly id: number;
      description: string | null;
      plan_date: string;
      title: string;
      readonly created_at: string;
      readonly updated_at: string;
      readonly display_name: string | null;
    };
    read: RhinoRecordBase & GeneratedModels['practice_plan']['attributes'] & {
      pdf_attachment: GeneratedModels['active_storage_attachment']['attributes'] | null;
      team_season: GeneratedModels['team_season']['attributes'] & {
        team: GeneratedModels['team']['attributes'] & {
          organization: GeneratedModels['organization']['attributes'];
        };
      };
    };
    create: {
      description?: string | null;
      plan_date: string;
      title: string;
      pdf_attachment?: (string | { signed_id: string }) | null;
      team_season: RhinoIdentifier | { id: RhinoIdentifier };
    };
    update: {
      description?: string | null;
      plan_date?: string;
      title?: string;
      pdf_attachment?: (string | { signed_id: string }) | null;
      team_season?: RhinoIdentifier | { id: RhinoIdentifier };
    };
    meta: (typeof models)['practice_plan']['meta'];
    querySurface: (typeof models)['practice_plan']['querySurface'];
  };
  recipient: {
    attributes: {
      readonly id: number;
      readonly created_at: string;
      readonly updated_at: string;
      readonly display_name: string | null;
    };
    read: RhinoRecordBase & GeneratedModels['recipient']['attributes'] & {
      contact: GeneratedModels['contact']['attributes'];
      message: GeneratedModels['message']['attributes'];
    };
    create: {
      contact: RhinoIdentifier | { id: RhinoIdentifier };
      message: RhinoIdentifier | { id: RhinoIdentifier };
    };
    update: {
      contact?: RhinoIdentifier | { id: RhinoIdentifier };
      message?: RhinoIdentifier | { id: RhinoIdentifier };
    };
    meta: (typeof models)['recipient']['meta'];
    querySurface: (typeof models)['recipient']['querySurface'];
  };
  report: {
    attributes: {
      readonly id: number;
      observing: 'exhibition' | 'regular_season' | 'playoff' | 'tournament' | 'practice' | 'tryout' | 'video' | 'other';
      report_status: number | null;
      reported_at: string;
      venue: string | null;
      readonly created_at: string;
      readonly updated_at: string;
      readonly display_name: string | null;
    };
    read: RhinoRecordBase & GeneratedModels['report']['attributes'] & {
      report_type: GeneratedModels['report_type']['attributes'];
      player: GeneratedModels['player']['attributes'] & {
        current_roster: GeneratedModels['roster']['attributes'] & {
          roster_status: GeneratedModels['roster_status']['attributes'];
          team_season: GeneratedModels['team_season']['attributes'] & {
            season: GeneratedModels['season']['attributes'];
          };
        } | null;
      };
      reporter: GeneratedModels['user']['attributes'];
      report_values: (GeneratedModels['report_value']['attributes'] & {
        report_field: GeneratedModels['report_field']['attributes'];
      })[];
      readonly report_fields: GeneratedModels['report_field']['attributes'][];
    };
    create: {
      observing: 'exhibition' | 'regular_season' | 'playoff' | 'tournament' | 'practice' | 'tryout' | 'video' | 'other';
      report_status?: number | null;
      reported_at: string;
      venue?: string | null;
      report_type: RhinoIdentifier | { id: RhinoIdentifier };
      player: RhinoIdentifier | { id: RhinoIdentifier };
      reporter: RhinoIdentifier | { id: RhinoIdentifier };
      report_values?: GeneratedModels['report_value']['create'][] | null;
    };
    update: {
      observing?: 'exhibition' | 'regular_season' | 'playoff' | 'tournament' | 'practice' | 'tryout' | 'video' | 'other';
      report_status?: number | null;
      reported_at?: string;
      venue?: string | null;
      report_type?: RhinoIdentifier | { id: RhinoIdentifier };
      player?: RhinoIdentifier | { id: RhinoIdentifier };
      reporter?: RhinoIdentifier | { id: RhinoIdentifier };
      report_values?: GeneratedModels['report_value']['create'][] | null;
    };
    meta: (typeof models)['report']['meta'];
    querySurface: (typeof models)['report']['querySurface'];
  };
  report_field: {
    attributes: {
      readonly id: number;
      field_type: 'text' | 'rating';
      name: string | null;
      order: number;
      required: boolean;
      readonly created_at: string;
      readonly updated_at: string;
      readonly display_name: string | null;
    };
    read: RhinoRecordBase & GeneratedModels['report_field']['attributes'] & {
      report_type: GeneratedModels['report_type']['attributes'];
    };
    create: {
      field_type: 'text' | 'rating';
      name?: string | null;
      order: number;
      required?: boolean;
      report_type: RhinoIdentifier | { id: RhinoIdentifier };
    };
    update: {
      field_type?: 'text' | 'rating';
      name?: string | null;
      order?: number;
      required?: boolean;
      report_type?: RhinoIdentifier | { id: RhinoIdentifier };
    };
    meta: (typeof models)['report_field']['meta'];
    querySurface: (typeof models)['report_field']['querySurface'];
  };
  report_type: {
    attributes: {
      readonly id: number;
      name: string | null;
      readonly created_at: string;
      readonly updated_at: string;
      readonly display_name: string | null;
    };
    read: RhinoRecordBase & GeneratedModels['report_type']['attributes'] & {
      readonly report_fields: GeneratedModels['report_field']['attributes'][];
      sport: GeneratedModels['sport']['attributes'];
    };
    create: {
      name?: string | null;
      sport: RhinoIdentifier | { id: RhinoIdentifier };
    };
    update: {
      name?: string | null;
      sport?: RhinoIdentifier | { id: RhinoIdentifier };
    };
    meta: (typeof models)['report_type']['meta'];
    querySurface: (typeof models)['report_type']['querySurface'];
  };
  report_value: {
    attributes: {
      readonly id: number;
      value: string | null;
      readonly created_at: string;
      readonly updated_at: string;
      readonly display_name: string | null;
    };
    read: RhinoRecordBase & GeneratedModels['report_value']['attributes'] & {
      report: GeneratedModels['report']['attributes'];
      report_field: GeneratedModels['report_field']['attributes'];
    };
    create: {
      value?: string | null;
      report: RhinoIdentifier | { id: RhinoIdentifier };
      report_field: RhinoIdentifier | { id: RhinoIdentifier };
    };
    update: {
      value?: string | null;
      report?: RhinoIdentifier | { id: RhinoIdentifier };
      report_field?: RhinoIdentifier | { id: RhinoIdentifier };
    };
    meta: (typeof models)['report_value']['meta'];
    querySurface: (typeof models)['report_value']['querySurface'];
  };
  rhino_notification: {
    attributes: {
      readonly id: number;
      readonly key: string;
      readonly message: string;
      readonly url: string | null;
      opened_at: string | null;
      readonly created_at: string;
      readonly display_name: string | null;
    };
    read: RhinoRecordBase & GeneratedModels['rhino_notification']['attributes'];
    create: {
      opened_at?: string | null;
    };
    update: {
      opened_at?: string | null;
    };
    meta: (typeof models)['rhino_notification']['meta'];
    querySurface: (typeof models)['rhino_notification']['querySurface'];
  };
  rhino_package: {
    attributes: {
      readonly id: number;
      readonly slug: string;
      readonly name: string;
      readonly kind: 'standard' | 'base' | 'addon';
      readonly features: string[] | null;
      readonly display_name: string | null;
    };
    read: RhinoRecordBase & GeneratedModels['rhino_package']['attributes'];
    create: Record<string, never>;
    update: Record<string, never>;
    meta: (typeof models)['rhino_package']['meta'];
    querySurface: (typeof models)['rhino_package']['querySurface'];
  };
  rhino_subscription: {
    attributes: {
      readonly id: number;
      readonly status: string | null;
      readonly current_period_end: string | null;
      readonly display_name: string | null;
    };
    read: RhinoRecordBase & GeneratedModels['rhino_subscription']['attributes'] & {
      readonly base_owner: GeneratedModels['organization']['attributes'];
      readonly subscription_items: (GeneratedModels['rhino_subscription_item']['attributes'] & {
        readonly package: GeneratedModels['rhino_package']['attributes'];
      })[];
    };
    create: Record<string, never>;
    update: Record<string, never>;
    meta: (typeof models)['rhino_subscription']['meta'];
    querySurface: (typeof models)['rhino_subscription']['querySurface'];
  };
  rhino_subscription_item: {
    attributes: {
      readonly id: number;
      readonly expires_at: string | null;
      readonly display_name: string | null;
    };
    read: RhinoRecordBase & GeneratedModels['rhino_subscription_item']['attributes'] & {
      readonly subscription: GeneratedModels['rhino_subscription']['attributes'];
      readonly package: GeneratedModels['rhino_package']['attributes'];
    };
    create: Record<string, never>;
    update: Record<string, never>;
    meta: (typeof models)['rhino_subscription_item']['meta'];
    querySurface: (typeof models)['rhino_subscription_item']['querySurface'];
  };
  role: {
    attributes: {
      readonly id: number;
      name: string;
      readonly created_at: string;
      readonly updated_at: string;
      readonly display_name: string | null;
    };
    read: RhinoRecordBase & GeneratedModels['role']['attributes'];
    create: {
      name: string;
    };
    update: {
      name?: string;
    };
    meta: (typeof models)['role']['meta'];
    querySurface: (typeof models)['role']['querySurface'];
  };
  roster: {
    attributes: {
      readonly id: number;
      number: string | null;
      readonly quick_rating: number | null;
      rank: number | null;
      readonly created_at: string;
      readonly updated_at: string;
      readonly display_name: string | null;
    };
    read: RhinoRecordBase & GeneratedModels['roster']['attributes'] & {
      player: GeneratedModels['player']['attributes'] & {
        external_linked_teams: GeneratedModels['external_linked_team']['attributes'][];
        readonly positions: GeneratedModels['position']['attributes'][];
        player_positions: (GeneratedModels['player_position']['attributes'] & {
          position: GeneratedModels['position']['attributes'];
        })[];
      };
      team_season: GeneratedModels['team_season']['attributes'];
      roster_status: GeneratedModels['roster_status']['attributes'];
    };
    create: {
      number?: string | null;
      rank?: number | null;
      player: RhinoIdentifier | { id: RhinoIdentifier };
      team_season: RhinoIdentifier | { id: RhinoIdentifier };
      roster_status: RhinoIdentifier | { id: RhinoIdentifier };
    };
    update: {
      number?: string | null;
      rank?: number | null;
      player?: RhinoIdentifier | { id: RhinoIdentifier };
      team_season?: RhinoIdentifier | { id: RhinoIdentifier };
      roster_status?: RhinoIdentifier | { id: RhinoIdentifier };
    };
    meta: (typeof models)['roster']['meta'];
    querySurface: (typeof models)['roster']['querySurface'];
  };
  roster_status: {
    attributes: {
      readonly id: number;
      name: string;
      order: number;
      status_type: 'planning' | 'active' | 'archived';
      readonly created_at: string;
      readonly updated_at: string;
      readonly display_name: string | null;
    };
    read: RhinoRecordBase & GeneratedModels['roster_status']['attributes'] & {
      organization: GeneratedModels['organization']['attributes'];
    };
    create: {
      name: string;
      order: number;
      status_type: 'planning' | 'active' | 'archived';
      organization: RhinoIdentifier | { id: RhinoIdentifier };
    };
    update: {
      name?: string;
      order?: number;
      status_type?: 'planning' | 'active' | 'archived';
      organization?: RhinoIdentifier | { id: RhinoIdentifier };
    };
    meta: (typeof models)['roster_status']['meta'];
    querySurface: (typeof models)['roster_status']['querySurface'];
  };
  season: {
    attributes: {
      readonly id: number;
      name: string | null;
      starts_on: string;
      readonly created_at: string;
      readonly updated_at: string;
      readonly display_name: string | null;
    };
    read: RhinoRecordBase & GeneratedModels['season']['attributes'] & {
      sport: GeneratedModels['sport']['attributes'];
    };
    create: {
      name?: string | null;
      starts_on: string;
      sport: RhinoIdentifier | { id: RhinoIdentifier };
    };
    update: {
      name?: string | null;
      starts_on?: string;
      sport?: RhinoIdentifier | { id: RhinoIdentifier };
    };
    meta: (typeof models)['season']['meta'];
    querySurface: (typeof models)['season']['querySurface'];
  };
  sport: {
    attributes: {
      readonly id: number;
      name: string | null;
      readonly created_at: string;
      readonly updated_at: string;
      readonly display_name: string | null;
    };
    read: RhinoRecordBase & GeneratedModels['sport']['attributes'];
    create: {
      name?: string | null;
    };
    update: {
      name?: string | null;
    };
    meta: (typeof models)['sport']['meta'];
    querySurface: (typeof models)['sport']['querySurface'];
  };
  team: {
    attributes: {
      readonly id: number;
      name: string;
      readonly created_at: string;
      readonly updated_at: string;
      readonly display_name: string | null;
    };
    read: RhinoRecordBase & GeneratedModels['team']['attributes'] & {
      organization: GeneratedModels['organization']['attributes'];
      team_seasons: GeneratedModels['team_season']['attributes'][];
    };
    create: {
      name: string;
      organization: RhinoIdentifier | { id: RhinoIdentifier };
      team_seasons?: GeneratedModels['team_season']['create'][] | null;
    };
    update: {
      name?: string;
      organization?: RhinoIdentifier | { id: RhinoIdentifier };
      team_seasons?: GeneratedModels['team_season']['create'][] | null;
    };
    meta: (typeof models)['team']['meta'];
    querySurface: (typeof models)['team']['querySurface'];
  };
  team_season: {
    attributes: {
      readonly id: number;
      calendar_embed_url: string | null;
      calendar_ics_url: string | null;
      rating_avg: number | null;
      roster_accepted: number | null;
      start_with: string | null;
      start_with_file: string | null;
      stats: unknown;
      status: 'planning' | 'active' | 'archived';
      readonly created_at: string;
      readonly updated_at: string;
      readonly display_name: string | null;
    };
    read: RhinoRecordBase & GeneratedModels['team_season']['attributes'] & {
      season: GeneratedModels['season']['attributes'];
      team: GeneratedModels['team']['attributes'] & {
        organization: GeneratedModels['organization']['attributes'];
      };
    };
    create: {
      calendar_embed_url?: string | null;
      calendar_ics_url?: string | null;
      rating_avg?: number | null;
      roster_accepted?: number | null;
      start_with?: string | null;
      start_with_file?: string | null;
      stats?: unknown;
      status?: 'planning' | 'active' | 'archived';
      season: RhinoIdentifier | { id: RhinoIdentifier };
      team: RhinoIdentifier | { id: RhinoIdentifier };
    };
    update: {
      calendar_embed_url?: string | null;
      calendar_ics_url?: string | null;
      rating_avg?: number | null;
      roster_accepted?: number | null;
      stats?: unknown;
      status?: 'planning' | 'active' | 'archived';
      season?: RhinoIdentifier | { id: RhinoIdentifier };
      team?: RhinoIdentifier | { id: RhinoIdentifier };
    };
    meta: (typeof models)['team_season']['meta'];
    querySurface: (typeof models)['team_season']['querySurface'];
  };
  user: {
    attributes: {
      readonly id: number;
      name: string | null;
      nickname: string | null;
      email: string;
      readonly image: string | null;
      readonly display_name: string | null;
    };
    read: RhinoRecordBase & GeneratedModels['user']['attributes'] & {
      readonly users_roles: (GeneratedModels['users_role']['attributes'] & {
        organization: GeneratedModels['organization']['attributes'] & {
          logo_attachment: GeneratedModels['active_storage_attachment']['attributes'] | null;
        };
        role: GeneratedModels['role']['attributes'];
      })[];
    };
    create: {
      name?: string | null;
      nickname?: string | null;
      email: string;
    };
    update: {
      name?: string | null;
      nickname?: string | null;
    };
    meta: (typeof models)['user']['meta'];
    querySurface: (typeof models)['user']['querySurface'];
  };
  users_role: {
    attributes: {
      readonly id: number;
      readonly created_at: string;
      readonly updated_at: string;
      readonly display_name: string | null;
    };
    read: RhinoRecordBase & GeneratedModels['users_role']['attributes'] & {
      user: GeneratedModels['user']['attributes'];
      role: GeneratedModels['role']['attributes'];
      organization: GeneratedModels['organization']['attributes'];
    };
    create: {
      user: RhinoIdentifier | { id: RhinoIdentifier };
      role: RhinoIdentifier | { id: RhinoIdentifier };
      organization: RhinoIdentifier | { id: RhinoIdentifier };
    };
    update: {
      role?: RhinoIdentifier | { id: RhinoIdentifier };
    };
    meta: (typeof models)['users_role']['meta'];
    querySurface: (typeof models)['users_role']['querySurface'];
  };
  users_role_invite: {
    attributes: {
      readonly id: number;
      email: string;
      readonly created_at: string;
      readonly updated_at: string;
      readonly display_name: string | null;
    };
    read: RhinoRecordBase & GeneratedModels['users_role_invite']['attributes'] & {
      role: GeneratedModels['role']['attributes'];
      organization: GeneratedModels['organization']['attributes'];
    };
    create: {
      email: string;
      role: RhinoIdentifier | { id: RhinoIdentifier };
      organization: RhinoIdentifier | { id: RhinoIdentifier };
    };
    update: {
      email?: string;
      role?: RhinoIdentifier | { id: RhinoIdentifier };
      organization?: RhinoIdentifier | { id: RhinoIdentifier };
    };
    meta: (typeof models)['users_role_invite']['meta'];
    querySurface: (typeof models)['users_role_invite']['querySurface'];
  };
  video: {
    attributes: {
      readonly id: number;
      category: 'time_based' | 'system';
      description: string | null;
      scheduled_at: string | null;
      system: ('forecheck' | 'backcheck' | 'breakout' | 'neutral_zone_offense' | 'neutral_zone_defense' | 'offensive_zone' | 'defensive_zone' | 'power_play' | 'penalty_kill' | 'faceoff' | 'transition' | 'goaltending' | 'skill') | null;
      title: string;
      url: string;
      readonly created_at: string;
      readonly updated_at: string;
      readonly display_name: string | null;
    };
    read: RhinoRecordBase & GeneratedModels['video']['attributes'] & {
      team_season: GeneratedModels['team_season']['attributes'] & {
        team: GeneratedModels['team']['attributes'] & {
          organization: GeneratedModels['organization']['attributes'];
        };
      };
    };
    create: {
      title: string;
      url: string;
      description?: string | null;
      category: 'time_based' | 'system';
      scheduled_at?: string | null;
      system?: ('forecheck' | 'backcheck' | 'breakout' | 'neutral_zone_offense' | 'neutral_zone_defense' | 'offensive_zone' | 'defensive_zone' | 'power_play' | 'penalty_kill' | 'faceoff' | 'transition' | 'goaltending' | 'skill') | null;
      team_season: RhinoIdentifier | { id: RhinoIdentifier };
    };
    update: {
      title?: string;
      url?: string;
      description?: string | null;
      category?: 'time_based' | 'system';
      scheduled_at?: string | null;
      system?: ('forecheck' | 'backcheck' | 'breakout' | 'neutral_zone_offense' | 'neutral_zone_defense' | 'offensive_zone' | 'defensive_zone' | 'power_play' | 'penalty_kill' | 'faceoff' | 'transition' | 'goaltending' | 'skill') | null;
      team_season?: RhinoIdentifier | { id: RhinoIdentifier };
    };
    meta: (typeof models)['video']['meta'];
    querySurface: (typeof models)['video']['querySurface'];
  };
}
